
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kfU2R", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteIntegration", () => $145d1b0a2223da5d$export$eb6ccee20cc51d7b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $hmD0N = parcelRequire("hmD0N");

var $b5pc0 = parcelRequire("b5pc0");

var $h2Vnd = parcelRequire("h2Vnd");

var $d8lE2 = parcelRequire("d8lE2");

var $bbRjE = parcelRequire("bbRjE");

var $9fuVs = parcelRequire("9fuVs");

var $jcw0u = parcelRequire("jcw0u");

var $8niRf = parcelRequire("8niRf");

var $koVbs = parcelRequire("koVbs");


var $ezMlR = parcelRequire("ezMlR");

var $3oeAD = parcelRequire("3oeAD");

var $ht5ui = parcelRequire("ht5ui");

var $6ixD4 = parcelRequire("6ixD4");

var $kqiyM = parcelRequire("kqiyM");

var $30J2m = parcelRequire("30J2m");

var $faBOu = parcelRequire("faBOu");

var $ad6ff = parcelRequire("ad6ff");

var $79Tnk = parcelRequire("79Tnk");
const $145d1b0a2223da5d$export$eb6ccee20cc51d7b = (props)=>{
    // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
    (0, $gKZoD.di)((0, $9fuVs.default));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isOpen: isOpen }] = (0, $d8lE2.useCommandPaletteIsOpen)();
    const { quickSearchCommand: quickSearchCommand } = (0, $b5pc0.useQuickSearchCommand)({
        keepSearch: true
    });
    (0, $h2Vnd.useCommandPaletteRegistry)();
    const onErrorAnalytics = (0, $5uXOq.useCallback)((attribution, error, id, attributes)=>{
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: `jira.commandPalette.${id}`,
                packageName: 'jiraCommandPaletteIntegration',
                teamName: attribution || 'deliveroo'
            },
            attributes: attributes
        });
    }, []);
    (0, $kqiyM.useRegisterSections)();
    (0, $6ixD4.useRegisterDismissCommand)();
    (0, $ezMlR.useCloseDotMenu)();
    (0, $ht5ui.useDisableCompalIfEmbed)();
    (0, $faBOu.useRegisterInitialCommands)();
    (0, $3oeAD.useCompalBridge)();
    const Wrapper = isOpen ? (0, $9fuVs.default) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $896c010256263437$export$70d2130cb02f61fa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbRjE.CommandPaletteModal), {
        defaultFooterContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $30J2m.FooterFeedbackContent), null),
        onAnalytics: (0, $hmD0N.handleAnalytics),
        onErrorAnalytics: onErrorAnalytics,
        defaultAriaLabel: formatMessage((0, $ad6ff.messages).defaultSearchInputAriaLabel),
        defaultPlaceholder: formatMessage((0, $ad6ff.messages).defaultPlaceholder),
        defaultFallback: {
            onError: {
                label: formatMessage((0, $ad6ff.messages).onErrorFallback)
            },
            onNoResults: {
                label: formatMessage((0, $ad6ff.messages).noResultsFound)
            }
        },
        rootFallback: {
            label: formatMessage((0, $ad6ff.messages).noResultsFound),
            fallbackCommand: quickSearchCommand,
            fallbackSection: {
                name: formatMessage((0, $ad6ff.messages).recommendedSection)
            }
        },
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79Tnk.RegisterDynamicCommands), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8niRf.ForgeCommandPaletteCommandsWithFF), null));
};

});
parcelRegister("hmD0N", function(module, exports) {

$parcel$export(module.exports, "handleAnalytics", () => $50c4f480d056336d$export$51232d58b72ca41a);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
const $50c4f480d056336d$var$packageName = 'jiraCommandPaletteIntegration';
const $50c4f480d056336d$export$51232d58b72ca41a = (event, eventType, args)=>{
    const eventFunctions = {
        [(0, $4d5e0871c06cee03$export$a1562d08625f5d7e)]: (0, $8zOmE.fireUIAnalytics),
        [(0, $4d5e0871c06cee03$export$947dac6c72b26f81)]: (0, $8zOmE.fireTrackAnalytics),
        [(0, $4d5e0871c06cee03$export$12346a674644c156)]: (0, $8zOmE.fireOperationalAnalytics)
    };
    if (args?.actionSubject && args?.action || event.payload.actionSubject && event.payload.action) {
        const eventActionAndSubject = args?.actionSubject && args?.action ? `${args?.actionSubject} ${args?.action}` : `${event.payload.actionSubject} ${event.payload.action}`;
        if (args?.actionSubjectId) {
            eventFunctions[eventType]?.(event, eventActionAndSubject, args?.actionSubjectId, args?.attributes ? args?.attributes : {});
            return;
        }
        if (!args?.actionSubjectId) eventFunctions[eventType]?.(event, eventActionAndSubject, args?.attributes ? args?.attributes : {});
    } else (0, $jcw0u.default)({
        error: new Error('Action or ActionSubject not provided'),
        meta: {
            id: 'jira.commandPalette.analytics',
            packageName: $50c4f480d056336d$var$packageName,
            teamName: 'deliveroo'
        }
    });
};

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("b5pc0", function(module, exports) {

$parcel$export(module.exports, "useQuickSearchCommand", () => $d2e45573835e5a07$export$e5359a76eb8e8480);

var $5uXOq = parcelRequire("5uXOq");

var $26g7Y = parcelRequire("26g7Y");

var $5p1kJ = parcelRequire("5p1kJ");

var $jh7L9 = parcelRequire("jh7L9");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $7kfUM = parcelRequire("7kfUM");

var $gXRsr = parcelRequire("gXRsr");

var $huARL = parcelRequire("huARL");

var $cy1Ju = parcelRequire("cy1Ju");
const $d2e45573835e5a07$export$e5359a76eb8e8480 = (props)=>{
    const keepSearch = props?.keepSearch;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $gXRsr.useFireQuickSearchAnalyticsOnClose)();
    const quickSearchCommand = (0, $5uXOq.useMemo)(()=>({
            id: (0, $cb5e5e9a3c6fee1b$export$2c1eb650fb9787f),
            name: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7kfUM.messages).searchCommandNameIssueTermRefresh : (0, $7kfUM.messages).searchCommandName),
            placeholder: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7kfUM.messages).searchInputPlaceHolderIssueTermRefresh : (0, $7kfUM.messages).searchInputPlaceHolder),
            keywords: formatMessage((0, $7kfUM.messages).searchYourIssuesSynonyms),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
                        spacing: "spacious",
                        label: ""
                    })
            },
            mode: '/',
            section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickSearch,
            priority: 1,
            analytics: {
                action: 'quickSearchMode',
                actionCategory: 'quick-search'
            },
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).COMMAND_LIST,
                components: {
                    Body: (0, $huARL.QuickSearchChildren),
                    Wrapper: (0, $cy1Ju.QuickSearchChildWrapper)
                },
                keepSearch: keepSearch
            }
        }), [
        formatMessage,
        keepSearch
    ]);
    return {
        quickSearchCommand: quickSearchCommand
    };
};

});
const $cb5e5e9a3c6fee1b$export$2c1eb650fb9787f = 'quick-search';

parcelRegister("7kfUM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $702b76be031743e3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $702b76be031743e3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    searchCommandName: {
        "id": "command-palette-quick-search.use-quick-search-command.search-command-name",
        "defaultMessage": "Search issues, projects, and more"
    },
    searchInputPlaceHolder: {
        "id": "command-palette-quick-search.use-quick-search-command.search-input-place-holder",
        "defaultMessage": "Search for issues, projects, boards, filters and plans"
    },
    searchYourIssuesSynonyms: {
        "id": "command-palette-quick-search.use-quick-search-command.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    searchCommandNameIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.search-command-name-issue-term-refresh",
        "defaultMessage": "Search work items, projects, and more"
    },
    searchInputPlaceHolderIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.search-input-place-holder-issue-term-refresh",
        "defaultMessage": "Search for work items, projects, boards, filters, and plans"
    }
});

});

parcelRegister("gXRsr", function(module, exports) {

$parcel$export(module.exports, "useFireQuickSearchAnalyticsOnClose", () => $97a054a159b04e0e$export$5bb3a88a6bd57afb);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gjt52 = parcelRequire("gjt52");
const $97a054a159b04e0e$export$5bb3a88a6bd57afb = ()=>{
    const [{ isOpen: isOpen }] = (0, $d8lE2.useCommandPaletteIsOpen)();
    const previousIsOpen = (0, $1XJ20.usePrevious)(isOpen);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ hasModalWrapperMounted: hasModalWrapperMounted }] = (0, $gjt52.useQuickSearchAnalytics)();
    // Need to get the previousAttributes since they will change after closing compal
    const [attributes] = (0, $d8lE2.useCommandPaletteAnalyticsAttributes)();
    const previousAttributes = (0, $1XJ20.usePrevious)(attributes);
    const [compalAttributes] = (0, $gjt52.useQuickSearchAnalyticsAttributes)();
    const previousCompalAttributes = (0, $1XJ20.usePrevious)(compalAttributes);
    (0, $5uXOq.useEffect)(()=>{
        if (hasModalWrapperMounted && previousIsOpen && !isOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'close commandPaletteSearch', {
            ...previousCompalAttributes,
            ...previousAttributes
        });
    }, [
        createAnalyticsEvent,
        isOpen,
        previousIsOpen,
        hasModalWrapperMounted,
        previousCompalAttributes,
        previousAttributes
    ]);
};

});
parcelRegister("gjt52", function(module, exports) {

$parcel$export(module.exports, "useQuickSearchAnalytics", () => $9ee2833827559dc4$export$4717a2168cba99f2);
$parcel$export(module.exports, "useQuickSearchAnalyticsAttributes", () => $9ee2833827559dc4$export$c5622799de43dc3a);

var $7Jxgt = parcelRequire("7Jxgt");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $c2I39 = parcelRequire("c2I39");
const $9ee2833827559dc4$var$initialState = {
    queryVersion: -1,
    query: '',
    searchSessionId: (0, $7Jxgt.v4)(),
    hasModalWrapperMounted: false,
    screenName: undefined,
    isCachedResult: false
};
const $9ee2833827559dc4$var$actions = {
    setQuery: (query)=>({ setState: setState, getState: getState })=>{
            setState({
                queryVersion: getState().queryVersion + 1,
                query: query
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                ...$9ee2833827559dc4$var$initialState,
                searchSessionId: (0, $7Jxgt.v4)()
            });
        },
    setHasModalWrapperMounted: (hasModalWrapperMounted)=>({ setState: setState })=>{
            setState({
                hasModalWrapperMounted: hasModalWrapperMounted
            });
        },
    setScreenName: (screenName)=>({ setState: setState })=>{
            setState({
                screenName: screenName
            });
        },
    setIsCachedResult: (isCachedResult)=>({ setState: setState })=>{
            setState({
                isCachedResult: isCachedResult
            });
        }
};
const $9ee2833827559dc4$var$store = (0, $iXqE5.createStore)({
    initialState: $9ee2833827559dc4$var$initialState,
    actions: $9ee2833827559dc4$var$actions,
    name: 'quickSearchAnalytics'
});
const $9ee2833827559dc4$export$4717a2168cba99f2 = (0, $3sQ5x.createHook)($9ee2833827559dc4$var$store);
const $9ee2833827559dc4$export$770c0b647b46c688 = (0, $3sQ5x.createActionsHook)($9ee2833827559dc4$var$store);
const $9ee2833827559dc4$export$c5622799de43dc3a = (0, $3sQ5x.createHook)($9ee2833827559dc4$var$store, {
    selector: ({ query: query, queryVersion: queryVersion, searchSessionId: searchSessionId, screenName: screenName, isCachedResult: isCachedResult })=>({
            wordCount: (0, $c2I39.getWordCount)(query),
            queryLength: query.length,
            queryHash: (0, $c2I39.getQueryHash)(query),
            queryVersion: queryVersion,
            searchSessionId: searchSessionId,
            activeProduct: 'jira',
            isMultiProduct: false,
            screenName: screenName,
            isCachedResult: isCachedResult
        })
});

});
parcelRegister("c2I39", function(module, exports) {

$parcel$export(module.exports, "getQueryHash", () => $890efcd2fb211377$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $890efcd2fb211377$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "transformResultsForAnalytics", () => $890efcd2fb211377$export$902530edac79328);

var $bdDiz = parcelRequire("bdDiz");
const $890efcd2fb211377$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
const $890efcd2fb211377$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $890efcd2fb211377$export$902530edac79328 = (data, isRecentResult)=>{
    const results = data?.scopes?.map((scope)=>({
            sectionId: scope.id,
            results: scope.results.map((result)=>({
                    containerId: result?.attributes && 'containerId' in result?.attributes ? result?.attributes?.containerId || 'UNAVAILABLE' : 'UNAVAILABLE',
                    isRecentResult: isRecentResult,
                    resultContentId: result.id,
                    resultType: scope.id
                }))
        }));
    const resultCount = data?.scopes?.reduce((acc, scope)=>acc + scope.size, 0);
    return {
        results: results,
        sectionCount: data?.scopes?.length || 0,
        resultCount: resultCount,
        noResultsFetched: !results?.find((scope)=>scope.results.length > 0)
    };
};

});



parcelRegister("huARL", function(module, exports) {

$parcel$export(module.exports, "QuickSearchChildren", () => $ffa7e6b797c341b7$export$a68383740408995a);

var $5uXOq = parcelRequire("5uXOq");

var $jiSaf = parcelRequire("jiSaf");

var $6Xy8w = parcelRequire("6Xy8w");

var $gjt52 = parcelRequire("gjt52");

var $1qxNN = parcelRequire("1qxNN");

var $b3BGu = parcelRequire("b3BGu");

var $5mZMv = parcelRequire("5mZMv");
const $ffa7e6b797c341b7$export$4630ed09821f1a78 = ()=>{
    const { fetch: fetch } = (0, $1qxNN.useQuickSearchWithRecentCache)();
    const getRecentResults = (0, $b3BGu.useGetRecentResults)();
    const getSearchResults = (0, $5mZMv.useGetSearchResults)();
    const [{ searchSessionId: searchSessionId }, { setQuery: setQuery, setIsCachedResult: setIsCachedResult, setScreenName: setScreenName }] = (0, $gjt52.useQuickSearchAnalytics)();
    const controllerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>()=>controllerRef.current?.abort(), []);
    const isMountedRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const loadChildren = (0, $5uXOq.useCallback)(async ({ search: search })=>{
        controllerRef.current?.abort();
        controllerRef.current = new AbortController();
        let response;
        let error;
        try {
            setQuery(search);
            response = await fetch(search, searchSessionId, controllerRef.current?.signal);
        } catch (e) {
            error = e instanceof Error ? e : new Error('Error not identified');
        }
        setIsCachedResult(response?.isCache || false);
        if (search && search.length > 0) {
            setScreenName('postQuerySearchResults');
            return {
                ...getSearchResults({
                    search: search,
                    quickSearchResponseData: response?.result,
                    error: error
                })
            };
        }
        setScreenName('preQuerySearchResults');
        return {
            ...getRecentResults({
                search: search,
                quickSearchResponseData: response?.result,
                error: error
            })
        };
    }, [
        setIsCachedResult,
        setScreenName,
        getRecentResults,
        setQuery,
        fetch,
        searchSessionId,
        getSearchResults
    ]);
    return {
        loadChildren: loadChildren
    };
};
const $ffa7e6b797c341b7$export$a68383740408995a = ({ setChildResult: setChildResult, setLoading: setLoading, ...rest })=>{
    const { loadChildren: loadChildren } = $ffa7e6b797c341b7$export$4630ed09821f1a78();
    const loadChildCommands = (0, $5uXOq.useCallback)((searchTerm, obj)=>loadChildren({
            search: searchTerm
        }).then((result)=>{
            if (!obj.isMounted) return;
            setChildResult?.(result);
        }), [
        loadChildren,
        setChildResult
    ]);
    (0, $6Xy8w.useDebouncedLoadChildren)(loadChildCommands);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiSaf.components).Body, {
        setChildResult: setChildResult,
        setLoading: setLoading,
        ...rest
    });
};

});
parcelRegister("jiSaf", function(module, exports) {

$parcel$export(module.exports, "components", () => $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296);

var $5uXOq = parcelRequire("5uXOq");

var $dOktC = parcelRequire("dOktC");

var $haBRL = parcelRequire("haBRL");

var $dE25F = parcelRequire("dE25F");

var $d4iCz = parcelRequire("d4iCz");
const $44cb4d9bf5d8b8a6$var$NameComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296 = {
    CommandRow: $haBRL.CommandRow,
    Name: $44cb4d9bf5d8b8a6$var$NameComponent,
    LeftIcon: (0, $5uXOq.Fragment),
    Wrapper: (0, $5uXOq.Fragment),
    Footer: $dE25F.Footer,
    Body: (0, $dOktC.CommandPaletteBody),
    Header: $d4iCz.Header
};

});
parcelRegister("dOktC", function(module, exports) {

$parcel$export(module.exports, "NoResultsContainer", () => $2bc4c9970ded9a96$export$2ab569a6937cb4e4);
$parcel$export(module.exports, "CommandPaletteBody", () => $2bc4c9970ded9a96$export$b1023de69a8756e6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $2NMNM = parcelRequire("2NMNM");

var $d8lE2 = parcelRequire("d8lE2");

var $gM5ou = parcelRequire("gM5ou");

var $bYCTm = parcelRequire("bYCTm");

var $38IFv = parcelRequire("38IFv");

var $cLshs = parcelRequire("cLshs");

var $4nfzy = parcelRequire("4nfzy");

var $eKTyH = parcelRequire("eKTyH");

var $5aF2z = parcelRequire("5aF2z");

var $64ZBB = parcelRequire("64ZBB");
const $2bc4c9970ded9a96$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, $d8lE2.useCommandPalette)();
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onMouseDownCommand = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onClickCommand = (0, $5uXOq.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $gM5ou.getAnalyticsAttributesFromResult)(result),
                ...(0, $gM5ou.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $gM5ou.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const localResultRefs = resultsRefs.current;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$export$2ab569a6937cb4e4, {
        "data-testid": (0, $5aF2z.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYCTm.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) // eslint-disable-next-line react-hooks/react-compiler
                localResultRefs[index] = commandRef;
            },
            group: result.group,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$GroupContainerComponent, {
            as: "h2",
            "data-testid": (0, $5aF2z.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4nfzy.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $gM5ou.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38IFv.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKTyH.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
const $2bc4c9970ded9a96$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, $d8lE2.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $5uXOq.useState)(activeIndex);
    const resultsRefs = (0, $5uXOq.useRef)([]);
    const modalBodyRef = (0, $5uXOq.useRef)(null);
    const onArrowScroll = (0, $5uXOq.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $5aF2z.SCROLL_DIRECTION).END : (0, $5aF2z.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $64ZBB.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $64ZBB.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $64ZBB.scrollResultIntoView)({
                target: scrolledToResult,
                direction: scrollTo,
                scrollContainer: modalBodyRef.current
            });
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $5uXOq.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cLshs.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        noResultsFallback: noResultsFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$CommandPaletteChildren, {
        results: results,
        noResultsFallback: noResultsFallback,
        renderAfterCommands: renderAfterCommands,
        resultsRefs: resultsRefs
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bc4c9970ded9a96$var$GroupContainerComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $lD23V.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1yt41f6d _syaz131l",
            __cmplp.className
        ])
    });
});
const $2bc4c9970ded9a96$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _syaz131l _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bYCTm", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $85a6ab23a77e1ea6$export$591c26128e5fd757);

var $5uXOq = parcelRequire("5uXOq");

const $85a6ab23a77e1ea6$export$591c26128e5fd757 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
        id: group ? `${0, $2350562822a34d03$export$9ed1834ff36a8f29}-${group}` : undefined,
        ...rest
    }));

});
const $2350562822a34d03$export$9ffb4923f81813d9 = 'compal-menu';
const $2350562822a34d03$export$b28d6b416aaf953a = `${$2350562822a34d03$export$9ffb4923f81813d9}-item`;
const $2350562822a34d03$export$9ed1834ff36a8f29 = `${$2350562822a34d03$export$9ffb4923f81813d9}-group`;
const $2350562822a34d03$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $2350562822a34d03$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $2350562822a34d03$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $2350562822a34d03$export$9e40a0642460a944 = 'compal-menu-screen-reader';


parcelRegister("38IFv", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $9082b0edc4f10018$export$1f8fa9d1eef77b32);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");


var $9gNeg = parcelRequire("9gNeg");
const $9082b0edc4f10018$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ id: id, active: active, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
        "aria-current": active,
        role: "menuitem",
        id: `${(0, $2350562822a34d03$export$b28d6b416aaf953a)}-${id}`,
        ...(0, $4R6GH.fg)('a11y_enghealth_fixes_deliveroo') && {
            'aria-label': formatMessage((0, $9gNeg.messages).resultListItemAriaLabel)
        },
        ...rest
    });
});

});
parcelRegister("9gNeg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $37963fcec28f3d0a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $37963fcec28f3d0a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    resultListItemAriaLabel: {
        "id": "command-palette.common.command-palette-search-result-list-item",
        "defaultMessage": "Command palette action item"
    }
});

});


parcelRegister("cLshs", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $42c35fc284860d36$export$95554f6fb39a83c2);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");


var $zfug2 = parcelRequire("zfug2");

var $6LGvc = parcelRequire("6LGvc");
const $42c35fc284860d36$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const resizerRef = (0, $5uXOq.useRef)(null);
    const height = (0, $6LGvc.useSmoothExpand)(resizerRef);
    (0, $5uXOq.useEffect)(()=>{
        if (ref && 'current' in ref && ref.current) {
            const currentRef = ref.current;
            currentRef.style.height = `${height}px`;
        }
    }, [
        height,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $42c35fc284860d36$var$wrapperStyles,
        testId: (0, $2350562822a34d03$export$85eefac753ab5bdb),
        id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
        role: noResultsFallback ? 'group' : 'menu',
        ref: ref,
        "aria-label": formatMessage((0, $zfug2.messages).commandPaletteSearchResultListBoxLabel),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        ref: resizerRef,
        direction: "column",
        gap: "space.050"
    }, children));
});
const $42c35fc284860d36$var$wrapperStyles = (0, $8CUq3.xcss)({
    padding: '0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    transition: 'height 0.15s ease-out',
    overflowY: 'auto',
    maxHeight: '376px'
});

});
parcelRegister("zfug2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2745ea1cb0c1a200$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2745ea1cb0c1a200$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});

parcelRegister("6LGvc", function(module, exports) {

$parcel$export(module.exports, "useSmoothExpand", () => $38452c6bcba6455a$export$674ba8b02d2bfe86);

var $5uXOq = parcelRequire("5uXOq");
const $38452c6bcba6455a$var$MAX_HEIGHT = 376;
const $38452c6bcba6455a$var$STARTING_HEIGHT = 56;
const $38452c6bcba6455a$var$ADDITIONAL_HEIGHT = 16;
const $38452c6bcba6455a$export$674ba8b02d2bfe86 = (content)=>{
    const [height, setHeight] = (0, $5uXOq.useState)($38452c6bcba6455a$var$STARTING_HEIGHT);
    const callback = (0, $5uXOq.useCallback)(()=>{
        const contentClientHeight = content.current?.clientHeight;
        if (!contentClientHeight) return;
        if (contentClientHeight > $38452c6bcba6455a$var$MAX_HEIGHT) setHeight($38452c6bcba6455a$var$MAX_HEIGHT);
        else setHeight(contentClientHeight + $38452c6bcba6455a$var$ADDITIONAL_HEIGHT);
    }, [
        content
    ]);
    (0, $5uXOq.useEffect)(()=>{
        let resizeObserver;
        if (content.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(content.current);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        callback,
        content
    ]);
    return height;
};

});


parcelRegister("4nfzy", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $53a0c321a39d3b85$export$223f3c3c93a14a83);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $53a0c321a39d3b85$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("eKTyH", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $9e51067b4d29f53f$export$3ef5d254c3c573e3);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");

var $haBRL = parcelRequire("haBRL");
const $9e51067b4d29f53f$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $gM5ou.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haBRL.CommandRow), rowProps);
};

});
parcelRegister("haBRL", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $04586313afa284d7$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $dzeHJ = parcelRequire("dzeHJ");


var $3m7XM = parcelRequire("3m7XM");

var $3sBlN = parcelRequire("3sBlN");
const $04586313afa284d7$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $04586313afa284d7$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $593123af132e266c$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InnerContainer, {
        "data-testid": (0, $593123af132e266c$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandIconsContainer, {
        "data-testid": (0, $593123af132e266c$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: (0, $593123af132e266c$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $04586313afa284d7$var$iconStyles,
            isActive && $04586313afa284d7$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconContainer, {
        "data-testid": (0, $593123af132e266c$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzeHJ.OutlinedLozenge), {
        "data-testid": (0, $593123af132e266c$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3m7XM.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sBlN.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04586313afa284d7$var$CommandContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz1gjq _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            !!__cmplp.active && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandContainerInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandIconsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$iconStyles = (0, $8CUq3.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $04586313afa284d7$var$iconActiveStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04586313afa284d7$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syazwdcn" : "_syaz1oju",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dzeHJ", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $0f9445e21ac061f1$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $0f9445e21ac061f1$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $0f9445e21ac061f1$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0f9445e21ac061f1$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _vwz41crf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _19it3ju0 _k48p1pd9 _1p1dangw _bfhk1j9a _syaz131l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _kqswh2mm _1p1dangw _1pbykb7n _1s6krwve _rfx31l7b _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1ris _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});

const $593123af132e266c$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $593123af132e266c$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $593123af132e266c$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $593123af132e266c$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $593123af132e266c$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("3m7XM", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $c1bc24527d77cdc3$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3uzfU = parcelRequire("3uzfU");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $gGkxR = parcelRequire("gGkxR");

const $c1bc24527d77cdc3$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $5uXOq.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGkxR.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandNameContainer, {
        "data-testid": (0, $c5fb72cffbe58dfe$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $c5fb72cffbe58dfe$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            justifyContent: "center",
            xcss: $c1bc24527d77cdc3$var$iconWrapperStyles,
            alignItems: "center",
            testId: (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandChevronContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1bc24527d77cdc3$var$CommandNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_dm2rwo": (0, $lD23V.default)(__cmplp.active ? "var(--ds-text-subtle, #44546F)" : "var(--ds-text-subtlest, #626F86)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !!__cmplp.isParent && "_syazalb7",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandChevronContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4kb7n _syaz1oju",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    height: '24px',
    width: '24px'
});

});
parcelRegister("gGkxR", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $e999625ec19f201d$export$4495aca3d261add0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $k5uoT = parcelRequire("k5uoT");

var $jgJNO = parcelRequire("jgJNO");

var $jgArx = parcelRequire("jgArx");


var $k7xca = parcelRequire("k7xca");
const $e999625ec19f201d$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        messageId: "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.popup",
        messageType: "transactional",
        popupComponent: (0, $jgArx.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $k5uoT.layers).tooltip()
    });
const $e999625ec19f201d$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
const $e999625ec19f201d$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $e999625ec19f201d$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $k7xca.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: containerRef,
        xcss: [
            $e999625ec19f201d$var$tooltipContainerStyles,
            !preventTruncate && $e999625ec19f201d$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e999625ec19f201d$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $e999625ec19f201d$var$tooltipContainerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $e999625ec19f201d$var$truncateTooltipStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("jgArx", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $3c6ba86682bb18eb$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $3c6ba86682bb18eb$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $3c6ba86682bb18eb$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $3c6ba86682bb18eb$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $3c6ba86682bb18eb$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $3c6ba86682bb18eb$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $btzsC = parcelRequire("btzsC");

var $koVbs = parcelRequire("koVbs");

var $6nFD4 = parcelRequire("6nFD4");
const $3c6ba86682bb18eb$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $3c6ba86682bb18eb$export$534fc570264a52a4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $6nFD4.messages).tooltipTriggerAriaLabel)
    });
});
const $3c6ba86682bb18eb$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c6ba86682bb18eb$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $btzsC.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c6ba86682bb18eb$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$8cae238d61c8405a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswh2mm _o5721q9c _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6nFD4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $87d1d47436abe24f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $87d1d47436abe24f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $40fe2afec35c84b7$export$f9e3e7ede9ba929d = 400;

parcelRegister("k7xca", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $ad951546dfa9fa2c$export$94b118b3187f12c);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");
const $ad951546dfa9fa2c$export$22c0312879c61300 = ()=>(0, $5uXOq.useState)(false);
const $ad951546dfa9fa2c$export$1ac6e474a0163418 = ()=>(0, $5uXOq.useState)(false);
const $ad951546dfa9fa2c$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $ad951546dfa9fa2c$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $ad951546dfa9fa2c$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $gM5ou.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $5uXOq.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $c5fb72cffbe58dfe$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $c5fb72cffbe58dfe$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $c5fb72cffbe58dfe$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("3sBlN", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $a83ca30f957fd273$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $14Kfa = parcelRequire("14Kfa");

var $koVbs = parcelRequire("koVbs");

var $gM5ou = parcelRequire("gM5ou");


var $iLhkq = parcelRequire("iLhkq");

var $dSJBv = parcelRequire("dSJBv");

var $kbnU6 = parcelRequire("kbnU6");

var $lHtdH = parcelRequire("lHtdH");
const $a83ca30f957fd273$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const transitionStep = (0, $lHtdH.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $5uXOq.useMemo)(()=>(0, $gM5ou.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$CommandRightChevronContainer, {
        "data-testid": (0, $0296d551a7f83620$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14Kfa))), {
        spacing: "spacious",
        label: formatMessage((0, $iLhkq.messages).rightChevronLabel),
        size: "small"
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$ShortcutContainer, {
        "data-testid": (0, $0296d551a7f83620$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dSJBv.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $a83ca30f957fd273$var$animationFadeIn = null;
const $a83ca30f957fd273$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$RightContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syaz1oju",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$ShortcutContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("14Kfa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4724a1e5dc4e8ab6ea5bb133724929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c8a092ead4633f0$var$_react = $0c8a092ead4633f0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0c8a092ead4633f0$var$_chevronRight = $0c8a092ead4633f0$var$_interopRequireDefault((parcelRequire("bpC55")));

var $0c8a092ead4633f0$var$_chevronRightLarge = $0c8a092ead4633f0$var$_interopRequireDefault((parcelRequire("h1toL")));
function $0c8a092ead4633f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c8a092ead4633f0$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0c8a092ead4633f0$var$_react.default.createElement($0c8a092ead4633f0$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $0c8a092ead4633f0$var$_chevronRightLarge.default
    }, props));
$0c8a092ead4633f0$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $0c8a092ead4633f0$var$_default = module.exports.default = $0c8a092ead4633f0$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("bpC55")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


const $0296d551a7f83620$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $0296d551a7f83620$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';

parcelRegister("iLhkq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bf35cee6e1d1204b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bf35cee6e1d1204b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("dSJBv", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $57e6d30b2626ce39$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $bcTvL = parcelRequire("bcTvL");

var $gM5ou = parcelRequire("gM5ou");


var $esPgL = parcelRequire("esPgL");
const $57e6d30b2626ce39$var$KeyElement = ({ shortcut: shortcut })=>{
    const isLongText = shortcut && shortcut.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $57e6d30b2626ce39$var$styles.shortcutKeyWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297),
        className: (0, $bwpsq.default)([
            $57e6d30b2626ce39$var$styles.lozenge,
            isLongText && $57e6d30b2626ce39$var$styles.longLozenge
        ])
    }, shortcut));
};
const $57e6d30b2626ce39$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutDivider, {
        "data-testid": (0, $5ecbf01f9da59a15$export$e06ad7c09a29974b)
    }, divisor);
const $57e6d30b2626ce39$var$SHIFT_CHAR_MAP = {
    '?': 'shift /',
    '!': 'shift 1',
    '@': 'shift 2',
    '#': 'shift 3',
    $: 'shift 4',
    '%': 'shift 5',
    '^': 'shift 6',
    '&': 'shift 7',
    '*': 'shift 8',
    '(': 'shift 9',
    ')': 'shift 0',
    _: 'shift -',
    '+': 'shift =',
    '{': 'shift [',
    '}': 'shift ]',
    ':': 'shift ;',
    '"': "shift '",
    '<': 'shift ,',
    '>': 'shift .',
    '|': 'shift \\',
    '~': 'shift `'
};
const $57e6d30b2626ce39$var$shiftModifierCheck = (shortcut)=>{
    if (shortcut.length === 1) {
        if (/[A-Z]/.test(shortcut)) return `shift ${shortcut.toLowerCase()}`;
        return $57e6d30b2626ce39$var$SHIFT_CHAR_MAP[shortcut] || shortcut;
    }
    return shortcut;
};
const $57e6d30b2626ce39$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        $57e6d30b2626ce39$var$shiftModifierCheck(shortcut).split(' ').forEach((key, index, array)=>{
            acc.push({
                type: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY,
                key: key
            });
            types.push((0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY);
            if (index < array.length - 1) {
                const separatorType = (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS;
                acc.push({
                    type: separatorType
                });
                types.push(separatorType);
            }
        });
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $57e6d30b2626ce39$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $57e6d30b2626ce39$export$cfaeb054b183bb20 = ()=>(0, $koVbs.default)();
const $57e6d30b2626ce39$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $57e6d30b2626ce39$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $5uXOq.useMemo)(()=>$57e6d30b2626ce39$var$parseShortcut(shortcut, (0, $gM5ou.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $5uXOq.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $esPgL.messages).shortcutThen;
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR) return (0, $esPgL.messages).shortcutOr;
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $esPgL.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $5uXOq.useCallback)((type)=>{
        switch(type){
            case (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $esPgL.messages).divisorThen);
            case (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $esPgL.messages).divisorOr);
            default:
                return formatMessage((0, $esPgL.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutContainer, {
        "data-testid": (0, $5ecbf01f9da59a15$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57e6d30b2626ce39$var$ShortcutDivider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57e6d30b2626ce39$var$ShortcutContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $57e6d30b2626ce39$var$styles = {
    lozenge: "_2rkoglpi _11c81u0j _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3i1tcg _syaz1fxt _1ul91tcg _1bsb1ris _kqswh2mm _1p1d1dk0 _1pbykb7n _1s6krwve _rfx3glpi _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
    longLozenge: "_18zr12x7",
    shortcutKeyWrapper: "_ca0qidpf _u5f31y44 _n3tdidpf _19bv1y44 _1ul91tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
};

});
const $5ecbf01f9da59a15$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $5ecbf01f9da59a15$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $5ecbf01f9da59a15$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("esPgL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f430d579edd6c91$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4f430d579edd6c91$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("kbnU6", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $d865f5b0afeb3acd$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $d865f5b0afeb3acd$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $d865f5b0afeb3acd$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $d865f5b0afeb3acd$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $d865f5b0afeb3acd$export$42d8d7c94c5a11e9 = /*#__PURE__*/ function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    return TRANSITION_STEP;
}({});
const $d865f5b0afeb3acd$export$82cfc253a6c33f59 = 600;
const $d865f5b0afeb3acd$export$e092796a9af3633b = 300;
const $d865f5b0afeb3acd$export$1cad4f611a1c0229 = 350;

});

parcelRegister("lHtdH", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $9c0e762a7fdf0cdc$export$eefd045a02bab4c6);

var $5uXOq = parcelRequire("5uXOq");

var $dWt6p = parcelRequire("dWt6p");

var $jcw0u = parcelRequire("jcw0u");

var $gM5ou = parcelRequire("gM5ou");

var $kbnU6 = parcelRequire("kbnU6");
const $9c0e762a7fdf0cdc$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $5uXOq.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $5uXOq.useState)((0, $kbnU6.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $5uXOq.useRef)(null);
    const isReducedMotion = (0, $dWt6p.useIsReducedMotion)();
    const commandHasChildren = (0, $gM5ou.hasChildren)(command);
    (0, $5uXOq.useEffect)(()=>{
        setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $5uXOq.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $kbnU6.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $5uXOq.useCallback)(()=>{
        switch(transitionStep){
            case (0, $kbnU6.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $kbnU6.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $kbnU6.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $kbnU6.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).FINISHED, (0, $kbnU6.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $kbnU6.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).INITIAL, (0, $kbnU6.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $jcw0u.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});




parcelRegister("5aF2z", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $7ecce3582144481d$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $7ecce3582144481d$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $7ecce3582144481d$export$a6d65a8fb7b912d6);
const $7ecce3582144481d$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $7ecce3582144481d$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $7ecce3582144481d$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $7ecce3582144481d$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $7ecce3582144481d$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $7ecce3582144481d$export$a6d65a8fb7b912d6 = /*#__PURE__*/ function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
    return SCROLL_DIRECTION;
}({});

});

parcelRegister("64ZBB", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $6b9215d3fa38a855$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $6b9215d3fa38a855$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $6b9215d3fa38a855$export$6be8a7238febd54f);

var $gM5ou = parcelRequire("gM5ou");

var $5aF2z = parcelRequire("5aF2z");
const $6b9215d3fa38a855$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $6b9215d3fa38a855$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $5aF2z.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $gM5ou.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $5aF2z.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $gM5ou.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $6b9215d3fa38a855$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
    const targetRect = target.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const gapScroll = 4;
    if (direction === (0, $5aF2z.SCROLL_DIRECTION).END) {
        const commandPosition = targetRect.bottom - containerRect.top;
        const amountToScroll = commandPosition - containerRect.height;
        const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
        scrollContainer.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = containerRect.top - targetRect.top;
        const amountToScroll = scrollContainer.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollContainer.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("dE25F", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $842574a5e4b1a419$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $842574a5e4b1a419$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($842574a5e4b1a419$var$ModalFooter, {
        "data-testid": (0, $8289a08a5c530859$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $842574a5e4b1a419$var$ModalFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _mrkb1kw7 _1o0z1kw7 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
const $8289a08a5c530859$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("d4iCz", function(module, exports) {

$parcel$export(module.exports, "Header", () => $82822f3e363fec07$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

const $82822f3e363fec07$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $82822f3e363fec07$var$headerStyles,
        testId: (0, $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf)
    }, children);
const $82822f3e363fec07$var$headerStyles = (0, $8CUq3.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    borderBottom: `solid 1px ${"var(--ds-border, #091E4224)"}`
});

});
const $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("6Xy8w", function(module, exports) {

$parcel$export(module.exports, "useDebouncedLoadChildren", () => $d4ce5e5db4831205$export$d38ddfbd8b9028f);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $bcTvL = parcelRequire("bcTvL");

var $d8lE2 = parcelRequire("d8lE2");
const $d4ce5e5db4831205$export$d38ddfbd8b9028f = (callback)=>{
    const [{ search: search }, { setLoadingList: setLoadingList }] = (0, $d8lE2.useCommandPaletteSearch)();
    const loadChildCommands = (0, $5uXOq.useCallback)(async (searchTerm, obj)=>{
        await callback(searchTerm, obj);
        if (!obj.isMounted) return;
        setLoadingList(false);
    }, [
        callback,
        setLoadingList
    ]);
    const executeDebouncer = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(loadChildCommands, (0, $bcTvL.COMMAND_PALETTE_DEBOUNCE_DEFAULT)), [
        loadChildCommands
    ]);
    (0, $5uXOq.useEffect)(()=>()=>executeDebouncer?.cancel?.(), [
        executeDebouncer
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const obj = {
            isMounted: true
        };
        setLoadingList(true);
        executeDebouncer(search, obj);
        return ()=>{
            obj.isMounted = false;
        };
    }, [
        search,
        executeDebouncer,
        setLoadingList
    ]);
};

});

parcelRegister("1qxNN", function(module, exports) {

$parcel$export(module.exports, "useQuickSearchWithRecentCache", () => $ebab1b38e2fea9c7$export$7eb3d4d963c0f46c);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lQmpR = parcelRequire("lQmpR");
const $ebab1b38e2fea9c7$export$ca7c3b177540050a = ()=>{
    const recentCacheRef = (0, $5uXOq.useRef)();
    const setRecentCache = (0, $5uXOq.useCallback)((cache)=>{
        recentCacheRef.current = cache;
    }, [
        recentCacheRef
    ]);
    return [
        recentCacheRef,
        setRecentCache
    ];
};
const $ebab1b38e2fea9c7$export$7eb3d4d963c0f46c = ()=>{
    const [{ isOpen: isOpen }] = (0, $d8lE2.useCommandPaletteIsOpen)();
    const [recentCache, setRecentCache] = $ebab1b38e2fea9c7$export$ca7c3b177540050a();
    const { fetch: fetch } = (0, $lQmpR.useQuickSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Reset cache when compal closes
    (0, $5uXOq.useEffect)(()=>{
        if (Boolean(recentCache.current) && !isOpen) setRecentCache(undefined);
    }, [
        isOpen,
        recentCache,
        setRecentCache
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async (searchString, sessionId, signal)=>{
        const start = new Date();
        const apiCall = fetch(searchString, sessionId, signal);
        const result = await apiCall;
        const end = new Date();
        const duration = end.getTime() - start.getTime();
        if (searchString?.length) (0, $8zOmE.fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'searchRequest completed', {
            postQueryRequestDurationMs: duration
        });
        else {
            (0, $8zOmE.fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'recentRequest completed', {
                preQueryRequestDurationMs: duration
            });
            setRecentCache(apiCall);
        }
        return result;
    }, [
        createAnalyticsEvent,
        fetch,
        setRecentCache
    ]);
    const getResponse = (0, $5uXOq.useCallback)(async (searchString, sessionId, signal)=>{
        if (searchString && searchString.length > 0) {
            const result = await fetchData(searchString, sessionId, signal);
            return {
                result: result,
                isCache: false
            };
        }
        if (recentCache.current) // refetch if existing cache is in error state
        try {
            await recentCache.current;
        } catch (err) {
            const apiCall = fetchData(searchString, sessionId, signal);
            return {
                result: await apiCall,
                isCache: false
            };
        }
        else {
            const apiCall = fetchData(searchString, sessionId, signal);
            return {
                result: await apiCall,
                isCache: false
            };
        }
        return {
            result: await recentCache.current,
            isCache: true
        };
    }, [
        recentCache,
        fetchData
    ]);
    return {
        fetch: getResponse
    };
};

});
parcelRegister("lQmpR", function(module, exports) {

$parcel$export(module.exports, "useQuickSearch", () => $ea71281883388db5$export$8ad8ebb2d2ffa47);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $9OXo1 = parcelRequire("9OXo1");

var $dmf5R = parcelRequire("dmf5R");
const $ea71281883388db5$var$EXPERIENCE = 'command-palette-jira-integration';
// limit of results per scope (can only choose 1 limit, so we are using the max limit)
// we are also adding 1 to this so we know if there are more items than the limit (vs there is exactly the limit)
const $ea71281883388db5$var$LIMIT = Math.max((0, $dmf5R.ISSUE_LIMIT), (0, $dmf5R.PROJECT_LIMIT), (0, $dmf5R.BOARD_LIMIT), (0, $dmf5R.FILTER_LIMIT), (0, $dmf5R.PLAN_LIMIT)) + 1;
const $ea71281883388db5$export$8ad8ebb2d2ffa47 = ()=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const fetch = (0, $5uXOq.useCallback)(async (query, sessionId, signal)=>{
        try {
            const data = await (0, $eusud.performPostRequest)('/gateway/api/xpsearch-aggregator/quicksearch/v1', {
                body: JSON.stringify({
                    cloudId: cloudId,
                    scopes: [
                        'jira.issue',
                        'jira.board',
                        'jira.project',
                        'jira.filter',
                        'jira.plan'
                    ],
                    query: query,
                    experience: $ea71281883388db5$var$EXPERIENCE,
                    searchSession: {
                        sessionId: sessionId,
                        referrerId: null
                    },
                    limit: $ea71281883388db5$var$LIMIT
                }),
                signal: signal
            });
            return data;
        } catch (error) {
            (0, $jcw0u.default)({
                error: error instanceof Error ? error : new Error('Error not identified'),
                meta: {
                    id: 'fetchRecentlyViewedIssuesService',
                    packageName: 'jiraCommandPaletteQuickSearch',
                    teamName: 'deliveroo'
                }
            });
            throw error;
        }
    }, [
        cloudId
    ]);
    return {
        fetch: fetch
    };
};

});
parcelRegister("dmf5R", function(module, exports) {

$parcel$export(module.exports, "QUICK_SEARCH_PRIORITY", () => $4f39564697687816$export$ce7c8c2e20fb73ca);
$parcel$export(module.exports, "ISSUE_LIMIT", () => $4f39564697687816$export$dcc4c3a6f9b2e0aa);
$parcel$export(module.exports, "PROJECT_LIMIT", () => $4f39564697687816$export$8000560255015036);
$parcel$export(module.exports, "BOARD_LIMIT", () => $4f39564697687816$export$2987f3ac7bc1c1c3);
$parcel$export(module.exports, "FILTER_LIMIT", () => $4f39564697687816$export$14ceffb568197d5a);
$parcel$export(module.exports, "PLAN_LIMIT", () => $4f39564697687816$export$654fbdaf884d026c);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $4f39564697687816$export$ce7c8c2e20fb73ca = /*#__PURE__*/ function(QUICK_SEARCH_PRIORITY) {
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["ISSUES"] = 0] = "ISSUES";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["PROJECTS"] = 1] = "PROJECTS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["BOARDS"] = 2] = "BOARDS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["FILTERS"] = 3] = "FILTERS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["PLANS"] = 4] = "PLANS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["RECOMMENDED"] = 5] = "RECOMMENDED";
    return QUICK_SEARCH_PRIORITY;
}({});
const $4f39564697687816$export$dcc4c3a6f9b2e0aa = 5;
const $4f39564697687816$export$8000560255015036 = 3;
const $4f39564697687816$export$2987f3ac7bc1c1c3 = 3;
const $4f39564697687816$export$14ceffb568197d5a = 3;
const $4f39564697687816$export$654fbdaf884d026c = 3;

});



parcelRegister("b3BGu", function(module, exports) {

$parcel$export(module.exports, "useGetRecentResults", () => $9775be8c5f520569$export$232194057b4317a2);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");

var $h9iZl = parcelRequire("h9iZl");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $JKfGz = parcelRequire("JKfGz");

var $5zDBm = parcelRequire("5zDBm");

var $hX4Eo = parcelRequire("hX4Eo");

var $c2I39 = parcelRequire("c2I39");

var $bsL38 = parcelRequire("bsL38");

var $33VxI = parcelRequire("33VxI");

var $5OaBm = parcelRequire("5OaBm");

var $3eTqY = parcelRequire("3eTqY");

var $2ZZwV = parcelRequire("2ZZwV");
const $9775be8c5f520569$export$232194057b4317a2 = ()=>{
    const { getChildResult: getRecentBoardsChildResult } = (0, $bsL38.useGetRecentBoardsChildResult)();
    const { getChildResult: getRecentIssuesChildResult } = (0, $5OaBm.useGetRecentIssuesChildResult)();
    const { getChildResult: getRecentProjectsChildResult } = (0, $2ZZwV.useGetRecentProjectsChildResult)();
    const { getChildResult: getRecentFiltersChildResult } = (0, $33VxI.useGetRecentFiltersChildResult)();
    const { getChildResult: getRecentPlansChildResult } = (0, $3eTqY.useGetRecentPlansChildResult)();
    const { getChildResult: getErrorChildResult } = (0, $JKfGz.useGetErrorChildResult)();
    const { getChildResult: getRecommendedChildResult } = (0, $5zDBm.useGetRecommendedChildResult)();
    const [hasEditOrViewPermissions] = (0, $h9iZl.useNavigationViewPlansPermission)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $hX4Eo.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    const getRecentResults = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        setTimeoutFunc(()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'searchResults shown', 'preQuerySearchResults', {
                ...(0, $c2I39.transformResultsForAnalytics)(quickSearchResponseData, true)
            });
        }, 0);
        return (0, $gM5ou.mergeChildResults)([
            getErrorChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecommendedChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentIssuesChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentProjectsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentBoardsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentFiltersChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            ...hasEditOrViewPermissions ? [
                getRecentPlansChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                })
            ] : []
        ]);
    }, [
        createAnalyticsEvent,
        getErrorChildResult,
        getRecommendedChildResult,
        getRecentIssuesChildResult,
        getRecentProjectsChildResult,
        getRecentBoardsChildResult,
        getRecentFiltersChildResult,
        hasEditOrViewPermissions,
        getRecentPlansChildResult,
        setTimeoutFunc
    ]);
    return getRecentResults;
};

});
parcelRegister("h9iZl", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $66eb980ebca35ddf$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $66eb980ebca35ddf$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $66eb980ebca35ddf$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $66eb980ebca35ddf$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $66eb980ebca35ddf$export$54805a2120a31ad0);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $66eb980ebca35ddf$export$fa475a9581133779 = (0, $2M1hQ.createResource)({
    type: (0, $94526093207618a3$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $7f4tk.default)('/rest/jpo/1.0/navigation/simple');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $94526093207618a3$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity
});
const $66eb980ebca35ddf$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $66eb980ebca35ddf$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $66eb980ebca35ddf$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $66eb980ebca35ddf$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
const $94526093207618a3$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $94526093207618a3$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("JKfGz", function(module, exports) {

$parcel$export(module.exports, "useGetErrorChildResult", () => $f1d1fc49f867d81f$export$3aefd3a8866c4c01);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $kjpLE = parcelRequire("kjpLE");

var $bgCj3 = parcelRequire("bgCj3");


var $3MOkj = parcelRequire("3MOkj");

var $7mCsh = parcelRequire("7mCsh");
const $f1d1fc49f867d81f$export$3aefd3a8866c4c01 = ()=>{
    const { formatMessage: formatMessage, formatList: formatList } = (0, $koVbs.default)();
    const getChildResult = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const commands = [];
        const sections = {};
        const isSearching = Boolean(search);
        const issueScope = (0, $bgCj3.getQuickSearchIssueScope)(quickSearchResponseData);
        const projectScope = (0, $bgCj3.getQuickSearchProjectScope)(quickSearchResponseData);
        const boardScope = (0, $bgCj3.getQuickSearchBoardScope)(quickSearchResponseData);
        const filterScope = (0, $bgCj3.getQuickSearchFilterScope)(quickSearchResponseData);
        const planScope = (0, $bgCj3.getQuickSearchPlanScope)(quickSearchResponseData);
        const errorScopes = [
            issueScope?.error ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3MOkj.messages).issuesIssueTermRefresh : (0, $3MOkj.messages).issues) : undefined,
            projectScope?.error ? formatMessage((0, $3MOkj.messages).projects) : undefined,
            boardScope?.error ? formatMessage((0, $3MOkj.messages).boards) : undefined,
            filterScope?.error ? formatMessage((0, $3MOkj.messages).filters) : undefined,
            planScope?.error ? formatMessage((0, $3MOkj.messages).plans) : undefined
        ];
        const errors = errorScopes.filter(Boolean); // If there is an api error or the api scopes are all errors
        if (error || errorScopes.length === errors.length) {
            const getMessage = ()=>{
                if (isSearching) return (0, $3MOkj.messages).searchFullError;
                return (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3MOkj.messages).recentFullErrorIssueTermRefresh : (0, $3MOkj.messages).recentFullError;
            };
            const message = formatMessage(getMessage());
            commands.push({
                id: 'full-error',
                name: message,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1d1fc49f867d81f$var$CommandErrorWrapper, {
                            "data-testid": (0, $eb8f9bab396c63a1$export$1a00547d03f724bf)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjpLE.FullWidthText), null, message))
                },
                keywords: search
            });
            return {
                sections: sections,
                commands: commands
            };
        } // If the api scopes are partially errored
        if (errors.length) {
            const formattedErrors = formatList(errors, {
                style: 'long',
                type: 'conjunction'
            });
            const message = isSearching ? formatMessage((0, $3MOkj.messages).searchPartialError, {
                errorList: formattedErrors
            }) : formatMessage((0, $3MOkj.messages).recentPartialError, {
                errorList: formattedErrors
            });
            commands.push({
                id: 'partial-error',
                name: formatMessage((0, $3MOkj.messages).searchFullError),
                // todo fix this
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1d1fc49f867d81f$var$CommandErrorWrapper, {
                            "data-testid": (0, $eb8f9bab396c63a1$export$18ff005171e98b96)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjpLE.FullWidthText), null, message))
                },
                keywords: search
            });
            return {
                sections: sections,
                commands: commands
            };
        }
        const noSearchResults = !issueScope?.results?.length && !projectScope?.results?.length && !boardScope?.results?.length && !filterScope?.results?.length && !planScope?.results?.length;
        if (noSearchResults) {
            if (isSearching) commands.push({
                id: 'no-search-results',
                name: formatMessage((0, $3MOkj.messages).searchFullError),
                keywords: search,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1d1fc49f867d81f$var$CommandErrorWrapper, {
                            "data-testid": (0, $eb8f9bab396c63a1$export$92b3b15780115417)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjpLE.FullWidthText), null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3MOkj.messages).searchNoResultsIssueTermRefresh : (0, $3MOkj.messages).searchNoResults)))
                }
            });
            else {
                const message = formatMessage((0, $3MOkj.messages).noRecentResults);
                commands.push({
                    id: 'no-recent-results',
                    name: message,
                    keywords: search,
                    components: {
                        Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1d1fc49f867d81f$var$CommandErrorWrapper, {
                                "data-testid": (0, $eb8f9bab396c63a1$export$b42da4a04bacaf8c)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7mCsh.NoRecentResults), {
                                message: message
                            }))
                    }
                });
            }
            return {
                sections: sections,
                commands: commands
            };
        }
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatList,
        formatMessage
    ]);
    return {
        getChildResult: getChildResult
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d1fc49f867d81f$var$CommandErrorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _n3tdu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kjpLE", function(module, exports) {

$parcel$export(module.exports, "FullWidthText", () => $c8be77c5d60194e1$export$379b1877ecebef1d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c8be77c5d60194e1$export$379b1877ecebef1d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bgCj3", function(module, exports) {

$parcel$export(module.exports, "transformQuickSearchIssueResultToIssue", () => $bd830de5da878c68$export$58562759d0785ec6);
$parcel$export(module.exports, "getQuickSearchIssueScope", () => $bd830de5da878c68$export$d7d3d79bf2e09f24);
$parcel$export(module.exports, "transformQuickSearchBoardResultToBoard", () => $bd830de5da878c68$export$b8b15ec40fa1a48c);
$parcel$export(module.exports, "getQuickSearchBoardScope", () => $bd830de5da878c68$export$53119668e12df12a);
$parcel$export(module.exports, "getQuickSearchProjectScope", () => $bd830de5da878c68$export$a63a1be38234a3e5);
$parcel$export(module.exports, "transformQuickSearchProjectResultToProject", () => $bd830de5da878c68$export$f2d81fcd7b29a3fa);
$parcel$export(module.exports, "getQuickSearchFilterScope", () => $bd830de5da878c68$export$9fa79248b92c9eb7);
$parcel$export(module.exports, "transformQuickSearchFilterResultToFilter", () => $bd830de5da878c68$export$ff1365615bf8816a);
$parcel$export(module.exports, "getQuickSearchPlanScope", () => $bd830de5da878c68$export$ee6c69e884c0330);
$parcel$export(module.exports, "transformQuickSearchPlanResultToPlan", () => $bd830de5da878c68$export$8033b8f463ee000a);
const $bd830de5da878c68$export$58562759d0785ec6 = (issue)=>({
        issueId: issue.id,
        summary: issue.name,
        url: issue.url,
        issueKey: issue.attributes.key,
        avatar: issue.attributes.avatar,
        projectName: issue.attributes.container.title,
        projectId: issue.attributes.containerId,
        issueTypeName: issue.attributes.issueTypeName
    });
const $bd830de5da878c68$export$d7d3d79bf2e09f24 = (results)=>{
    const issueResults = results?.scopes?.find((scope)=>scope.id === 'jira.issue');
    if (issueResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return issueResults;
    return undefined;
};
const $bd830de5da878c68$export$b8b15ec40fa1a48c = (board)=>({
        id: board.id,
        url: board.url,
        name: board.name,
        containerId: board.attributes.containerId,
        containerName: board.attributes.containerName,
        isFavourite: board.attributes.isFavourite
    });
const $bd830de5da878c68$export$53119668e12df12a = (results)=>{
    const boardResults = results?.scopes?.find((scope)=>scope.id === 'jira.board');
    if (boardResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return boardResults;
    return undefined;
};
const $bd830de5da878c68$export$a63a1be38234a3e5 = (results)=>{
    const issueResults = results?.scopes?.find((scope)=>scope.id === 'jira.project');
    if (issueResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return issueResults;
    return undefined;
};
const $bd830de5da878c68$export$f2d81fcd7b29a3fa = (project)=>({
        projectId: project.id,
        name: project.name,
        url: project.url,
        avatar: project.attributes.avatar,
        canView: project.attributes.canView,
        isFavourite: project.attributes.isFavourite,
        projectKey: project.attributes.projectKey,
        projectType: project.attributes.projectType,
        simplified: project.attributes.simplified
    });
const $bd830de5da878c68$export$9fa79248b92c9eb7 = (results)=>{
    const filterResults = results?.scopes?.find((scope)=>scope.id === 'jira.filter');
    if (filterResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return filterResults;
    return undefined;
};
const $bd830de5da878c68$export$ff1365615bf8816a = (filter)=>({
        id: filter.id,
        name: filter.name,
        url: filter.url
    });
const $bd830de5da878c68$export$ee6c69e884c0330 = (results)=>{
    const planResults = results?.scopes?.find((scope)=>scope.id === 'jira.plan');
    if (planResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return planResults;
    return undefined;
};
const $bd830de5da878c68$export$8033b8f463ee000a = (plan)=>({
        id: plan.id,
        name: plan.name,
        url: plan.url
    });

});

const $eb8f9bab396c63a1$export$1a00547d03f724bf = 'command-palette.ui.modal.modal-dialog';
const $eb8f9bab396c63a1$export$18ff005171e98b96 = 'command-palette.ui.modal.modal-dialog';
const $eb8f9bab396c63a1$export$92b3b15780115417 = 'command-palette.ui.modal.modal-dialog';
const $eb8f9bab396c63a1$export$b42da4a04bacaf8c = 'no-recent-results';

parcelRegister("3MOkj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8949dd27841de0ba$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8949dd27841de0ba$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    noRecentResults: {
        "id": "command-palette-quick-search.common.error.no-recent-results",
        "defaultMessage": "Things in Jira that you\u2019ve recently viewed will appear here."
    },
    recentFullError: {
        "id": "command-palette-quick-search.common.error.recent-full-error",
        "defaultMessage": "We\u2019re having trouble loading recently viewed issues. Try again in a few moments."
    },
    searchFullError: {
        "id": "command-palette-quick-search.common.error.search-full-error",
        "defaultMessage": "We\u2019re not sure what went wrong. Try again in a few moments."
    },
    searchNoResults: {
        "id": "command-palette-quick-search.common.error.search-no-results",
        "defaultMessage": "No issue, project, board, plan, or filter matches your search"
    },
    searchIssueError: {
        "id": "command-palette-quick-search.common.error.search-issue-error",
        "defaultMessage": "We\u2019re having trouble searching issues. You can try again in a few moments."
    },
    recentPartialError: {
        "id": "command-palette-quick-search.common.error.recent-partial-error",
        "defaultMessage": "We are having trouble loading {errorList} from your recently viewed items. Try again in a few moments."
    },
    searchPartialError: {
        "id": "command-palette-quick-search.common.error.search-partial-error",
        "defaultMessage": "We are having trouble searching {errorList}. Try again in a few moments."
    },
    issues: {
        "id": "command-palette-quick-search.common.error.issues",
        "defaultMessage": "issues"
    },
    projects: {
        "id": "command-palette-quick-search.common.error.projects",
        "defaultMessage": "projects"
    },
    boards: {
        "id": "command-palette-quick-search.common.error.boards",
        "defaultMessage": "boards"
    },
    filters: {
        "id": "command-palette-quick-search.common.error.filters",
        "defaultMessage": "filters"
    },
    plans: {
        "id": "command-palette-quick-search.common.error.plans",
        "defaultMessage": "plans"
    },
    recentFullErrorIssueTermRefresh: {
        "id": "command-palette-quick-search.common.error.recent-full-error-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble loading recently viewed work items. Try again in a few moments."
    },
    searchNoResultsIssueTermRefresh: {
        "id": "command-palette-quick-search.common.error.search-no-results-issue-term-refresh",
        "defaultMessage": "No work item, project, board, plan, or filter matches your search"
    },
    searchIssueErrorIssueTermRefresh: {
        "id": "command-palette-quick-search.common.error.search-issue-error-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble searching for work items. You can try again in a few moments."
    },
    issuesIssueTermRefresh: {
        "id": "command-palette-quick-search.common.error.issues-issue-term-refresh",
        "defaultMessage": "work items"
    }
});

});

parcelRegister("7mCsh", function(module, exports) {

$parcel$export(module.exports, "NoRecentResults", () => $58efa10eb1db047e$export$6a5306d6ad19b06d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $80P9l = parcelRequire("80P9l");

var $kjpLE = parcelRequire("kjpLE");
const $58efa10eb1db047e$export$6a5306d6ad19b06d = ({ message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjpLE.FullWidthText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58efa10eb1db047e$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80P9l.default), {
        alt: "",
        fill: true
    })), message)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58efa10eb1db047e$var$ImageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ioahv _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("80P9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6043373c6b544137$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cTD1D")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cTD1D")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nj3nrg7zrmxwrhh9fn9ftw5m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nj3nrg7zrmxwrhh9fn9ftw5m

var $dCLgq = parcelRequire("dCLgq");

var $cTD1D = parcelRequire("cTD1D");
const $6043373c6b544137$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cTD1D)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cTD1D))
});
var $6043373c6b544137$export$2e2bcd8739ae039 = $6043373c6b544137$var$Illustration;
// for advanced use only
const $6043373c6b544137$export$a179c88182cb9d56 = [
    0,
    0,
    95,
    89
];

});
parcelRegister("cTD1D", function(module, exports) {
module.exports = new URL("magic-search.dbdce574.svg", import.meta.url).toString();

});




parcelRegister("5zDBm", function(module, exports) {

$parcel$export(module.exports, "useGetRecommendedChildResult", () => $6bd8e7b697bad55c$export$d7d3564e5e2691ad);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $bgCj3 = parcelRequire("bgCj3");

var $73ZzY = parcelRequire("73ZzY");

var $e5idJ = parcelRequire("e5idJ");

var $bGpCi = parcelRequire("bGpCi");
const $6bd8e7b697bad55c$var$SECTION_ID = 'recommended';
const $6bd8e7b697bad55c$export$d7d3564e5e2691ad = ()=>{
    const { getViewAllCommand: getViewAllCommand } = (0, $73ZzY.useGetViewAllCommand)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getChildResult = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const isSearching = Boolean(search);
        const sections = {
            [$6bd8e7b697bad55c$var$SECTION_ID]: {
                name: formatMessage((0, $bGpCi.messages).recommendedSection),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).RECOMMENDED
            }
        };
        const commands = [];
        const issueScope = (0, $bgCj3.getQuickSearchIssueScope)(quickSearchResponseData);
        const projectScope = (0, $bgCj3.getQuickSearchProjectScope)(quickSearchResponseData);
        const boardScope = (0, $bgCj3.getQuickSearchBoardScope)(quickSearchResponseData);
        const filterScope = (0, $bgCj3.getQuickSearchFilterScope)(quickSearchResponseData);
        const planScope = (0, $bgCj3.getQuickSearchPlanScope)(quickSearchResponseData);
        const showRecommended = (scope)=>!scope || scope.error || error || isSearching && !scope?.results?.length;
        if (showRecommended(issueScope)) commands.push(getViewAllCommand({
            id: 'recommended-issues',
            section: $6bd8e7b697bad55c$var$SECTION_ID,
            name: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bGpCi.messages).viewAllIssuesIssueTermRefresh : (0, $bGpCi.messages).viewAllIssues),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).ISSUE),
            priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).ISSUES,
            analyticsPayload: {
                action: 'viewAllIssues'
            }
        }));
        if (showRecommended(boardScope)) commands.push(getViewAllCommand({
            id: 'recommended-boards',
            section: $6bd8e7b697bad55c$var$SECTION_ID,
            name: formatMessage((0, $bGpCi.messages).viewAllBoards),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).BOARD),
            priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).BOARDS,
            analyticsPayload: {
                action: 'viewAllBoards'
            }
        }));
        if (showRecommended(projectScope)) commands.push(getViewAllCommand({
            id: 'recommended-projects',
            section: $6bd8e7b697bad55c$var$SECTION_ID,
            name: formatMessage((0, $bGpCi.messages).viewAllProjects),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).PROJECT),
            priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).PROJECTS,
            analyticsPayload: {
                action: 'viewAllProjects'
            }
        }));
        if (showRecommended(filterScope)) commands.push(getViewAllCommand({
            id: 'recommended-filters',
            section: $6bd8e7b697bad55c$var$SECTION_ID,
            name: formatMessage((0, $bGpCi.messages).viewAllFilters),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).FILTER),
            priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).FILTERS,
            analyticsPayload: {
                action: 'viewAllFilters'
            }
        }));
        if (showRecommended(planScope)) commands.push(getViewAllCommand({
            id: 'recommended-plans',
            section: $6bd8e7b697bad55c$var$SECTION_ID,
            name: formatMessage((0, $bGpCi.messages).viewAllPlans),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).PLAN),
            priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).PLANS,
            analyticsPayload: {
                action: 'viewAllPlans'
            }
        }));
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getViewAllCommand
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("73ZzY", function(module, exports) {

$parcel$export(module.exports, "useGetViewAllCommand", () => $6cf89e2618cdefcd$export$fc2d112e790e7f2a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGdV2 = parcelRequire("eGdV2");

var $4l54H = parcelRequire("4l54H");
const $6cf89e2618cdefcd$export$fc2d112e790e7f2a = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $4l54H.useTransformNavigationCommands)();
    const getViewAllCommand = (0, $5uXOq.useCallback)(({ name: name, url: url, isRecommended: isRecommended = false, analyticsPayload: analyticsPayload = {}, ...rest })=>transformNavigationCommand({
            name: name,
            components: {
                Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cf89e2618cdefcd$var$RenderNameWrapper, {
                        "data-testid": "command-palette-quick-search.common.ui.view-all.render-name-wrapper",
                        isRecommended: isRecommended
                    }, name),
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                        label: "",
                        color: "currentColor",
                        size: "small"
                    })
            },
            analytics: {
                action: 'quickSearchViewAll',
                ...analyticsPayload
            },
            ...rest
        }, {
            path: url
        }), [
        transformNavigationCommand
    ]);
    return {
        getViewAllCommand: getViewAllCommand
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6cf89e2618cdefcd$var$RenderNameWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRecommended: isRecommended, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isRecommended && "_syaz1e6v",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eGdV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
    }, props));
$aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});


parcelRegister("4l54H", function(module, exports) {

$parcel$export(module.exports, "useTransformNavigationCommands", () => $586d7e6f1a99cb44$export$5b108cd54c923a60);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $7paD5 = parcelRequire("7paD5");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $jh7L9 = parcelRequire("jh7L9");

var $jiSaf = parcelRequire("jiSaf");

var $gM5ou = parcelRequire("gM5ou");

var $d8lE2 = parcelRequire("d8lE2");

var $2f2jJ = parcelRequire("2f2jJ");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $doZTA = parcelRequire("doZTA");

var $8btEA = parcelRequire("8btEA");

var $3XsL2 = parcelRequire("3XsL2");

var $d10H0 = parcelRequire("d10H0");

var $dmcoI = parcelRequire("dmcoI");

const $586d7e6f1a99cb44$export$5b108cd54c923a60 = ()=>{
    const [{ location: { pathname: pathname } }, { push: push, pushTo: pushTo }] = (0, $doZTA.useRouter)();
    const { getAnalyticsAttributes: getAnalyticsAttributes } = (0, $d8lE2.useActionsCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const openNewTab = (0, $5uXOq.useCallback)((link, openBackground)=>{
        const url = typeof link === 'string' ? link : link.path;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const newTab = window.open(url, '_blank');
        if (openBackground) {
            newTab?.blur();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.focus();
        }
        return newTab;
    }, []);
    const openSameTab = (0, $5uXOq.useCallback)((link)=>{
        if (typeof link === 'string') return push(link);
        return pushTo(link);
    }, [
        push,
        pushTo
    ]);
    const renderCommand = (0, $5uXOq.useCallback)((props, path, shouldAlwaysOpenNewTab)=>{
        const { onClick: onClick, ...rest } = props;
        const { command: command } = rest;
        const handleClick = (event)=>{
            const wasSecondaryTriggered = (0, $gM5ou.isSecondaryTrigger)(event);
            if (!wasSecondaryTriggered) {
                onClick?.(event); // Run main action as it will close the modal too
                event.preventDefault();
                return;
            }
            const analytics = getAnalyticsAttributes(command, 'mouse', wasSecondaryTriggered, props?.analyticsAttributes);
            const eventAnalytics = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(eventAnalytics, 'commandPalette navigation', analytics);
            (0, $8zOmE.fireTrackAnalytics)(eventAnalytics, 'commandPalette secondaryAction', {
                ...analytics,
                keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                secondaryAction: 'openNewTab'
            });
            (0, $8zOmE.fireTrackAnalytics)(eventAnalytics, 'commandPalette taskSucceeded', analytics);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3XsL2.NavigationLink), {
            to: path,
            onClick: handleClick,
            ...shouldAlwaysOpenNewTab && {
                target: '_blank'
            },
            "data-testid": (0, $2ea3babd020e8e8a$export$8db96ea7b6a4cbab)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiSaf.components).CommandRow, rest));
    }, [
        createAnalyticsEvent,
        getAnalyticsAttributes
    ]);
    const transformNavigationCommand = (0, $5uXOq.useCallback)((command, { path: path, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab })=>({
            ...command,
            components: {
                ...command.components,
                Name: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8btEA.NameContainer), null, command.components?.Name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.Name, base) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, command.name), !!shouldAlwaysOpenNewTab && (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        testId: (0, $2ea3babd020e8e8a$export$99957d8f5f113509),
                        justifyContent: "center",
                        alignItems: "center",
                        xcss: $586d7e6f1a99cb44$var$iconWrapperStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                        label: "",
                        color: "currentColor"
                    })), !!shouldAlwaysOpenNewTab && !(0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8btEA.IconContainer), {
                        "data-testid": (0, $2ea3babd020e8e8a$export$99957d8f5f113509)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                        label: "",
                        color: "currentColor"
                    }))),
                CommandRow: (base)=>renderCommand(base, path, shouldAlwaysOpenNewTab),
                Footer: (0, $d10H0.NewTabHintMessage)
            },
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>shouldAlwaysOpenNewTab ? openNewTab(path) : openSameTab(path)
            },
            secondaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>openNewTab(path, true),
                preventModalClose: true,
                analyticsArgs: {
                    secondaryAction: 'openNewTab'
                }
            }
        }), [
        openNewTab,
        openSameTab,
        renderCommand
    ]);
    const shouldShowCommand = (0, $5uXOq.useCallback)((hideCommandPath)=>!(0, $dmcoI.isCurrentPage)(hideCommandPath, pathname), [
        pathname
    ]);
    const hideAndTransformNavigationCommand = (0, $5uXOq.useCallback)((commandToTransform)=>{
        const { path: path, hideCommandPath: hideCommandPath, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab, command: command } = commandToTransform;
        let hidePath = typeof path === 'string' ? path : path.path;
        if (hideCommandPath) hidePath = hideCommandPath;
        if (!shouldShowCommand(hidePath)) return undefined;
        return transformNavigationCommand(command, {
            path: path,
            shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab
        });
    }, [
        shouldShowCommand,
        transformNavigationCommand
    ]);
    const hideAndTransformNavigationCommands = (0, $5uXOq.useCallback)((commands)=>{
        const filteredCommands = [];
        commands.forEach((commandToTransform)=>{
            const transformedCommand = hideAndTransformNavigationCommand(commandToTransform);
            if (transformedCommand) filteredCommands.push(transformedCommand);
        });
        return filteredCommands;
    }, [
        hideAndTransformNavigationCommand
    ]);
    return {
        shouldShowCommand: shouldShowCommand,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        hideAndTransformNavigationCommands: hideAndTransformNavigationCommands,
        transformNavigationCommand: transformNavigationCommand
    };
};
const $586d7e6f1a99cb44$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    height: '24px',
    width: '24px',
    marginLeft: 'space.075'
});

});
parcelRegister("8btEA", function(module, exports) {

$parcel$export(module.exports, "NameContainer", () => $ddea451afbf29ad2$export$817b6bdd5f45c94b);
$parcel$export(module.exports, "IconContainer", () => $ddea451afbf29ad2$export$8f314e512d92575f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ddea451afbf29ad2$export$817b6bdd5f45c94b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc _1nmz1hna _slp31hna",
            __cmplp.className
        ])
    });
});
const $ddea451afbf29ad2$export$8f314e512d92575f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _18u012x7 _1bsb1tcg _4t3i1tcg _vwz41tcg _1f027vkz _nbgx7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3XsL2", function(module, exports) {

$parcel$export(module.exports, "NavigationLink", () => $fdfd62bd57e7226d$export$721ee963a67379f1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hjSul = parcelRequire("hjSul");
const $fdfd62bd57e7226d$export$721ee963a67379f1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSul.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});

parcelRegister("d10H0", function(module, exports) {

$parcel$export(module.exports, "NewTabHintMessage", () => $9f2aa76d6a204b23$export$54561b2030abf061);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jiSaf = parcelRequire("jiSaf");

var $dzeHJ = parcelRequire("dzeHJ");

var $2f2jJ = parcelRequire("2f2jJ");

var $koVbs = parcelRequire("koVbs");

var $kdbk3 = parcelRequire("kdbk3");
const $9f2aa76d6a204b23$export$54561b2030abf061 = ({ defaultFooterContent: defaultFooterContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiSaf.components).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$FooterContentContainer, {
        "data-testid": "command-palette-common.common.ui.new-tab-hint-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, defaultFooterContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$HintMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MessageWrapper, null, formatMessage((0, $kdbk3.messages).openInANewTab)), (0, $2f2jJ.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MacLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MacTextOffset, null, "\u2318")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$WindowsLozenge, null, "Ctrl"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$EnterLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$EnterIconSVG, null)))));
};
const $9f2aa76d6a204b23$var$EnterIconSVG = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "13",
        height: "8",
        viewBox: "0 0 13 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.055 1.055V3.055H2.275L4.195 1.135C4.455 0.875 4.455 0.455 4.195 0.195C3.935 -0.065 3.515 -0.065 3.255 0.195L0.195 3.255C-0.065 3.515 -0.065 3.935 0.195 4.195L3.255 7.255C3.515 7.515 3.935 7.515 4.195 7.255C4.455 6.995 4.455 6.575 4.195 6.315L2.275 4.38833H11.7217C12.0883 4.38833 12.3883 4.08833 12.3883 3.72167V1.055C12.3883 0.688333 12.0883 0.388333 11.7217 0.388333C11.355 0.388333 11.055 0.688333 11.055 1.055Z",
        fill: "var(--ds-text-subtle, #44546F)"
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f2aa76d6a204b23$var$FooterContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f2aa76d6a204b23$var$HintMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m _syaz1gjq _u5f312x7",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$MacLozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dzeHJ.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81ixg _18u0v77o _vwz47vkz _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$MacTextOffset = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_t9ec170z",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$WindowsLozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dzeHJ.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1qjk _k48pi7a9 _1p1d1dk0 _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$EnterLozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dzeHJ.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$MessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kdbk3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $29cc514acfa3bb8e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $29cc514acfa3bb8e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    openInANewTab: {
        "id": "command-palette-common.common.new-tab-hint-message.open-in-a-new-tab",
        "defaultMessage": "Open in a new tab"
    }
});

});


parcelRegister("dmcoI", function(module, exports) {

$parcel$export(module.exports, "isCurrentPage", () => $b6be5b0653c72ae5$export$d4781f4a7d66b55c);
const $b6be5b0653c72ae5$export$d4781f4a7d66b55c = (hideCommandPath, pathname)=>{
    const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');
    const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');
    return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
};

});

const $2ea3babd020e8e8a$export$99957d8f5f113509 = 'command-palette-common.controllers.transform-navigation-commands.icon-container';
const $2ea3babd020e8e8a$export$8db96ea7b6a4cbab = 'command-palette-common.controllers.transform-navigation-commands.navigation-link';



parcelRegister("e5idJ", function(module, exports) {

$parcel$export(module.exports, "ViewAllType", () => $1ebb3b4e78014f2d$export$701f40362530db8b);
$parcel$export(module.exports, "getViewAllUrl", () => $1ebb3b4e78014f2d$export$96e8b39eed587a1e);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $1ebb3b4e78014f2d$export$701f40362530db8b = /*#__PURE__*/ function(ViewAllType) {
    ViewAllType["PROJECT"] = "project";
    ViewAllType["ISSUE"] = "issue";
    ViewAllType["BOARD"] = "board";
    ViewAllType["FILTER"] = "filter";
    ViewAllType["PLAN"] = "plan";
    return ViewAllType;
}({});
const $1ebb3b4e78014f2d$export$96e8b39eed587a1e = (type, search)=>{
    switch(type){
        case "issue":
            return `/jira/search${search ? `?searchString=${search}` : ''}`;
        case "board":
            return `/jira/boards${search ? `?contains=${search}` : ''}`;
        case "project":
            return `/jira/projects${search ? `?keyword=${search}` : ''}`;
        case "filter":
            return `/jira/filters${search ? `?name=${search}` : ''}`;
        case "plan":
            return `/jira/plans${search ? `?name=${search}` : ''}`;
        default:
            return undefined;
    }
};

});

parcelRegister("bGpCi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d964339cd9d84bf9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d964339cd9d84bf9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    recommendedSection: {
        "id": "command-palette-quick-search.common.recommended.recommended-section",
        "defaultMessage": "Recommended"
    },
    viewAllIssues: {
        "id": "command-palette-quick-search.common.recommended.view-all-issues",
        "defaultMessage": "View all issues"
    },
    viewAllProjects: {
        "id": "command-palette-quick-search.common.recommended.view-all-projects",
        "defaultMessage": "View all projects"
    },
    viewAllBoards: {
        "id": "command-palette-quick-search.common.recommended.view-all-boards",
        "defaultMessage": "View all boards"
    },
    viewAllFilters: {
        "id": "command-palette-quick-search.common.recommended.view-all-filters",
        "defaultMessage": "View all filters"
    },
    viewAllPlans: {
        "id": "command-palette-quick-search.common.recommended.view-all-plans",
        "defaultMessage": "View all plans"
    },
    viewAllIssuesIssueTermRefresh: {
        "id": "command-palette-quick-search.common.recommended.view-all-issues-issue-term-refresh",
        "defaultMessage": "View all work items"
    }
});

});


parcelRegister("hX4Eo", function(module, exports) {

$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $4cb9c5b6b4b17493$export$c3d20e8c1e93a572);

var $5uXOq = parcelRequire("5uXOq");
const $4cb9c5b6b4b17493$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (0, $5uXOq.useCallback)((...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    }, []);
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});

parcelRegister("bsL38", function(module, exports) {

$parcel$export(module.exports, "useGetRecentBoardsChildResult", () => $a9075714ae8a3438$export$67be4cf74634869c);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $flylh = parcelRequire("flylh");

var $dmf5R = parcelRequire("dmf5R");


var $3gYvd = parcelRequire("3gYvd");
const $a9075714ae8a3438$export$67be4cf74634869c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchBoardCommands: getQuickSearchBoardCommands } = (0, $flylh.useGetQuickSearchBoardCommands)({
        section: (0, $491877a74099feb6$export$501955bd67991a25),
        showViewAll: false
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [(0, $491877a74099feb6$export$501955bd67991a25)]: {
                id: (0, $491877a74099feb6$export$501955bd67991a25),
                name: formatMessage((0, $3gYvd.messages).recentlyViewedBoards),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).BOARDS
            }
        };
        const commands = getQuickSearchBoardCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchBoardCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("flylh", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchBoardCommands", () => $d88b5469edac1ca6$export$3036f58f7b6b3d11);

var $5uXOq = parcelRequire("5uXOq");

var $di77o = parcelRequire("di77o");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $9ReLB = parcelRequire("9ReLB");

var $bgCj3 = parcelRequire("bgCj3");

var $73ZzY = parcelRequire("73ZzY");

var $e5idJ = parcelRequire("e5idJ");
const $d88b5469edac1ca6$export$3036f58f7b6b3d11 = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getBoardCommand: getBoardCommand } = (0, $di77o.useGetBoardCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $73ZzY.useGetViewAllCommand)();
    const getQuickSearchBoardCommands = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const boardScope = (0, $bgCj3.getQuickSearchBoardScope)(quickSearchResponseData);
        // No results
        if (!boardScope || error || boardScope?.error || boardScope?.results?.length === 0) return [];
        const commands = boardScope.results.slice(0, (0, $dmf5R.BOARD_LIMIT)).map((board)=>getBoardCommand({
                board: (0, $bgCj3.transformQuickSearchBoardResultToBoard)(board),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            }));
        if (!showViewAll || boardScope.results.length <= (0, $dmf5R.BOARD_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-boards',
            keywords: search,
            section: section,
            name: formatMessage((0, $9ReLB.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).BOARD, search),
            analyticsPayload: {
                action: 'viewAllBoards',
                size: boardScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getBoardCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchBoardCommands: getQuickSearchBoardCommands
    };
};

});
parcelRegister("di77o", function(module, exports) {

$parcel$export(module.exports, "useGetBoardCommand", () => $c14ac5929a67ca09$export$a607cbe1c4fa60ee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dME4E = parcelRequire("dME4E");

var $4l54H = parcelRequire("4l54H");
const $c14ac5929a67ca09$export$a607cbe1c4fa60ee = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $4l54H.useTransformNavigationCommands)();
    const renderBoardName = (0, $5uXOq.useCallback)((name, containerName, isActive)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c14ac5929a67ca09$var$BoardNameContainer, {
            "data-testid": "command-palette-common.common.ui.command.board.board-name-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c14ac5929a67ca09$var$BoardNameText, null, name), containerName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c14ac5929a67ca09$export$17e73069b4d98f65, {
            active: isActive
        }, containerName)), []);
    const getBoardCommand = (0, $5uXOq.useCallback)(({ board: board, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
        const { id: id, url: url, name: name, containerId: containerId = 'UNAVAILABLE', containerName: containerName } = board;
        return transformNavigationCommand({
            id: `board-${id}`,
            section: section,
            name: name,
            keywords: keywords,
            components: {
                Name: ({ isActive: isActive })=>renderBoardName(name, containerName, isActive),
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
                        label: "",
                        color: "currentColor"
                    })
            },
            analytics: {
                action: 'boardViewed',
                boardId: id,
                boardContainerId: containerId || '',
                metadata: {
                    contentId: id,
                    containerId: containerId,
                    contentType: 'board'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        renderBoardName,
        transformNavigationCommand
    ]);
    return {
        getBoardCommand: getBoardCommand
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c14ac5929a67ca09$var$BoardNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c14ac5929a67ca09$var$BoardNameText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _vwz41kw7",
            __cmplp.className
        ])
    });
});
const $c14ac5929a67ca09$export$17e73069b4d98f65 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _vwz41kw7",
            __cmplp.active ? "_syaz1gjq" : "_syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dME4E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6de69f6e8d23d80c647d0a6d3ecd7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a08ed7e863649bfd$var$_react = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a08ed7e863649bfd$var$_board = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("8EsNC")));

var $a08ed7e863649bfd$var$_board2 = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("v8Zna")));
function $a08ed7e863649bfd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardIcon.
 * This component is BoardIcon, with `UNSAFE_fallbackIcon` set to "BoardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a08ed7e863649bfd$var$BoardIcon = (props)=>/*#__PURE__*/ $a08ed7e863649bfd$var$_react.default.createElement($a08ed7e863649bfd$var$_board.default, Object.assign({
        LEGACY_fallbackIcon: $a08ed7e863649bfd$var$_board2.default
    }, props));
$a08ed7e863649bfd$var$BoardIcon.Name = 'BoardIconMigration';
var $a08ed7e863649bfd$var$_default = module.exports.default = $a08ed7e863649bfd$var$BoardIcon;

});
parcelRegister("8EsNC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64c8661ab6d81803$var$_react = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $64c8661ab6d81803$var$_baseNew = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $64c8661ab6d81803$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64c8661ab6d81803$var$BoardIcon = (props)=>/*#__PURE__*/ $64c8661ab6d81803$var$_react.default.createElement($64c8661ab6d81803$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$64c8661ab6d81803$var$BoardIcon.displayName = 'BoardIcon';
var $64c8661ab6d81803$var$_default = module.exports.default = $64c8661ab6d81803$var$BoardIcon;

});

parcelRegister("v8Zna", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05d9de5ec3a4369b$var$_react = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $05d9de5ec3a4369b$var$_board = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("8EsNC")));
function $05d9de5ec3a4369b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $05d9de5ec3a4369b$var$BoardIcon = (props)=>/*#__PURE__*/ $05d9de5ec3a4369b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $05d9de5ec3a4369b$var$_board.default
    }));
$05d9de5ec3a4369b$var$BoardIcon.displayName = 'BoardIcon';
var $05d9de5ec3a4369b$var$_default = module.exports.default = $05d9de5ec3a4369b$var$BoardIcon;

});



parcelRegister("9ReLB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d239df1fde27f18a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d239df1fde27f18a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    viewAllResults: {
        "id": "command-palette-quick-search.common.view-all-results",
        "defaultMessage": "View all results"
    }
});

});


const $491877a74099feb6$export$501955bd67991a25 = 'jira.board';

parcelRegister("3gYvd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1094b8458a2f11d3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1094b8458a2f11d3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    recentlyViewedBoards: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.boards.recently-viewed-boards",
        "defaultMessage": "Recently Viewed Boards"
    }
});

});


parcelRegister("33VxI", function(module, exports) {

$parcel$export(module.exports, "useGetRecentFiltersChildResult", () => $4c2e1610d33be477$export$abc1122ece543f47);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $8kcFW = parcelRequire("8kcFW");


var $5fcJA = parcelRequire("5fcJA");
const $4c2e1610d33be477$export$abc1122ece543f47 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchFilterCommands: getQuickSearchFilterCommands } = (0, $8kcFW.useGetQuickSearchFilterCommands)({
        section: (0, $1eff0899f1ee36bd$export$501955bd67991a25),
        showViewAll: false
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [(0, $1eff0899f1ee36bd$export$501955bd67991a25)]: {
                id: (0, $1eff0899f1ee36bd$export$501955bd67991a25),
                name: formatMessage((0, $5fcJA.messages).recentlyViewedFilters),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).FILTERS
            }
        };
        const commands = getQuickSearchFilterCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchFilterCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("8kcFW", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchFilterCommands", () => $aa6c7064981ac871$export$b31b2989a89c872e);

var $5uXOq = parcelRequire("5uXOq");

var $eat75 = parcelRequire("eat75");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $9ReLB = parcelRequire("9ReLB");

var $bgCj3 = parcelRequire("bgCj3");

var $73ZzY = parcelRequire("73ZzY");

var $e5idJ = parcelRequire("e5idJ");
const $aa6c7064981ac871$export$b31b2989a89c872e = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getFilterCommand: getFilterCommand } = (0, $eat75.useGetFilterCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $73ZzY.useGetViewAllCommand)();
    const getQuickSearchFilterCommands = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const filterScope = (0, $bgCj3.getQuickSearchFilterScope)(quickSearchResponseData);
        // No results
        if (!filterScope || error || filterScope?.error || filterScope?.results?.length === 0) return [];
        const commands = filterScope.results.slice(0, (0, $dmf5R.FILTER_LIMIT)).map((filter)=>getFilterCommand({
                filter: (0, $bgCj3.transformQuickSearchFilterResultToFilter)(filter),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            }));
        if (!showViewAll || filterScope.results.length <= (0, $dmf5R.FILTER_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-filters',
            keywords: search,
            section: section,
            name: formatMessage((0, $9ReLB.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).FILTER, search),
            analyticsPayload: {
                action: 'viewAllFilters',
                size: filterScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getFilterCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchFilterCommands: getQuickSearchFilterCommands
    };
};

});
parcelRegister("eat75", function(module, exports) {

$parcel$export(module.exports, "useGetFilterCommand", () => $77b1b9a822ca07f1$export$c074d91a3a335ecb);

var $5uXOq = parcelRequire("5uXOq");

var $2o8gl = parcelRequire("2o8gl");

var $4l54H = parcelRequire("4l54H");
const $77b1b9a822ca07f1$export$c074d91a3a335ecb = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $4l54H.useTransformNavigationCommands)();
    const getFilterCommand = (0, $5uXOq.useCallback)(({ filter: filter, section: section, analytics: analytics, ...rest })=>{
        const { id: id, url: url, name: name } = filter;
        return transformNavigationCommand({
            id: `filter-${id}`,
            section: section,
            name: name,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2o8gl))), {
                        label: "",
                        color: "currentColor"
                    })
            },
            analytics: {
                action: 'filterViewed',
                filterId: id,
                metadata: {
                    contentId: id,
                    containerId: 'UNAVAILABLE',
                    contentType: 'filter'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getFilterCommand: getFilterCommand
    };
};

});
parcelRegister("2o8gl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289d4f542a1ed26db6d28b87ad2efcf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1bd43b75b5db29b6$var$_react = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1bd43b75b5db29b6$var$_filter = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("jX361")));

var $1bd43b75b5db29b6$var$_filter2 = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("bTqXB")));
function $1bd43b75b5db29b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FilterIcon.
 * This component is FilterIcon, with `UNSAFE_fallbackIcon` set to "FilterIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1bd43b75b5db29b6$var$FilterIcon = (props)=>/*#__PURE__*/ $1bd43b75b5db29b6$var$_react.default.createElement($1bd43b75b5db29b6$var$_filter.default, Object.assign({
        LEGACY_fallbackIcon: $1bd43b75b5db29b6$var$_filter2.default
    }, props));
$1bd43b75b5db29b6$var$FilterIcon.Name = 'FilterIconMigration';
var $1bd43b75b5db29b6$var$_default = module.exports.default = $1bd43b75b5db29b6$var$FilterIcon;

});
parcelRegister("bTqXB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a89be8174ef75ee$var$_react = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8a89be8174ef75ee$var$_filter = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("jX361")));
function $8a89be8174ef75ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a89be8174ef75ee$var$FilterIcon = (props)=>/*#__PURE__*/ $8a89be8174ef75ee$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $8a89be8174ef75ee$var$_filter.default
    }));
$8a89be8174ef75ee$var$FilterIcon.displayName = 'FilterIcon';
var $8a89be8174ef75ee$var$_default = module.exports.default = $8a89be8174ef75ee$var$FilterIcon;

});




const $1eff0899f1ee36bd$export$501955bd67991a25 = 'jira.filter';

parcelRegister("5fcJA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b7976029a21f4058$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b7976029a21f4058$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    recentlyViewedFilters: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.filters.recently-viewed-filters",
        "defaultMessage": "Recently Viewed Filters"
    }
});

});


parcelRegister("5OaBm", function(module, exports) {

$parcel$export(module.exports, "useGetRecentIssuesChildResult", () => $f6932e48ac759e7c$export$e5366d4438f3f848);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $hzB87 = parcelRequire("hzB87");

var $bBHcB = parcelRequire("bBHcB");
const $f6932e48ac759e7c$var$SECTION_ID = 'jira.issue';
const $f6932e48ac759e7c$export$e5366d4438f3f848 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchIssueCommands: getQuickSearchIssueCommands } = (0, $hzB87.useGetQuickSearchIssueCommands)({
        section: $f6932e48ac759e7c$var$SECTION_ID,
        errorMessage: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bBHcB.messages).issueErrorIssueTermRefresh : (0, $bBHcB.messages).issueError),
        showViewAll: false
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [$f6932e48ac759e7c$var$SECTION_ID]: {
                id: $f6932e48ac759e7c$var$SECTION_ID,
                name: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bBHcB.messages).recentlyViewedIssuesIssueTermRefresh : (0, $bBHcB.messages).recentlyViewedIssues),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).ISSUES
            }
        };
        const commands = getQuickSearchIssueCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchIssueCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("hzB87", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchIssueCommands", () => $ccaee2400f4c17a8$export$e3611b615ec843dc);

var $5uXOq = parcelRequire("5uXOq");

var $5WKxV = parcelRequire("5WKxV");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $9ReLB = parcelRequire("9ReLB");

var $bgCj3 = parcelRequire("bgCj3");

var $73ZzY = parcelRequire("73ZzY");

var $e5idJ = parcelRequire("e5idJ");
const $ccaee2400f4c17a8$export$e3611b615ec843dc = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getIssueCommand: getIssueCommand } = (0, $5WKxV.useGetIssueCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $73ZzY.useGetViewAllCommand)();
    const getQuickSearchIssueCommands = (0, $5uXOq.useCallback)(({ error: error, search: search, quickSearchResponseData: quickSearchResponseData })=>{
        const issueScope = (0, $bgCj3.getQuickSearchIssueScope)(quickSearchResponseData);
        // No results
        if (!issueScope || error || issueScope?.error || issueScope?.results?.length === 0) return [];
        // There are results!
        const commands = issueScope.results.slice(0, (0, $dmf5R.ISSUE_LIMIT)).map((issue)=>{
            const command = getIssueCommand({
                issue: (0, $bgCj3.transformQuickSearchIssueResultToIssue)(issue),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            });
            return command;
        });
        if (!showViewAll || issueScope.results.length <= (0, $dmf5R.ISSUE_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-issues',
            keywords: search,
            section: section,
            name: formatMessage((0, $9ReLB.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).ISSUE, search),
            analyticsPayload: {
                action: 'viewAllIssues',
                size: issueScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getIssueCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchIssueCommands: getQuickSearchIssueCommands
    };
};

});
parcelRegister("5WKxV", function(module, exports) {

$parcel$export(module.exports, "useGetIssueCommand", () => $a622cdc1edfd2034$export$98868e4240dcd14d);

var $5uXOq = parcelRequire("5uXOq");

var $4l54H = parcelRequire("4l54H");

var $eMpK2 = parcelRequire("eMpK2");

var $e0tx8 = parcelRequire("e0tx8");
const $a622cdc1edfd2034$export$98868e4240dcd14d = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $4l54H.useTransformNavigationCommands)();
    const getIssueCommand = (0, $5uXOq.useCallback)(({ issue: issue, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
        const { issueId: issueId, summary: summary, issueKey: issueKey, projectId: projectId = 'UNAVAILABLE' } = issue;
        return transformNavigationCommand({
            id: `issue-${issueId}`,
            section: section,
            keywords: keywords,
            name: `${issueKey} ${summary}`,
            components: {
                Name: ({ isActive: isActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0tx8.IssueView), {
                        issue: issue,
                        isActive: isActive
                    }),
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMpK2.IssueLeftIcon), {
                        iconUrl: issue.avatar?.url,
                        issueTypeName: issue.issueTypeName
                    })
            },
            analytics: {
                action: 'issueViewed',
                issueId: issueId,
                metadata: {
                    contentId: issueId,
                    containerId: projectId,
                    contentType: 'issue'
                },
                ...analytics
            },
            ...rest
        }, {
            path: `/browse/${issueKey}`
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getIssueCommand: getIssueCommand
    };
};

});
parcelRegister("eMpK2", function(module, exports) {

$parcel$export(module.exports, "IssueLeftIcon", () => $f381ae85157eafc9$export$b1b562672a76ad84);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dXXlv = parcelRequire("dXXlv");
const $f381ae85157eafc9$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: iconUrl,
        alt: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXXlv.messages).issueIconAltTextIssueTermRefresh : (0, $dXXlv.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("dXXlv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $91c46772185cf0df$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $91c46772185cf0df$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    },
    issueIconAltTextIssueTermRefresh: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text-issue-term-refresh",
        "defaultMessage": "Icon for the work type {issueTypeName}"
    }
});

});


parcelRegister("e0tx8", function(module, exports) {

$parcel$export(module.exports, "IssueView", () => $d9e23d5c9ad5ce0a$export$5aebed4b5cba826a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aYAc3 = parcelRequire("aYAc3");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gGkxR = parcelRequire("gGkxR");
const $d9e23d5c9ad5ce0a$export$995d7ae0c0293bac = {
    1: 'default',
    2: 'default',
    3: 'success',
    4: 'inprogress'
};
const $d9e23d5c9ad5ce0a$export$5aebed4b5cba826a = ({ issue: { issueKey: issueKey, summary: summary, projectName: projectName, status: status }, isActive: isActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d9e23d5c9ad5ce0a$var$searchResultContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$TopContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGkxR.TruncateWithTooltipOnActive), {
        isActive: !!isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$IssueKey, null, issueKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$IssueSummary, {
        active: isActive
    }, summary))), (status || projectName) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$BottomContainer, null, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d9e23d5c9ad5ce0a$var$statusStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: $d9e23d5c9ad5ce0a$export$995d7ae0c0293bac[status.statusCategoryId],
        maxWidth: 236
    }, status.statusName)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$ProjectName, {
        active: isActive
    }, projectName)));
const $d9e23d5c9ad5ce0a$var$searchResultContainerStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d9e23d5c9ad5ce0a$var$TopContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz41tcg _slp31hna _1nmz1hna",
            __cmplp.className
        ])
    });
});
const $d9e23d5c9ad5ce0a$var$IssueKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq _2hwx12x7 _1e0c1nu9",
            __cmplp.className
        ])
    });
});
const $d9e23d5c9ad5ce0a$var$IssueSummary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1nu9",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $d9e23d5c9ad5ce0a$var$BottomContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1txw _19pkv77o _syaz1gjq _vwz41kw7",
            __cmplp.className
        ])
    });
});
const $d9e23d5c9ad5ce0a$var$statusStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.150'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d9e23d5c9ad5ce0a$var$ProjectName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1 _vwz4gktf",
            __cmplp.active ? "_syaz1gjq" : "_syaz131l",
            __cmplp.className
        ])
    });
});

});



parcelRegister("bBHcB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2fd7492046662c20$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2fd7492046662c20$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    recentlyViewedIssues: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.recently-viewed-issues",
        "defaultMessage": "Recently Viewed Issues"
    },
    issueError: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.issue-error",
        "defaultMessage": "We're having trouble loading recently viewed issues. Try again in a few moments."
    },
    recentlyViewedIssuesIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.recently-viewed-issues-issue-term-refresh",
        "defaultMessage": "Recently viewed work items"
    },
    issueErrorIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.issue-error-issue-term-refresh",
        "defaultMessage": "We're having trouble loading recently viewed work items. Try again in a few moments."
    }
});

});


parcelRegister("3eTqY", function(module, exports) {

$parcel$export(module.exports, "useGetRecentPlansChildResult", () => $b7d349acd9c3db6d$export$ec02659dcd249bd6);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $9NCxG = parcelRequire("9NCxG");


var $gIysK = parcelRequire("gIysK");
const $b7d349acd9c3db6d$export$ec02659dcd249bd6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchPlanCommands: getQuickSearchPlanCommands } = (0, $9NCxG.useGetQuickSearchPlanCommands)({
        section: (0, $96f4cd972101fda7$export$501955bd67991a25),
        showViewAll: false
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [(0, $96f4cd972101fda7$export$501955bd67991a25)]: {
                id: (0, $96f4cd972101fda7$export$501955bd67991a25),
                name: formatMessage((0, $gIysK.messages).recentlyViewedPlans),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).PLANS
            }
        };
        const commands = getQuickSearchPlanCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchPlanCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("9NCxG", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchPlanCommands", () => $d40be781b173125f$export$668213efda00d797);

var $5uXOq = parcelRequire("5uXOq");

var $cPSNS = parcelRequire("cPSNS");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $9ReLB = parcelRequire("9ReLB");

var $bgCj3 = parcelRequire("bgCj3");

var $73ZzY = parcelRequire("73ZzY");

var $e5idJ = parcelRequire("e5idJ");
const $d40be781b173125f$export$668213efda00d797 = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getPlanCommand: getPlanCommand } = (0, $cPSNS.useGetPlanCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $73ZzY.useGetViewAllCommand)();
    const getQuickSearchPlanCommands = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const planScope = (0, $bgCj3.getQuickSearchPlanScope)(quickSearchResponseData);
        // No results
        if (!planScope || error || planScope?.error || planScope?.results?.length === 0) return [];
        const commands = planScope.results.slice(0, (0, $dmf5R.PLAN_LIMIT)).map((plan)=>getPlanCommand({
                plan: (0, $bgCj3.transformQuickSearchPlanResultToPlan)(plan),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            }));
        if (!showViewAll || planScope.results.length <= (0, $dmf5R.PLAN_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-plans',
            keywords: search,
            section: section,
            name: formatMessage((0, $9ReLB.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).PLAN, search),
            analyticsPayload: {
                action: 'viewAllPlans',
                size: planScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getPlanCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchPlanCommands: getQuickSearchPlanCommands
    };
};

});
parcelRegister("cPSNS", function(module, exports) {

$parcel$export(module.exports, "useGetPlanCommand", () => $3e2bb83f72c97086$export$69408f6c87099775);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4l54H = parcelRequire("4l54H");
const $3e2bb83f72c97086$export$69408f6c87099775 = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $4l54H.useTransformNavigationCommands)();
    const getPlanCommand = (0, $5uXOq.useCallback)(({ plan: plan, section: section, analytics: analytics, ...rest })=>{
        const { id: id, url: url, name: name } = plan;
        return transformNavigationCommand({
            id: `plan-${id}`,
            section: section,
            name: name,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e2bb83f72c97086$export$3eeaa2f0a53409a2, null)
            },
            analytics: {
                action: 'planViewed',
                planId: id,
                metadata: {
                    contentId: id,
                    containerId: 'UNAVAILABLE',
                    contentType: 'plan'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getPlanCommand: getPlanCommand
    };
};
const $3e2bb83f72c97086$export$3eeaa2f0a53409a2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e2bb83f72c97086$var$PlanLeftIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.44455 5.66667C6.015 5.66667 5.66677 6.01489 5.66677 6.44444C5.66677 6.874 6.015 7.22222 6.44455 7.22222H9.55566C9.98522 7.22222 10.3334 6.874 10.3334 6.44444C10.3334 6.01489 9.98522 5.66667 9.55566 5.66667H6.44455Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.44455 8.77778C6.44455 8.34822 6.79278 8 7.22233 8H10.3334C10.763 8 11.1112 8.34822 11.1112 8.77778C11.1112 9.20733 10.763 9.55556 10.3334 9.55556H7.22233C6.79278 9.55556 6.44455 9.20733 6.44455 8.77778Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.44455 10.3333C6.015 10.3333 5.66677 10.6816 5.66677 11.1111C5.66677 11.5407 6.015 11.8889 6.44455 11.8889H8.00011C8.42966 11.8889 8.77789 11.5407 8.77789 11.1111C8.77789 10.6816 8.42966 10.3333 8.00011 10.3333H6.44455Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.889 2.55556C4.889 1.69645 5.58544 1 6.44455 1H9.55566C10.4148 1 11.1112 1.69645 11.1112 2.55556H11.889C12.7481 2.55556 13.4446 3.252 13.4446 4.11111V13.4444C13.4446 14.3036 12.7481 15 11.889 15H4.11122C3.25211 15 2.55566 14.3036 2.55566 13.4444V4.11111C2.55566 3.252 3.25211 2.55556 4.11122 2.55556H4.889ZM9.55566 4.88889C10.1314 4.88889 10.6342 4.57607 10.9031 4.11111H11.889V13.4444H4.11122L4.11122 4.11111H5.0971C5.36607 4.57607 5.86878 4.88889 6.44455 4.88889H9.55566ZM9.55566 2.55556H6.44455V3.33333H9.55566V2.55556Z"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e2bb83f72c97086$var$PlanLeftIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4kb7n _13ti15vq _15jv15vq _n0baglyw _1m8i1osq _1azq1osq _11d61r31 _11ssyfq0",
            __cmplp.className
        ])
    });
});

});


const $96f4cd972101fda7$export$501955bd67991a25 = 'jira.plan';

parcelRegister("gIysK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fb619441bb92994c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fb619441bb92994c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    recentlyViewedPlans: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.plans.recently-viewed-plans",
        "defaultMessage": "Recently Viewed Plans"
    }
});

});


parcelRegister("2ZZwV", function(module, exports) {

$parcel$export(module.exports, "useGetRecentProjectsChildResult", () => $b4417f6a7643e6c0$export$1f6a5212707c0c74);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $i1jRv = parcelRequire("i1jRv");

var $6SKj1 = parcelRequire("6SKj1");
const $b4417f6a7643e6c0$var$SECTION_ID = 'jira.project';
const $b4417f6a7643e6c0$export$1f6a5212707c0c74 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchProjectCommands: getQuickSearchProjectCommands } = (0, $i1jRv.useGetQuickSearchProjectCommands)({
        section: $b4417f6a7643e6c0$var$SECTION_ID,
        showViewAll: false
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [$b4417f6a7643e6c0$var$SECTION_ID]: {
                id: $b4417f6a7643e6c0$var$SECTION_ID,
                name: formatMessage((0, $6SKj1.messages).recentlyViewedProjects),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).PROJECTS
            }
        };
        const commands = getQuickSearchProjectCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchProjectCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("i1jRv", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchProjectCommands", () => $662434420534e753$export$d434736854ef42ec);

var $5uXOq = parcelRequire("5uXOq");

var $aZ12W = parcelRequire("aZ12W");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $9ReLB = parcelRequire("9ReLB");

var $bgCj3 = parcelRequire("bgCj3");

var $73ZzY = parcelRequire("73ZzY");

var $e5idJ = parcelRequire("e5idJ");
const $662434420534e753$export$d434736854ef42ec = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getProjectCommand: getProjectCommand } = (0, $aZ12W.useGetProjectCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $73ZzY.useGetViewAllCommand)();
    const getQuickSearchProjectCommands = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const projectScope = (0, $bgCj3.getQuickSearchProjectScope)(quickSearchResponseData);
        // No results
        if (!projectScope || error || projectScope?.error || projectScope?.results?.length === 0) return [];
        // There are results!
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const commands = projectScope.results.slice(0, (0, $dmf5R.PROJECT_LIMIT)).map((project)=>getProjectCommand({
                project: (0, $bgCj3.transformQuickSearchProjectResultToProject)(project),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            })).filter((project)=>project);
        if (!showViewAll || projectScope.results.length <= (0, $dmf5R.PROJECT_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-projects',
            keywords: search,
            section: section,
            name: formatMessage((0, $9ReLB.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $e5idJ.getViewAllUrl)((0, $e5idJ.ViewAllType).PROJECT, search),
            analyticsPayload: {
                action: 'viewAllProjects',
                size: projectScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getProjectCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchProjectCommands: getQuickSearchProjectCommands
    };
};

});
parcelRegister("aZ12W", function(module, exports) {

$parcel$export(module.exports, "useGetProjectCommand", () => $63b43d5e6f1b8813$export$ea003d923e77b495);

var $5uXOq = parcelRequire("5uXOq");

var $4l54H = parcelRequire("4l54H");

var $f8hy9 = parcelRequire("f8hy9");
const $63b43d5e6f1b8813$export$ea003d923e77b495 = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $4l54H.useTransformNavigationCommands)();
    const getProjectCommand = (0, $5uXOq.useCallback)(({ project: project, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
        const { projectId: projectId, name: name, url: url, avatar: avatar, canView: canView } = project;
        if (!canView) return null;
        return transformNavigationCommand({
            id: `project-${projectId}`,
            section: section,
            keywords: keywords,
            name: name,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8hy9.ProjectLeftIcon), {
                        url: avatar.url,
                        name: name
                    })
            },
            analytics: {
                action: 'projectViewed',
                projectId: projectId,
                metadata: {
                    contentId: projectId,
                    containerId: 'UNAVAILABLE',
                    contentType: 'project'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getProjectCommand: getProjectCommand
    };
};

});
parcelRegister("f8hy9", function(module, exports) {

$parcel$export(module.exports, "ProjectLeftIcon", () => $242c5c58946a0dbd$export$423e89389ac007b0);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gxhFd = parcelRequire("gxhFd");
const $242c5c58946a0dbd$export$423e89389ac007b0 = ({ url: url, name: name })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: url,
        alt: formatMessage((0, $gxhFd.messages).issueIconAltText, {
            name: name
        }),
        height: "16"
    });
};

});
parcelRegister("gxhFd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $41c7d31c0e7473b6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $41c7d31c0e7473b6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.project.project-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the project {name}"
    }
});

});




parcelRegister("6SKj1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $879dfa2560394919$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $879dfa2560394919$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    recentlyViewedProjects: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.projects.recently-viewed-projects",
        "defaultMessage": "Recently Viewed Projects"
    }
});

});



parcelRegister("5mZMv", function(module, exports) {

$parcel$export(module.exports, "useGetSearchResults", () => $833c50f0d3c45952$export$bca2834c2ecfc5f9);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");

var $h9iZl = parcelRequire("h9iZl");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $JKfGz = parcelRequire("JKfGz");

var $5zDBm = parcelRequire("5zDBm");

var $hX4Eo = parcelRequire("hX4Eo");

var $c2I39 = parcelRequire("c2I39");

var $lLiuT = parcelRequire("lLiuT");

var $gaogX = parcelRequire("gaogX");

var $9Jgrf = parcelRequire("9Jgrf");

var $1WvJs = parcelRequire("1WvJs");

var $c2RuO = parcelRequire("c2RuO");
const $833c50f0d3c45952$export$bca2834c2ecfc5f9 = ()=>{
    const { getChildResult: getErrorChildResult } = (0, $JKfGz.useGetErrorChildResult)();
    const { getChildResult: getRecommendedChildResult } = (0, $5zDBm.useGetRecommendedChildResult)();
    const { getChildResult: getSearchIssuesChildResult } = (0, $9Jgrf.useGetSearchIssuesChildResult)();
    const { getChildResult: getSearchProjectsChildResult } = (0, $c2RuO.useGetSearchProjectsChildResult)();
    const { getChildResult: getSearchBoardsChildResult } = (0, $lLiuT.useGetSearchBoardsChildResult)();
    const { getChildResult: getSearchFiltersChildResult } = (0, $gaogX.useGetSearchFiltersChildResult)();
    const { getChildResult: getSearchPlansChildResult } = (0, $1WvJs.useGetSearchPlansChildResult)();
    const [hasEditOrViewPermissions] = (0, $h9iZl.useNavigationViewPlansPermission)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $hX4Eo.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    const getSearchResults = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        setTimeoutFunc(()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'searchResults shown', 'postQuerySearchResults', {
                ...(0, $c2I39.transformResultsForAnalytics)(quickSearchResponseData, false)
            });
        }, 0);
        return (0, $gM5ou.mergeChildResults)([
            getErrorChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecommendedChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchIssuesChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchProjectsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchBoardsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchFiltersChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            ...hasEditOrViewPermissions ? [
                getSearchPlansChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                })
            ] : []
        ]);
    }, [
        createAnalyticsEvent,
        getErrorChildResult,
        getRecommendedChildResult,
        getSearchBoardsChildResult,
        getSearchFiltersChildResult,
        getSearchIssuesChildResult,
        getSearchPlansChildResult,
        getSearchProjectsChildResult,
        hasEditOrViewPermissions,
        setTimeoutFunc
    ]);
    return getSearchResults;
};

});
parcelRegister("lLiuT", function(module, exports) {

$parcel$export(module.exports, "useGetSearchBoardsChildResult", () => $88c4ff99e9f621dc$export$894d6ed9a271a485);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $flylh = parcelRequire("flylh");

var $dmf5R = parcelRequire("dmf5R");


var $be7GP = parcelRequire("be7GP");
const $88c4ff99e9f621dc$export$894d6ed9a271a485 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchBoardCommands: getQuickSearchBoardCommands } = (0, $flylh.useGetQuickSearchBoardCommands)({
        section: (0, $9db33864c3ec79d1$export$501955bd67991a25),
        showViewAll: true
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [(0, $9db33864c3ec79d1$export$501955bd67991a25)]: {
                id: (0, $9db33864c3ec79d1$export$501955bd67991a25),
                name: formatMessage((0, $be7GP.messages).boards),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).BOARDS
            }
        };
        const commands = getQuickSearchBoardCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchBoardCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
const $9db33864c3ec79d1$export$501955bd67991a25 = 'jira.board';

parcelRegister("be7GP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa2de8cb98997fdf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $aa2de8cb98997fdf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    boards: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.boards.boards",
        "defaultMessage": "Boards"
    }
});

});


parcelRegister("gaogX", function(module, exports) {

$parcel$export(module.exports, "useGetSearchFiltersChildResult", () => $b64025b277191be0$export$679a1b8aea427942);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $8kcFW = parcelRequire("8kcFW");


var $4gL65 = parcelRequire("4gL65");
const $b64025b277191be0$export$679a1b8aea427942 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchFilterCommands: getQuickSearchFilterCommands } = (0, $8kcFW.useGetQuickSearchFilterCommands)({
        section: (0, $c830d1fbcd93a1f4$export$501955bd67991a25),
        showViewAll: true
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [(0, $c830d1fbcd93a1f4$export$501955bd67991a25)]: {
                id: (0, $c830d1fbcd93a1f4$export$501955bd67991a25),
                name: formatMessage((0, $4gL65.messages).filters),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).FILTERS
            }
        };
        const commands = getQuickSearchFilterCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchFilterCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
const $c830d1fbcd93a1f4$export$501955bd67991a25 = 'jira.filter';

parcelRegister("4gL65", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3b03efab368f8867$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3b03efab368f8867$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    filters: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.filters.filters",
        "defaultMessage": "Filters"
    }
});

});


parcelRegister("9Jgrf", function(module, exports) {

$parcel$export(module.exports, "useGetSearchIssuesChildResult", () => $9793044f8c06d022$export$87713fad27eebcf1);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $hzB87 = parcelRequire("hzB87");

var $1URUx = parcelRequire("1URUx");
const $9793044f8c06d022$var$SECTION_ID = 'jira.issue';
const $9793044f8c06d022$export$87713fad27eebcf1 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchIssueCommands: getQuickSearchIssueCommands } = (0, $hzB87.useGetQuickSearchIssueCommands)({
        section: $9793044f8c06d022$var$SECTION_ID,
        errorMessage: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $1URUx.messages).issueErrorIssueTermRefresh : (0, $1URUx.messages).issueError),
        showViewAll: true
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [$9793044f8c06d022$var$SECTION_ID]: {
                id: $9793044f8c06d022$var$SECTION_ID,
                name: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $1URUx.messages).issuesIssueTermRefresh : (0, $1URUx.messages).issues),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).ISSUES
            }
        };
        const commands = getQuickSearchIssueCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchIssueCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("1URUx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $47497f421fc59186$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $47497f421fc59186$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueError: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issue-error",
        "defaultMessage": "We\u2019re having trouble searching issues. You can try again in a few moments."
    },
    issues: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issues",
        "defaultMessage": "Issues"
    },
    issueErrorIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issue-error-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble searching work items. You can try again in a few moments."
    },
    issuesIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    }
});

});


parcelRegister("1WvJs", function(module, exports) {

$parcel$export(module.exports, "useGetSearchPlansChildResult", () => $e32d9815c94026cd$export$fc9d0a774ff010f1);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $9NCxG = parcelRequire("9NCxG");


var $d0qEo = parcelRequire("d0qEo");
const $e32d9815c94026cd$export$fc9d0a774ff010f1 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchPlanCommands: getQuickSearchPlanCommands } = (0, $9NCxG.useGetQuickSearchPlanCommands)({
        section: (0, $fa2f1ec5e9dfa50d$export$501955bd67991a25),
        showViewAll: true
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [(0, $fa2f1ec5e9dfa50d$export$501955bd67991a25)]: {
                id: (0, $fa2f1ec5e9dfa50d$export$501955bd67991a25),
                name: formatMessage((0, $d0qEo.messages).plans),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).PLANS
            }
        };
        const commands = getQuickSearchPlanCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchPlanCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
const $fa2f1ec5e9dfa50d$export$501955bd67991a25 = 'jira.plan';

parcelRegister("d0qEo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9f7215f09d1073bd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9f7215f09d1073bd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    plans: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.plans.plans",
        "defaultMessage": "Plans"
    }
});

});


parcelRegister("c2RuO", function(module, exports) {

$parcel$export(module.exports, "useGetSearchProjectsChildResult", () => $703c5598a8fdd0ed$export$e18d773eb3827574);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dmf5R = parcelRequire("dmf5R");

var $i1jRv = parcelRequire("i1jRv");

var $lJcHJ = parcelRequire("lJcHJ");
const $703c5598a8fdd0ed$var$SECTION_ID = 'jira.project';
const $703c5598a8fdd0ed$export$e18d773eb3827574 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getQuickSearchProjectCommands: getQuickSearchProjectCommands } = (0, $i1jRv.useGetQuickSearchProjectCommands)({
        section: $703c5598a8fdd0ed$var$SECTION_ID,
        showViewAll: true
    });
    const getChildResult = (0, $5uXOq.useCallback)((props)=>{
        const sections = {
            [$703c5598a8fdd0ed$var$SECTION_ID]: {
                id: $703c5598a8fdd0ed$var$SECTION_ID,
                name: formatMessage((0, $lJcHJ.messages).projects),
                priority: (0, $dmf5R.QUICK_SEARCH_PRIORITY).PROJECTS
            }
        };
        const commands = getQuickSearchProjectCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchProjectCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("lJcHJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8373ba575134fc5e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8373ba575134fc5e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.projects.projects",
        "defaultMessage": "Projects"
    }
});

});




parcelRegister("cy1Ju", function(module, exports) {

$parcel$export(module.exports, "QuickSearchChildWrapper", () => $155f5b8355a77d5d$export$85ee85d7d315a747);

var $5uXOq = parcelRequire("5uXOq");

var $gjt52 = parcelRequire("gjt52");

var $18wuq = parcelRequire("18wuq");

var $bFaKi = parcelRequire("bFaKi");
const $155f5b8355a77d5d$export$85ee85d7d315a747 = ({ children: children })=>{
    const [attributes, { reset: reset }] = (0, $gjt52.useQuickSearchAnalyticsAttributes)();
    (0, $5uXOq.useEffect)(()=>{
        reset();
        return ()=>{
            reset();
        };
    }, [
        reset
    ]);
    const shouldFireScreenAnalytics = attributes.queryVersion >= 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $18wuq.QuickSearchWrapper), null, shouldFireScreenAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bFaKi.QuickSearchFireScreenAnalytics), null), children);
};

});
parcelRegister("18wuq", function(module, exports) {

$parcel$export(module.exports, "QuickSearchWrapper", () => $c5eeb66c5ad1d34b$export$2398c0852f2402a1);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $gjt52 = parcelRequire("gjt52");
const $c5eeb66c5ad1d34b$export$2398c0852f2402a1 = ({ children: children })=>{
    const [attributes] = (0, $gjt52.useQuickSearchAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraCommandPaletteQuickSearch",
        id: "quick-search",
        teamName: "deliveroo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, children));
};

});

parcelRegister("bFaKi", function(module, exports) {

$parcel$export(module.exports, "QuickSearchFireScreenAnalytics", () => $9c588ae7c7c47ec2$export$7b8039e0ef5a7b1b);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $gjt52 = parcelRequire("gjt52");
const $9c588ae7c7c47ec2$export$7b8039e0ef5a7b1b = ()=>{
    const [{ query: query }] = (0, $gjt52.useQuickSearchAnalytics)();
    const isSearch = (0, $5uXOq.useMemo)(()=>Boolean(query?.length), [
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: isSearch ? 'searchCommandPalettePostQuery' : 'searchCommandPalettePreQuery',
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};

});



parcelRegister("h2Vnd", function(module, exports) {

$parcel$export(module.exports, "useCommandPaletteRegistry", () => $8a5112967b14f6b6$export$843ca10488699b0c);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $1Kt4o = parcelRequire("1Kt4o");
const $8a5112967b14f6b6$export$843ca10488699b0c = ()=>{
    const { setRegistry: setRegistry } = (0, $d8lE2.useActionsCommandPalette)();
    (0, $5uXOq.useState)(()=>{
        setRegistry((0, $1Kt4o.COMMAND_PALETTE_REGISTRY));
    });
};

});

parcelRegister("bbRjE", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteModal", () => $5656caada5aa2e19$export$9b347310d90ce55);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $i8Qvm = parcelRequire("i8Qvm");

var $eTXmK = parcelRequire("eTXmK");

var $koVbs = parcelRequire("koVbs");

var $7NYq5 = parcelRequire("7NYq5");

var $bcTvL = parcelRequire("bcTvL");

var $d8lE2 = parcelRequire("d8lE2");


var $7idav = parcelRequire("7idav");

var $9gmuM = parcelRequire("9gmuM");

var $aV3mV = parcelRequire("aV3mV");
const $5656caada5aa2e19$export$9b347310d90ce55 = ({ defaultAriaLabel: defaultAriaLabel, defaultPlaceholder: defaultPlaceholder, defaultFooterContent: defaultFooterContent, onAnalytics: onAnalytics, onErrorAnalytics: onErrorAnalytics, defaultFallback: defaultFallback, rootFallback: rootFallback })=>{
    const [{ commandPaletteSessionId: commandPaletteSessionId, isOpen: isOpen, hasPopupOverlay: hasPopupOverlay }, { close: close, markAsLoaded: markAsLoaded, setAnalytics: setAnalytics }] = (0, $d8lE2.useCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        setAnalytics(onAnalytics, onErrorAnalytics);
    }, [
        onAnalytics,
        onErrorAnalytics,
        setAnalytics
    ]);
    const sendAnalyticsEvent = (0, $5uXOq.useCallback)((action)=>{
        const ev = createAnalyticsEvent({
            action: action,
            actionSubject: 'commandPalette'
        });
        if (onAnalytics) onAnalytics(ev, (0, $bcTvL.UI_EVENT_TYPE), {
            attributes: {
                commandPaletteSessionId: commandPaletteSessionId
            }
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        onAnalytics
    ]);
    const onEscPressed = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Escape' && isOpen) {
            event.preventDefault();
            event.stopPropagation();
            sendAnalyticsEvent('closed');
            (0, $eTXmK.default)('command-palette-closed');
            close();
        }
    }, [
        isOpen,
        sendAnalyticsEvent,
        close
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasPopupOverlay) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('keydown', onEscPressed, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('keydown', onEscPressed, true);
        };
    }, [
        hasPopupOverlay,
        onEscPressed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        markAsLoaded();
    }, [
        markAsLoaded
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        sendAnalyticsEvent('closed');
        (0, $eTXmK.default)('command-palette-closed');
        close();
    }, [
        sendAnalyticsEvent,
        close
    ]);
    const onOpenComplete = (0, $5uXOq.useCallback)(()=>{
        sendAnalyticsEvent('viewed');
    }, [
        sendAnalyticsEvent
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        onClose: onClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEscapePress: true,
        autoFocus: false,
        testId: (0, $898ce3b7997b47d8$export$7622d28bacf170d1),
        onOpenComplete: onOpenComplete,
        width: 752,
        isBlanketHidden: true,
        label: formatMessage((0, $7idav.messages).modalLabel),
        messageId: "command-palette.ui.modal.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aV3mV.ModalWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gmuM.ModalContent), {
        defaultAriaLabel: defaultAriaLabel,
        defaultFallback: defaultFallback,
        rootFallback: rootFallback,
        defaultPlaceholder: defaultPlaceholder,
        defaultFooterContent: defaultFooterContent,
        onClose: onClose
    }))));
};

});
const $898ce3b7997b47d8$export$7622d28bacf170d1 = 'command-palette.ui.modal.modal-dialog';

parcelRegister("7idav", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df55570f72dcd4e3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $df55570f72dcd4e3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    modalLabel: {
        "id": "command-palette.modal.modal-label",
        "defaultMessage": "Command palette modal"
    }
});

});

parcelRegister("9gmuM", function(module, exports) {

$parcel$export(module.exports, "ModalContent", () => $a9a31ea88bba7cd5$export$6da19a24bf249f17);

var $5uXOq = parcelRequire("5uXOq");

var $l8ruj = parcelRequire("l8ruj");

var $dOktC = parcelRequire("dOktC");

var $d8lE2 = parcelRequire("d8lE2");

var $2c1yN = parcelRequire("2c1yN");

var $fChlq = parcelRequire("fChlq");

var $bgJTS = parcelRequire("bgJTS");

var $eNg6o = parcelRequire("eNg6o");

var $3OYpW = parcelRequire("3OYpW");


var $2mlNs = parcelRequire("2mlNs");

var $5c7Xb = parcelRequire("5c7Xb");

var $5nIJM = parcelRequire("5nIJM");
const $a9a31ea88bba7cd5$export$6da19a24bf249f17 = ({ defaultAriaLabel: defaultAriaLabel, defaultFallback: defaultFallback, rootFallback: rootFallback, defaultPlaceholder: defaultPlaceholder, defaultFooterContent: defaultFooterContent, onClose: onClose })=>{
    const { total: total, fallback: fallback, results: results, renderAfterCommands: renderAfterCommands, activeCommand: activeCommand } = (0, $2c1yN.useMatches)({
        defaultFallback: defaultFallback,
        rootFallback: rootFallback
    });
    const [registryData] = (0, $d8lE2.useCommandPaletteRegistryCurrentAttribution)();
    (0, $bgJTS.usePerformPendingCommandOnClose)();
    (0, $fChlq.usePerformMode)();
    // Typing as any so we can pass the prop to the UFO Segment using ffs without typescript/react errors
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5c7Xb.default), {
        onClose: onClose,
        defaultAriaLabel: defaultAriaLabel,
        defaultPlaceholder: defaultPlaceholder,
        results: results,
        activeCommand: activeCommand
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "command-palette-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNg6o.CommandBodyErrorBoundary), {
        teamName: registryData?.registryData?.teamName || 'deliveroo',
        attributes: registryData?.analyticsAttributes,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOktC.NoResultsContainer), {
                "data-testid": (0, $621e16c24c54300b$export$3545956e927a0d0a)
            }, fallback?.onError?.renderLabel?.() || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fallback?.onError?.label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OYpW.Body), {
        fallback: fallback,
        results: results,
        total: total,
        renderAfterCommands: renderAfterCommands
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5nIJM.ScreenReaderContent), {
        activeCommand: activeCommand,
        results: results
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mlNs.Footer), {
        defaultFooterContent: defaultFooterContent,
        activeCommand: activeCommand
    }));
};

});
parcelRegister("2c1yN", function(module, exports) {

$parcel$export(module.exports, "useMatches", () => $7bee86b4b24e2871$export$2378eb7f5ff86053);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $a2Y5o = parcelRequire("a2Y5o");

var $d8lE2 = parcelRequire("d8lE2");

var $ivHpc = parcelRequire("ivHpc");

var $4SX9W = parcelRequire("4SX9W");

var $cPq6h = parcelRequire("cPq6h");
const $7bee86b4b24e2871$export$2378eb7f5ff86053 = ({ defaultFallback: defaultFallback, rootFallback: rootFallback })=>{
    const [{ commands: commands, expandedCommand: expandedCommand, childResult: childResult, loadingList: loadingList, sections: sections, fallbackOverride: fallbackOverride }] = (0, $d8lE2.useCommandPalette)();
    const [search] = (0, $ivHpc.useCommandPaletteSearchDebounced)();
    const hasLoadChildren = (0, $gM5ou.hasChildren)(expandedCommand);
    const selectedCommands = (0, $5uXOq.useMemo)(()=>hasLoadChildren ? childResult?.commands || [] : commands, [
        hasLoadChildren,
        childResult?.commands,
        commands
    ]);
    const selectedSections = (0, $5uXOq.useMemo)(()=>hasLoadChildren ? childResult?.sections : (0, $gM5ou.mergeSections)(sections), [
        hasLoadChildren,
        childResult?.sections,
        sections
    ]);
    const filterCommandsOverride = (0, $5uXOq.useMemo)(()=>(0, $4DwnT.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.filterAndSortOverrideFn, [
        expandedCommand
    ]);
    const flattenedResults = (0, $cPq6h.useSortAndFilter)(search, selectedCommands, selectedSections, filterCommandsOverride);
    const fallback = (0, $5uXOq.useMemo)(()=>(0, $4SX9W.getFallback)({
            rootFallback: rootFallback,
            defaultFallback: defaultFallback,
            expandedCommand: expandedCommand,
            noResults: Boolean(flattenedResults.results.length === 0 && !loadingList),
            fallbackOverride: fallbackOverride
        }), [
        defaultFallback,
        expandedCommand,
        fallbackOverride,
        flattenedResults.results.length,
        loadingList,
        rootFallback
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if ((0, $4DwnT.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.shouldShowNoCommandsWhileLoading && loadingList) return {
            results: [],
            total: 0
        };
        const fallbackCommandResult = (0, $a2Y5o.getFallbackCommandResult)(fallback);
        if (fallbackCommandResult) return fallbackCommandResult;
        return {
            ...flattenedResults,
            fallback: fallback
        };
    }, [
        expandedCommand,
        fallback,
        flattenedResults,
        loadingList
    ]);
};

});
parcelRegister("a2Y5o", function(module, exports) {

$parcel$export(module.exports, "getFallbackCommandResult", () => $71360b39d14851cd$export$f6daf99735e387a3);
const $71360b39d14851cd$export$f6daf99735e387a3 = (fallback)=>{
    if (!fallback || !fallback?.onNoResults?.fallbackCommand) return undefined;
    const { fallbackCommand: fallbackCommand, fallbackSection: fallbackSection } = fallback.onNoResults;
    const section = fallbackSection;
    const fallbackCommandHeader = fallbackCommand && section ? {
        ...section.renderName ? {
            renderGroup: section.renderName
        } : {
            group: section.name
        },
        isGroup: true
    } : undefined;
    return {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        results: [
            fallbackCommandHeader,
            {
                command: fallbackCommand,
                active: true,
                index: 0
            }
        ].filter(Boolean),
        total: 1,
        activeCommand: fallbackCommand,
        fallback: fallback
    };
};

});

parcelRegister("ivHpc", function(module, exports) {

$parcel$export(module.exports, "useCommandPaletteSearchDebounced", () => $2636035def55b2ae$export$f36a4bb9041c3f69);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $bcTvL = parcelRequire("bcTvL");

var $d8lE2 = parcelRequire("d8lE2");
const $2636035def55b2ae$export$f36a4bb9041c3f69 = (debounceTime = (0, $bcTvL.COMMAND_PALETTE_DEBOUNCE_DEFAULT))=>{
    const [{ search: search }, { handleSearch: handleSearch }] = (0, $d8lE2.useCommandPaletteSearch)();
    const [debouncedSearch, setDebouncedSearch] = (0, $5uXOq.useState)(search);
    const debouncedSetSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(setDebouncedSearch, debounceTime), [
        debounceTime
    ]);
    (0, $5uXOq.useEffect)(()=>{
        debouncedSetSearch(search);
    }, [
        debouncedSetSearch,
        search
    ]);
    (0, $5uXOq.useEffect)(()=>()=>debouncedSetSearch.cancel(), [
        debouncedSetSearch
    ]);
    const setSearch = (0, $5uXOq.useCallback)((newSearch)=>{
        debouncedSetSearch.cancel();
        handleSearch(newSearch);
        setDebouncedSearch(newSearch);
    }, [
        debouncedSetSearch,
        handleSearch
    ]);
    return (0, $5uXOq.useMemo)(()=>[
            debouncedSearch,
            setSearch
        ], [
        debouncedSearch,
        setSearch
    ]);
};

});

parcelRegister("4SX9W", function(module, exports) {

$parcel$export(module.exports, "getFallback", () => $616b5b5588a59ff4$export$ad095be9c56d0fc8);

var $4DwnT = parcelRequire("4DwnT");
const $616b5b5588a59ff4$export$ad095be9c56d0fc8 = ({ defaultFallback: defaultFallback, rootFallback: rootFallback, expandedCommand: expandedCommand, noResults: noResults, fallbackOverride: fallbackOverride })=>{
    const rootNoResultsFallback = rootFallback ? {
        onNoResults: rootFallback
    } : undefined;
    if (fallbackOverride) return {
        ...rootNoResultsFallback,
        ...fallbackOverride,
        ...!noResults && {
            onNoResults: undefined
        }
    };
    const wasSecondaryTriggered = expandedCommand?.wasSecondaryTriggered;
    const activeCommandList = (0, $4DwnT.getActiveCommandList)(expandedCommand, wasSecondaryTriggered);
    const commandFallback = activeCommandList?.fallback;
    if (!defaultFallback && !commandFallback && !rootNoResultsFallback) return undefined;
    return {
        ...rootNoResultsFallback,
        ...expandedCommand ? defaultFallback : {},
        ...commandFallback,
        ...!noResults && {
            onNoResults: undefined
        }
    };
};

});

parcelRegister("cPq6h", function(module, exports) {

$parcel$export(module.exports, "useSortAndFilter", () => $9cd78317b9fc124c$export$329b92741e754bfe);

var $5uXOq = parcelRequire("5uXOq");

var $l87OC = parcelRequire("l87OC");

var $fVoBn = parcelRequire("fVoBn");

var $d8lE2 = parcelRequire("d8lE2");

var $aRVi7 = parcelRequire("aRVi7");

var $16iJP = parcelRequire("16iJP");

var $6dRZA = parcelRequire("6dRZA");

var $Nytob = parcelRequire("Nytob");
const $9cd78317b9fc124c$export$329b92741e754bfe = (search, selectedCommands, selectedSections, filterCommandsOverride)=>{
    const queryKeywordCount = (0, $5uXOq.useMemo)(()=>search.trim().split(' ').filter(Boolean).length, [
        search
    ]);
    const searchableCommands = (0, $6dRZA.useSearchableCommands)(selectedCommands);
    const [{ activeIndex: activeIndex }] = (0, $d8lE2.useCommandPalette)();
    const fuse = (0, $5uXOq.useMemo)(()=>(0, $16iJP.createFuseFromCommands)(searchableCommands, queryKeywordCount), [
        searchableCommands,
        queryKeywordCount
    ]);
    const sortedAndFilteredCommands = (0, $5uXOq.useMemo)(()=>{
        if (filterCommandsOverride) return filterCommandsOverride(search, selectedCommands, selectedSections);
        let filteredCommands;
        if (!search.trim().toLowerCase().length) filteredCommands = selectedCommands.map((command)=>({
                ...command,
                searchRelevancyScore: 1
            }));
        else {
            const fuseResults = (0, $16iJP.searchFuseIndex)(fuse, search);
            filteredCommands = (0, $aRVi7.filterCommandsFromSearch)(search, fuseResults, searchableCommands);
        }
        return (0, $Nytob.sortCommands)(filteredCommands, selectedSections);
    }, [
        filterCommandsOverride,
        fuse,
        search,
        searchableCommands,
        selectedCommands,
        selectedSections
    ]);
    const groupedCommands = (0, $5uXOq.useMemo)(()=>(0, $fVoBn.getGroupedCommands)(sortedAndFilteredCommands, selectedSections), [
        selectedSections,
        sortedAndFilteredCommands
    ]);
    const commandMatches = (0, $5uXOq.useMemo)(()=>(0, $l87OC.getFlattenedResults)(groupedCommands, activeIndex), [
        groupedCommands,
        activeIndex
    ]);
    return commandMatches;
};

});
parcelRegister("l87OC", function(module, exports) {

$parcel$export(module.exports, "getFlattenedResults", () => $a244ed78c982107b$export$2915eee4e3cdb2f0);
const $a244ed78c982107b$export$2915eee4e3cdb2f0 = (groupedCommands, activeIndex)=>{
    const ungroupedCommands = groupedCommands.ungrouped.slice(0);
    let results = ungroupedCommands;
    const sortedGroups = Object.values(groupedCommands.grouped);
    sortedGroups.forEach(({ id: id, group: group, renderGroup: renderGroup, commands: groupCommands })=>{
        results = results.concat({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...renderGroup ? {
                renderGroup: renderGroup
            } : {
                group: group
            },
            isGroup: true,
            id: id
        }, groupCommands);
    });
    const hasAction = (listed)=>Boolean(listed.command.primaryAction || listed.command.secondaryAction);
    let index = 0;
    let totalActionableCommands = 0;
    let activeCommand;
    let sectionIndex = -1;
    let indexWithinSection = 0;
    let sectionId;
    results = results.map((result)=>{
        if (result.isGroup) {
            const newResult = result;
            indexWithinSection = 0;
            sectionIndex += 1;
            newResult.index = sectionIndex;
            sectionId = result.id;
        }
        if (!result.isGroup) {
            const newResult = result;
            if (hasAction(result)) {
                newResult.index = index;
                index += 1;
                totalActionableCommands += 1;
                newResult.active = activeIndex === result.index;
            }
            newResult.indexWithinSection = indexWithinSection;
            newResult.sectionIndex = sectionIndex;
            newResult.sectionId = sectionId;
            indexWithinSection += 1;
            if (newResult.active) activeCommand = newResult.command;
            return newResult;
        }
        return result;
    });
    return {
        results: results,
        total: totalActionableCommands,
        activeCommand: activeCommand
    };
};

});

parcelRegister("fVoBn", function(module, exports) {

$parcel$export(module.exports, "getGroupedCommands", () => $691c7859c3b26655$export$30f49bc6f46f80dd);
const $691c7859c3b26655$export$30f49bc6f46f80dd = (commands, sections)=>commands.reduce((acc, command)=>{
        const listedCommand = {
            command: command
        };
        const createGroup = (id, section)=>{
            if (!acc.grouped.some((group)=>group.id === id)) acc.grouped.push({
                ...section.renderName ? {
                    renderGroup: section.renderName
                } : {
                    group: section.name
                },
                id: id,
                priority: section.priority,
                commands: []
            });
        };
        /**
			 * Add command to the group
			 */ const addCommandGroup = (name, newCommand)=>{
            acc.grouped.find((group)=>group.id === name)?.commands.push(newCommand);
        };
        const section = !!command.section && sections?.[command.section];
        if (section) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const id = command.section;
            createGroup?.(id, section);
            addCommandGroup(id, listedCommand);
        } else acc.ungrouped.push(listedCommand);
        acc.length += 1;
        return acc;
    }, {
        grouped: [],
        ungrouped: [],
        length: 0
    });

});

parcelRegister("aRVi7", function(module, exports) {

$parcel$export(module.exports, "filterCommandsFromSearch", () => $97a1382624453719$export$552543cdf42ae2bf);
const $97a1382624453719$export$552543cdf42ae2bf = (search, fuseResults, commands)=>{
    const trimmedSearch = search.trim().toLowerCase();
    if (!trimmedSearch.length) return commands.map((command)=>({
            ...command,
            searchRelevancyScore: 1
        }));
    return commands.flatMap((command)=>{
        const fuseResult = fuseResults.find((result)=>result.item.id === command.id);
        if (fuseResult) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            {
                ...command,
                searchRelevancyScore: fuseResult.score
            }
        ]; // includeScore is true, will always return a number
        return [];
    });
};

});

parcelRegister("16iJP", function(module, exports) {

$parcel$export(module.exports, "createFuseFromCommands", () => $9b94410daf45f1f8$export$3047320e6ed5178f);
$parcel$export(module.exports, "searchFuseIndex", () => $9b94410daf45f1f8$export$17e53d0bddbf4060);

var $eqCsX = parcelRequire("eqCsX");

var $7WupW = parcelRequire("7WupW");
const $9b94410daf45f1f8$export$dee16a5b7a115788 = (queryKeywordCount = 1)=>({
        ...(0, $7WupW.FUSE_SEARCH_OPTIONS),
        keys: (0, $7WupW.FUSE_SEARCH_OPTIONS).keys?.map((key)=>typeof key === 'object' && 'name' in key ? {
                ...key,
                weight: key.name === 'searchKeywordsArray' ? (key.weight ?? 1) / Math.max(queryKeywordCount, 1) : key.weight
            } : key)
    });
const $9b94410daf45f1f8$export$3047320e6ed5178f = (allCommands, queryKeywordCount = 1)=>new (0, $eqCsX.default)(allCommands, $9b94410daf45f1f8$export$dee16a5b7a115788(queryKeywordCount));
const $9b94410daf45f1f8$export$17e53d0bddbf4060 = (fuse, query)=>fuse.search({
        $or: [
            {
                name: query
            },
            {
                shortcut: query
            },
            {
                sectionName: query
            },
            {
                $or: query.split(' ').map((word)=>({
                        searchKeywordsArray: word
                    }))
            }
        ]
    });

});
parcelRegister("eqCsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a81154f2549cb822$export$2e2bcd8739ae039);
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $a81154f2549cb822$var$isArray(value) {
    return !Array.isArray ? $a81154f2549cb822$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $a81154f2549cb822$var$INFINITY = 1 / 0;
function $a81154f2549cb822$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$a81154f2549cb822$var$INFINITY ? '-0' : result;
}
function $a81154f2549cb822$var$toString(value) {
    return value == null ? '' : $a81154f2549cb822$var$baseToString(value);
}
function $a81154f2549cb822$var$isString(value) {
    return typeof value === 'string';
}
function $a81154f2549cb822$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $a81154f2549cb822$var$isBoolean(value) {
    return value === true || value === false || $a81154f2549cb822$var$isObjectLike(value) && $a81154f2549cb822$var$getTag(value) == '[object Boolean]';
}
function $a81154f2549cb822$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $a81154f2549cb822$var$isObjectLike(value) {
    return $a81154f2549cb822$var$isObject(value) && value !== null;
}
function $a81154f2549cb822$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $a81154f2549cb822$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $a81154f2549cb822$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $a81154f2549cb822$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $a81154f2549cb822$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $a81154f2549cb822$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $a81154f2549cb822$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $a81154f2549cb822$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $a81154f2549cb822$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $a81154f2549cb822$var$hasOwn = Object.prototype.hasOwnProperty;
class $a81154f2549cb822$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $a81154f2549cb822$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $a81154f2549cb822$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($a81154f2549cb822$var$isString(key) || $a81154f2549cb822$var$isArray(key)) {
        src = key;
        path = $a81154f2549cb822$var$createKeyPath(key);
        id = $a81154f2549cb822$var$createKeyId(key);
    } else {
        if (!$a81154f2549cb822$var$hasOwn.call(key, 'name')) throw new Error($a81154f2549cb822$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($a81154f2549cb822$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($a81154f2549cb822$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $a81154f2549cb822$var$createKeyPath(name);
        id = $a81154f2549cb822$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $a81154f2549cb822$var$createKeyPath(key) {
    return $a81154f2549cb822$var$isArray(key) ? key : key.split('.');
}
function $a81154f2549cb822$var$createKeyId(key) {
    return $a81154f2549cb822$var$isArray(key) ? key.join('.') : key;
}
function $a81154f2549cb822$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$a81154f2549cb822$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$a81154f2549cb822$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($a81154f2549cb822$var$isString(value) || $a81154f2549cb822$var$isNumber(value) || $a81154f2549cb822$var$isBoolean(value))) list.push($a81154f2549cb822$var$toString(value));
            else if ($a81154f2549cb822$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $a81154f2549cb822$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $a81154f2549cb822$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $a81154f2549cb822$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $a81154f2549cb822$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $a81154f2549cb822$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $a81154f2549cb822$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $a81154f2549cb822$var$Config = {
    ...$a81154f2549cb822$var$BasicOptions,
    ...$a81154f2549cb822$var$MatchOptions,
    ...$a81154f2549cb822$var$FuzzyOptions,
    ...$a81154f2549cb822$var$AdvancedOptions
};
const $a81154f2549cb822$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $a81154f2549cb822$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($a81154f2549cb822$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $a81154f2549cb822$var$FuseIndex {
    constructor({ getFn: getFn = $a81154f2549cb822$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a81154f2549cb822$var$Config.fieldNormWeight } = {}){
        this.norm = $a81154f2549cb822$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($a81154f2549cb822$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($a81154f2549cb822$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$a81154f2549cb822$var$isDefined(doc) || $a81154f2549cb822$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$a81154f2549cb822$var$isDefined(value)) return;
            if ($a81154f2549cb822$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$a81154f2549cb822$var$isDefined(value)) continue;
                    if ($a81154f2549cb822$var$isString(value) && !$a81154f2549cb822$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($a81154f2549cb822$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($a81154f2549cb822$var$isString(value) && !$a81154f2549cb822$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $a81154f2549cb822$var$createIndex(keys, docs, { getFn: getFn = $a81154f2549cb822$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a81154f2549cb822$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $a81154f2549cb822$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($a81154f2549cb822$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $a81154f2549cb822$var$parseIndex(data, { getFn: getFn = $a81154f2549cb822$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a81154f2549cb822$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $a81154f2549cb822$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $a81154f2549cb822$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $a81154f2549cb822$var$Config.distance, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $a81154f2549cb822$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $a81154f2549cb822$var$MAX_BITS = 32;
function $a81154f2549cb822$var$search(text, pattern, patternAlphabet, { location: location = $a81154f2549cb822$var$Config.location, distance: distance = $a81154f2549cb822$var$Config.distance, threshold: threshold = $a81154f2549cb822$var$Config.threshold, findAllMatches: findAllMatches = $a81154f2549cb822$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength, includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $a81154f2549cb822$var$MAX_BITS) throw new Error($a81154f2549cb822$var$PATTERN_LENGTH_TOO_LARGE($a81154f2549cb822$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $a81154f2549cb822$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $a81154f2549cb822$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $a81154f2549cb822$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $a81154f2549cb822$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $a81154f2549cb822$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $a81154f2549cb822$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $a81154f2549cb822$var$BitapSearch {
    constructor(pattern, { location: location = $a81154f2549cb822$var$Config.location, threshold: threshold = $a81154f2549cb822$var$Config.threshold, distance: distance = $a81154f2549cb822$var$Config.distance, includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, findAllMatches: findAllMatches = $a81154f2549cb822$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a81154f2549cb822$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $a81154f2549cb822$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $a81154f2549cb822$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $a81154f2549cb822$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $a81154f2549cb822$var$MAX_BITS), i);
                i += $a81154f2549cb822$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $a81154f2549cb822$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $a81154f2549cb822$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $a81154f2549cb822$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $a81154f2549cb822$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $a81154f2549cb822$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $a81154f2549cb822$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $a81154f2549cb822$var$ExactMatch extends $a81154f2549cb822$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $a81154f2549cb822$var$InverseExactMatch extends $a81154f2549cb822$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $a81154f2549cb822$var$PrefixExactMatch extends $a81154f2549cb822$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $a81154f2549cb822$var$InversePrefixExactMatch extends $a81154f2549cb822$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $a81154f2549cb822$var$SuffixExactMatch extends $a81154f2549cb822$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $a81154f2549cb822$var$InverseSuffixExactMatch extends $a81154f2549cb822$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $a81154f2549cb822$var$FuzzyMatch extends $a81154f2549cb822$var$BaseMatch {
    constructor(pattern, { location: location = $a81154f2549cb822$var$Config.location, threshold: threshold = $a81154f2549cb822$var$Config.threshold, distance: distance = $a81154f2549cb822$var$Config.distance, includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, findAllMatches: findAllMatches = $a81154f2549cb822$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a81154f2549cb822$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $a81154f2549cb822$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $a81154f2549cb822$var$IncludeMatch extends $a81154f2549cb822$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $a81154f2549cb822$var$searchers = [
    $a81154f2549cb822$var$ExactMatch,
    $a81154f2549cb822$var$IncludeMatch,
    $a81154f2549cb822$var$PrefixExactMatch,
    $a81154f2549cb822$var$InversePrefixExactMatch,
    $a81154f2549cb822$var$InverseSuffixExactMatch,
    $a81154f2549cb822$var$SuffixExactMatch,
    $a81154f2549cb822$var$InverseExactMatch,
    $a81154f2549cb822$var$FuzzyMatch
];
const $a81154f2549cb822$var$searchersLen = $a81154f2549cb822$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $a81154f2549cb822$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $a81154f2549cb822$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $a81154f2549cb822$var$parseQuery(pattern, options = {}) {
    return pattern.split($a81154f2549cb822$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($a81154f2549cb822$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $a81154f2549cb822$var$searchersLen){
                const searcher = $a81154f2549cb822$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $a81154f2549cb822$var$searchersLen){
                const searcher = $a81154f2549cb822$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $a81154f2549cb822$var$MultiMatchSet = new Set([
    $a81154f2549cb822$var$FuzzyMatch.type,
    $a81154f2549cb822$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $a81154f2549cb822$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $a81154f2549cb822$var$Config.isCaseSensitive, includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation, findAllMatches: findAllMatches = $a81154f2549cb822$var$Config.findAllMatches, location: location = $a81154f2549cb822$var$Config.location, threshold: threshold = $a81154f2549cb822$var$Config.threshold, distance: distance = $a81154f2549cb822$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $a81154f2549cb822$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($a81154f2549cb822$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $a81154f2549cb822$var$registeredSearchers = [];
function $a81154f2549cb822$var$register(...args) {
    $a81154f2549cb822$var$registeredSearchers.push(...args);
}
function $a81154f2549cb822$var$createSearcher(pattern, options) {
    for(let i = 0, len = $a81154f2549cb822$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $a81154f2549cb822$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $a81154f2549cb822$var$BitapSearch(pattern, options);
}
const $a81154f2549cb822$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $a81154f2549cb822$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $a81154f2549cb822$var$isExpression = (query)=>!!(query[$a81154f2549cb822$var$LogicalOperator.AND] || query[$a81154f2549cb822$var$LogicalOperator.OR]);
const $a81154f2549cb822$var$isPath = (query)=>!!query[$a81154f2549cb822$var$KeyType.PATH];
const $a81154f2549cb822$var$isLeaf = (query)=>!$a81154f2549cb822$var$isArray(query) && $a81154f2549cb822$var$isObject(query) && !$a81154f2549cb822$var$isExpression(query);
const $a81154f2549cb822$var$convertToExplicit = (query)=>({
        [$a81154f2549cb822$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $a81154f2549cb822$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $a81154f2549cb822$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$a81154f2549cb822$var$isExpression(query)) return next($a81154f2549cb822$var$convertToExplicit(query));
        if ($a81154f2549cb822$var$isLeaf(query)) {
            const key = isQueryPath ? query[$a81154f2549cb822$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$a81154f2549cb822$var$KeyType.PATTERN] : query[key];
            if (!$a81154f2549cb822$var$isString(pattern)) throw new Error($a81154f2549cb822$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $a81154f2549cb822$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $a81154f2549cb822$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($a81154f2549cb822$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$a81154f2549cb822$var$isExpression(query)) query = $a81154f2549cb822$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $a81154f2549cb822$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $a81154f2549cb822$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $a81154f2549cb822$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$a81154f2549cb822$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$a81154f2549cb822$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $a81154f2549cb822$var$transformScore(result, data) {
    data.score = result.score;
}
function $a81154f2549cb822$var$format(results, docs, { includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, includeScore: includeScore = $a81154f2549cb822$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($a81154f2549cb822$var$transformMatches);
    if (includeScore) transformers.push($a81154f2549cb822$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $a81154f2549cb822$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$a81154f2549cb822$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $a81154f2549cb822$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $a81154f2549cb822$var$FuseIndex)) throw new Error($a81154f2549cb822$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $a81154f2549cb822$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$a81154f2549cb822$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $a81154f2549cb822$var$isString(query) ? $a81154f2549cb822$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $a81154f2549cb822$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($a81154f2549cb822$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $a81154f2549cb822$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $a81154f2549cb822$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$a81154f2549cb822$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $a81154f2549cb822$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $a81154f2549cb822$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($a81154f2549cb822$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $a81154f2549cb822$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$a81154f2549cb822$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$a81154f2549cb822$var$isDefined(value)) return [];
        let matches = [];
        if ($a81154f2549cb822$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$a81154f2549cb822$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$a81154f2549cb822$export$2e2bcd8739ae039.version = '7.0.0';
$a81154f2549cb822$export$2e2bcd8739ae039.createIndex = $a81154f2549cb822$var$createIndex;
$a81154f2549cb822$export$2e2bcd8739ae039.parseIndex = $a81154f2549cb822$var$parseIndex;
$a81154f2549cb822$export$2e2bcd8739ae039.config = $a81154f2549cb822$var$Config;
$a81154f2549cb822$export$2e2bcd8739ae039.parseQuery = $a81154f2549cb822$var$parse;
$a81154f2549cb822$var$register($a81154f2549cb822$var$ExtendedSearch);

});

parcelRegister("7WupW", function(module, exports) {

$parcel$export(module.exports, "FUSE_SEARCH_OPTIONS", () => $38319215347bd0bc$export$833d69a1b36f826e);

var $gM5ou = parcelRequire("gM5ou");
const $38319215347bd0bc$export$833d69a1b36f826e = {
    threshold: 0.3,
    keys: [
        {
            name: 'shortcut',
            getFn: (command)=>(0, $gM5ou.removeShortcutSpecialCharacters)(command.shortcut ?? ''),
            weight: Math.pow(2, 6)
        },
        {
            name: 'name',
            weight: Math.pow(2, 5)
        },
        {
            name: 'searchKeywordsArray',
            weight: Math.pow(2, 2)
        },
        {
            name: 'sectionName',
            weight: Math.pow(2, 1)
        }
    ],
    includeScore: true,
    shouldSort: false,
    distance: 1000,
    ignoreFieldNorm: true
};

});


parcelRegister("6dRZA", function(module, exports) {

$parcel$export(module.exports, "useSearchableCommands", () => $1c92e65a4091d3c6$export$9fc7cf5dc38ed809);

var $5uXOq = parcelRequire("5uXOq");

var $jh7L9 = parcelRequire("jh7L9");

var $d8lE2 = parcelRequire("d8lE2");

const $1c92e65a4091d3c6$var$getSearchableChildrenCommands = (action)=>{
    if (action?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && action.commands !== undefined) return action.commands;
    return [];
};
const $1c92e65a4091d3c6$export$9fc7cf5dc38ed809 = (commands)=>{
    const [{ sections: sections }] = (0, $d8lE2.useCommandPalette)();
    return (0, $5uXOq.useMemo)(()=>$1c92e65a4091d3c6$export$529e2322cf5eecf3(commands, sections), [
        commands,
        sections
    ]);
};
const $1c92e65a4091d3c6$var$getSectionName = (command, sectionMap)=>{
    const sectionId = command.section ?? '';
    const section = sectionMap.get(sectionId);
    if (!section) return '';
    if (section.name) return section.name;
    const textContent = (elem)=>{
        if (!elem) return '';
        if (typeof elem === 'string') return elem;
        const children = elem.props && elem.props.children;
        return children instanceof Array ? children.map(textContent).join('') : textContent(children);
    };
    return textContent(section.renderName?.() ?? '');
};
const $1c92e65a4091d3c6$export$529e2322cf5eecf3 = (commands, sections)=>{
    const sectionMap = new Map(sections.flatMap((section)=>Object.entries(section)));
    const findCommands = (currentCommands, depth = 1)=>{
        const allCommands = [];
        const commandsToPrepare = currentCommands;
        commandsToPrepare.forEach((command)=>{
            allCommands.push({
                ...command,
                searchKeywordsArray: command.keywords?.split(' ') ?? [],
                sectionName: $1c92e65a4091d3c6$var$getSectionName(command, sectionMap)
            });
            const searchableChildren = [];
            const searchablePrimaryChildren = $1c92e65a4091d3c6$var$getSearchableChildrenCommands(command.primaryAction);
            const searchableSecondaryChildren = $1c92e65a4091d3c6$var$getSearchableChildrenCommands(command.secondaryAction);
            if (depth < (0, $d867cba7ab775099$export$f1496885619d1f75) && searchablePrimaryChildren.length) searchableChildren.push(...findCommands(searchablePrimaryChildren, depth + 1));
            if (depth < (0, $d867cba7ab775099$export$f1496885619d1f75) && searchableSecondaryChildren.length) searchableChildren.push(...findCommands(searchableSecondaryChildren, depth + 1));
            searchableChildren.forEach((childCommand)=>{
                const breadcrumb = [
                    command?.components?.Name || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, command.name))
                ];
                if (childCommand.breadcrumb?.length) breadcrumb.push(...childCommand.breadcrumb);
                else breadcrumb.push(childCommand?.components?.Name || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, childCommand.name)));
                const parentCommands = [
                    command
                ];
                if (childCommand.parentCommands?.length) parentCommands.push(...childCommand.parentCommands);
                allCommands.push({
                    ...childCommand,
                    searchKeywordsArray: childCommand.keywords?.split(' ') ?? [],
                    section: command.section,
                    sectionName: $1c92e65a4091d3c6$var$getSectionName(command, sectionMap),
                    parentCommands: parentCommands,
                    breadcrumb: breadcrumb
                });
            });
        });
        return allCommands;
    };
    return findCommands(commands);
};

});
const $d867cba7ab775099$export$f1496885619d1f75 = 3;


parcelRegister("Nytob", function(module, exports) {

$parcel$export(module.exports, "sortCommands", () => $19451497861c3205$export$e679a6aefb43ec97);

const $19451497861c3205$var$getSectionOffset = (section)=>1 + (section.priority ?? 0) * (0, $6294646e4edfb139$export$af5cf775e0899047);
const $19451497861c3205$export$e679a6aefb43ec97 = (commands, selectedSections)=>{
    const sortByPriority = (commandsToSort)=>commandsToSort.sort((a, b)=>(a.priority || 0) - (b.priority || 0));
    const sortedSections = Object.entries(selectedSections ?? {}).sort(([idA, valA], [idB, valB])=>{
        const aScore = Math.min(...commands.filter((command)=>command.section === idA).map((command)=>command.searchRelevancyScore ?? 1), 1) * $19451497861c3205$var$getSectionOffset(valA);
        const bScore = Math.min(...commands.filter((command)=>command.section === idB).map((command)=>command.searchRelevancyScore ?? 1), 1) * $19451497861c3205$var$getSectionOffset(valB);
        if (aScore !== bScore) return aScore - bScore;
        const priorityA = valA.priority || 0;
        const priorityB = valB.priority || 0;
        return priorityA - priorityB;
    });
    return sortByPriority(commands).sort((a, b)=>{
        if (a.section && !b.section) return 1;
        if (!a.section && b.section) return -1;
        if (a.section === b.section) return (a.searchRelevancyScore ?? 1) - (b.searchRelevancyScore ?? 1);
        return sortedSections.findIndex(([id])=>id === a.section) - sortedSections.findIndex(([id])=>id === b.section);
    });
};

});
const $6294646e4edfb139$export$af5cf775e0899047 = 10e3;




parcelRegister("fChlq", function(module, exports) {

$parcel$export(module.exports, "usePerformMode", () => $5ef8ac424e3864af$export$8d997d005eb1dc1c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $gM5ou = parcelRequire("gM5ou");

var $d8lE2 = parcelRequire("d8lE2");
const $5ef8ac424e3864af$export$8d997d005eb1dc1c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry }, { executeCommand: executeCommand }] = (0, $d8lE2.useCommandPaletteUsePerformModeState)();
    const hasLoadChildren = (0, $gM5ou.hasChildren)(expandedCommand);
    const selectedCommands = (0, $5uXOq.useMemo)(()=>hasLoadChildren ? childResult?.commands || [] : commands, [
        hasLoadChildren,
        childResult?.commands,
        commands
    ]);
    const foundCommand = (0, $5uXOq.useMemo)(()=>selectedCommands.find((command)=>command.mode && command.mode === search), [
        search,
        selectedCommands
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (foundCommand) executeCommand(foundCommand, {
            method: 'mode',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: (0, $gM5ou.getRegistryData)(registry, activeRegistry, foundCommand.id)
        });
    }, [
        executeCommand,
        createAnalyticsEvent,
        registry,
        activeRegistry,
        foundCommand
    ]);
};

});

parcelRegister("bgJTS", function(module, exports) {

$parcel$export(module.exports, "usePerformPendingCommandOnClose", () => $5e8be564573a780a$export$25863b30ab942012);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
const $5e8be564573a780a$export$25863b30ab942012 = ()=>{
    const { performDialogCloseCommand: performDialogCloseCommand } = (0, $d8lE2.useActionsCommandPalette)();
    (0, $5uXOq.useEffect)(()=>()=>{
            performDialogCloseCommand();
        }, [
        performDialogCloseCommand
    ]);
};

});

parcelRegister("eNg6o", function(module, exports) {

$parcel$export(module.exports, "CommandBodyErrorBoundary", () => $166e8aef33de4a1d$export$3f5cc8366a41f7db);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $d8lE2 = parcelRequire("d8lE2");
const $166e8aef33de4a1d$export$3f5cc8366a41f7db = ({ teamName: teamName, attributes: attributes, fallback: fallback, children: children })=>{
    const [{ expandedCommand: expandedCommand }] = (0, $d8lE2.useCommandPaletteExpandedCommand)();
    const [capturedError, setCapturedError] = (0, $5uXOq.useState)();
    const [prevExpandedCommand, setPrevExpandedCommand] = (0, $5uXOq.useState)(expandedCommand);
    const [hasReset, setHasReset] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasReset) {
            setCapturedError(undefined);
            setHasReset(false);
        }
    }, [
        hasReset
    ]);
    const onRetry = (0, $5uXOq.useCallback)(()=>{
        setHasReset(true);
    }, []);
    // This is so that changing body triggers a reset if an error was caught and then the user goes back a level or to another command list
    // Without this, the body would not rerender, and the fallback would remain present
    (0, $5uXOq.useEffect)(()=>{
        if (capturedError && !hasReset && prevExpandedCommand !== expandedCommand) onRetry();
        setPrevExpandedCommand(expandedCommand);
    }, [
        capturedError,
        expandedCommand,
        hasReset,
        onRetry,
        prevExpandedCommand
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "command.body",
        packageName: "jiraCommandPalette",
        teamName: teamName || 'deliveroo',
        attributes: attributes,
        onError: (_location, error)=>{
            setCapturedError(error);
        },
        fallback: fallback || 'unmount',
        resetCaughtError: hasReset ? capturedError : undefined
    }, children);
};

});

parcelRegister("3OYpW", function(module, exports) {

$parcel$export(module.exports, "Body", () => $fd9cdbb5a5f5b9d9$export$4b2c32e08f77ff18);

var $5uXOq = parcelRequire("5uXOq");

var $jiSaf = parcelRequire("jiSaf");

var $4DwnT = parcelRequire("4DwnT");

var $d8lE2 = parcelRequire("d8lE2");
const $fd9cdbb5a5f5b9d9$export$4b2c32e08f77ff18 = ({ fallback: fallback, results: results, total: total, renderAfterCommands: renderAfterCommands })=>{
    const [{ expandedCommand: expandedCommand }, { setChildCommands: setChildCommands, setLoadingList: setLoadingList, setFallbackOverride: setFallbackOverride }] = (0, $d8lE2.useCommandPaletteExpandedCommand)();
    const ExpandedBody = (0, $5uXOq.useMemo)(()=>(0, $4DwnT.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Body || (0, $jiSaf.components).Body, [
        expandedCommand
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ExpandedBody, {
        setChildResult: setChildCommands,
        setLoading: setLoadingList,
        fallback: fallback,
        results: results,
        total: total,
        renderAfterCommands: renderAfterCommands,
        setFallbackOverride: setFallbackOverride
    });
};

});

const $621e16c24c54300b$export$3545956e927a0d0a = 'command-palette.ui.modal.modal-content.no-results-container';

parcelRegister("2mlNs", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $5aa3d4736d044264$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $jiSaf = parcelRequire("jiSaf");
const $5aa3d4736d044264$export$a06f1c675e846f6f = (props)=>{
    const { activeCommand: activeCommand, ...rest } = props;
    const FooterComponent = activeCommand?.components?.Footer || (0, $jiSaf.components).Footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FooterComponent, rest);
};

});

parcelRegister("5c7Xb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b96539c7f2e0676$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $3zBQA = parcelRequire("3zBQA");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $26g7Y = parcelRequire("26g7Y");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $bcTvL = parcelRequire("bcTvL");

var $1mjMH = parcelRequire("1mjMH");

var $jiSaf = parcelRequire("jiSaf");

var $dzeHJ = parcelRequire("dzeHJ");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $d8lE2 = parcelRequire("d8lE2");


var $1fSPc = parcelRequire("1fSPc");
const $7b96539c7f2e0676$export$8b251419efc915eb = ({ defaultAriaLabel: defaultAriaLabel, defaultPlaceholder: defaultPlaceholder, results: results, activeCommand: activeCommand })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ search: search, forceSearchFocus: forceSearchFocus, isOpen: isOpen, expandedCommand: expandedCommand, activeIndex: activeIndex, loadingList: loadingList, onAnalytics: onAnalytics, registry: registry, activeRegistry: activeRegistry, shouldForceSearchValue: shouldForceSearchValue }, { handleSearch: handleSearch, goBackLevel: goBackLevel, forceFocusSearch: forceFocusSearch, executeCommand: executeCommand, setFocusInput: setFocusInput, resetShouldForceSearchValue: resetShouldForceSearchValue }] = (0, $d8lE2.useCommandPalette)();
    const textFieldRef = (0, $5uXOq.useRef)();
    const onFocusInput = (isFocused)=>()=>{
            setFocusInput(isFocused);
        };
    (0, $5uXOq.useEffect)(()=>{
        if (shouldForceSearchValue && textFieldRef.current && textFieldRef.current.value !== search) {
            resetShouldForceSearchValue();
            textFieldRef.current.value = search;
        }
    }, [
        resetShouldForceSearchValue,
        search,
        shouldForceSearchValue
    ]);
    const onInputKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Backspace' && search === '') goBackLevel(false, {
            createAnalyticsEvent: createAnalyticsEvent,
            method: 'keyboard'
        });
        if (event.key === 'Enter') {
            event.preventDefault();
            const listed = results.find((result)=>!result.isGroup && result.index === activeIndex);
            if (listed) executeCommand(listed.command, {
                method: 'keyboard',
                createAnalyticsEvent: createAnalyticsEvent,
                attributes: {
                    ...(0, $gM5ou.getAnalyticsAttributesFromResult)(listed),
                    ...(0, $gM5ou.getRegistryData)(registry, activeRegistry, listed.command.id)
                }
            }, (0, $gM5ou.isSecondaryTrigger)(event));
        }
    }, [
        search,
        goBackLevel,
        createAnalyticsEvent,
        results,
        activeIndex,
        executeCommand,
        registry,
        activeRegistry
    ]);
    const onTypeAnalytics = (0, $5uXOq.useCallback)((query)=>{
        if (onAnalytics && createAnalyticsEvent) {
            const event = createAnalyticsEvent({});
            onAnalytics(event, (0, $bcTvL.TRACK_EVENT_TYPE), {
                action: 'entered',
                actionSubject: 'text',
                actionSubjectId: 'commandPaletteSearch',
                attributes: {
                    wordCount: (0, $gM5ou.getWordCount)(query),
                    queryLength: query.length,
                    queryHash: (0, $gM5ou.getQueryHash)(query),
                    queryVersion: -1 // This is done to prevent the quickSearch queryVersion being sent which may be confusing, something to reimplement later
                }
            });
        }
    }, [
        createAnalyticsEvent,
        onAnalytics
    ]);
    const onTypeAnalyticsDebounced = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onTypeAnalytics, 400), [
        onTypeAnalytics
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            onTypeAnalyticsDebounced?.cancel?.();
        }, [
        onTypeAnalyticsDebounced
    ]);
    const onTypeSearch = (0, $5uXOq.useCallback)((ev)=>{
        const searchValue = ev.target.value;
        handleSearch(searchValue);
        onTypeAnalyticsDebounced(searchValue);
    }, [
        handleSearch,
        onTypeAnalyticsDebounced
    ]);
    const handleBackButton = (0, $5uXOq.useCallback)(()=>{
        goBackLevel(false, {
            createAnalyticsEvent: createAnalyticsEvent,
            method: 'mouse'
        });
    }, [
        createAnalyticsEvent,
        goBackLevel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (textFieldRef.current && forceSearchFocus) {
            textFieldRef.current.focus();
            forceFocusSearch(false);
        }
    }, [
        forceSearchFocus,
        forceFocusSearch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && textFieldRef.current) textFieldRef.current.focus();
    }, [
        isOpen
    ]);
    const renderLozenge = (0, $5uXOq.useCallback)((command)=>{
        if (command.mode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzeHJ.OutlinedLozenge), {
            key: command.id,
            "data-testid": (0, $9b53dd3a01dd0af4$export$a670752bd2308067)
        }, "\xa0", command.mode, "\xa0");
        const searchLozengeName = command.searchLozengeName || command.name;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzeHJ.SearchLozenge), {
            key: command.id,
            "data-testid": (0, $9b53dd3a01dd0af4$export$1bc358df5aba61fd)
        }, searchLozengeName);
    }, []);
    const elemBeforeInput = (0, $5uXOq.useMemo)(()=>{
        if (!expandedCommand) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-subtle, #626F86)"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b96539c7f2e0676$var$ElemBeforeInputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $1fSPc.default).goBack)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b96539c7f2e0676$var$BackButton, {
            testId: (0, $9b53dd3a01dd0af4$export$69f261bc56a05f72),
            appearance: "subtle",
            onClick: handleBackButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3zBQA))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $1fSPc.default).goBack),
            color: "var(--ds-icon-subtle, #626F86)",
            size: "small"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b96539c7f2e0676$var$LozengeContainer, null, renderLozenge(expandedCommand)));
    }, [
        expandedCommand,
        formatMessage,
        handleBackButton,
        renderLozenge
    ]);
    const elemAfterInput = (0, $5uXOq.useMemo)(()=>{
        if (expandedCommand && loadingList) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b96539c7f2e0676$var$SpinnerContainer, {
            "data-testid": (0, $9b53dd3a01dd0af4$export$b2afd57a1d4bc9e4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        }));
        return null;
    }, [
        expandedCommand,
        loadingList
    ]);
    const placeholder = (0, $5uXOq.useMemo)(()=>{
        if (expandedCommand) return expandedCommand.placeholder || expandedCommand.name;
        return defaultPlaceholder;
    }, [
        expandedCommand,
        defaultPlaceholder
    ]);
    const ModalHeader = (0, $5uXOq.useMemo)(()=>(0, $4DwnT.getActiveCommandList)(expandedCommand)?.components?.Header || (0, $jiSaf.components).Header, [
        expandedCommand
    ]);
    const ariaLabel = (0, $5uXOq.useMemo)(()=>{
        if (!expandedCommand && defaultAriaLabel) return defaultAriaLabel;
        return placeholder;
    }, [
        defaultAriaLabel,
        expandedCommand,
        placeholder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1mjMH.CommandPaletteSearchInput), {
        "aria-label": ariaLabel,
        placeholder: placeholder,
        onKeyDown: onInputKeyPress,
        elemBeforeInput: elemBeforeInput,
        elemAfterInput: elemAfterInput,
        onChange: onTypeSearch,
        ref: textFieldRef,
        onFocus: onFocusInput(true),
        onBlur: onFocusInput(false),
        activeId: activeCommand?.id
    }));
};
var $7b96539c7f2e0676$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7b96539c7f2e0676$export$8b251419efc915eb;
const $7b96539c7f2e0676$var$BackButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _1bsba982 _4t3ia982 _t7bl1lpd _4hh6wdcn _1fyqwdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b96539c7f2e0676$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b96539c7f2e0676$var$ElemBeforeInputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b96539c7f2e0676$var$LozengeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3zBQA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e34bc8237f35d48455854b605c0f874a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29a1ffa1f260b277$var$_react = $29a1ffa1f260b277$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $29a1ffa1f260b277$var$_chevronLeft = $29a1ffa1f260b277$var$_interopRequireDefault((parcelRequire("ks8FD")));

var $29a1ffa1f260b277$var$_chevronLeftLarge = $29a1ffa1f260b277$var$_interopRequireDefault((parcelRequire("a88oa")));
function $29a1ffa1f260b277$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29a1ffa1f260b277$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $29a1ffa1f260b277$var$_react.default.createElement($29a1ffa1f260b277$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $29a1ffa1f260b277$var$_chevronLeftLarge.default
    }, props));
$29a1ffa1f260b277$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $29a1ffa1f260b277$var$_default = module.exports.default = $29a1ffa1f260b277$var$ChevronLeftIcon;

});
parcelRegister("ks8FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3d25fb52825f26$var$_react = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee3d25fb52825f26$var$_baseNew = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee3d25fb52825f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3d25fb52825f26$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ee3d25fb52825f26$var$_react.default.createElement($ee3d25fb52825f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$ee3d25fb52825f26$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $ee3d25fb52825f26$var$_default = module.exports.default = $ee3d25fb52825f26$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("ks8FD")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("1mjMH", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchInput", () => $0b67d1fd6e1f08e8$export$1f98f66b42e34226);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $kY99m = parcelRequire("kY99m");

const $0b67d1fd6e1f08e8$export$1f98f66b42e34226 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ activeId: activeId, ...rest }, ref)=>{
    const ariaProps = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeId) ? {
        'aria-expanded': true,
        'aria-controls': (0, $2350562822a34d03$export$9ffb4923f81813d9),
        role: 'combobox'
    } : {
        role: 'searchbox'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b67d1fd6e1f08e8$var$TextFieldStyle, {
        appearance: "none",
        testId: (0, $2350562822a34d03$export$d3cd230e107fbce),
        ref: ref,
        ...ariaProps,
        ...rest
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b67d1fd6e1f08e8$var$TextFieldStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $kY99m.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _syaz1fxt _ca0q12x7 _u5f31b66 _n3td12x7 _19bv1b66 _swxz1ixg _10wj1ixg _v69yidpf _h61aidpf _1qtqidpf _1bayidpf _n9z41b66 _lmlq1b66 _pytkgktf _k2u0gktf _5ce6131l _irr31r81",
            __cmplp.className
        ])
    });
});

});

const $9b53dd3a01dd0af4$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $9b53dd3a01dd0af4$export$a670752bd2308067 = 'command-palette.ui.modal.header.command-mode';
const $9b53dd3a01dd0af4$export$69f261bc56a05f72 = 'command-palette.ui.modal.header.left-arrow';
const $9b53dd3a01dd0af4$export$b2afd57a1d4bc9e4 = 'command-palette.ui.modal.header.spinner-container';
const $9b53dd3a01dd0af4$export$1bc358df5aba61fd = 'command-palette.ui.modal.modal-content.header.search-lozenge';

parcelRegister("1fSPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $afdfeb0ffd4b2a56$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $afdfeb0ffd4b2a56$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goBack: {
        "id": "command-palette.modal.modal-content.header.go-back",
        "defaultMessage": "Go back"
    }
});

});


parcelRegister("5nIJM", function(module, exports) {

$parcel$export(module.exports, "ScreenReaderContent", () => $e471ff516a544aad$export$d133a8e1226db0f3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $koVbs = parcelRequire("koVbs");

var $1XJ20 = parcelRequire("1XJ20");


var $d8lE2 = parcelRequire("d8lE2");

var $j67DJ = parcelRequire("j67DJ");
const $e471ff516a544aad$var$CommandPaletteScreenReaderContent = ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e471ff516a544aad$var$ScreenReaderOnly, {
        "aria-live": "polite",
        "aria-atomic": "false",
        tabIndex: -1,
        ...props,
        id: (0, $2350562822a34d03$export$9e40a0642460a944)
    });
const $e471ff516a544aad$export$d133a8e1226db0f3 = ({ activeCommand: activeCommand, results: results })=>{
    const [{ search: search, activeIndex: activeIndex }, { forceFocusSearch: forceFocusSearch }] = (0, $d8lE2.useCommandPalette)();
    const previousSearch = (0, $1XJ20.usePrevious)(search);
    const { getScreenReaderText: getScreenReaderText } = $e471ff516a544aad$export$a59db8e7afab3919();
    const [screenReaderText, setScreenReaderText] = (0, $5uXOq.useState)(null);
    const debouncedSetScreenReaderText = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(setScreenReaderText, 400), []);
    (0, $5uXOq.useEffect)(()=>()=>{
            debouncedSetScreenReaderText?.cancel?.();
        }, [
        debouncedSetScreenReaderText
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previousSearch !== search) debouncedSetScreenReaderText(getScreenReaderText({
            activeCommand: activeCommand,
            results: results,
            activeIndex: activeIndex
        }));
    }, [
        activeCommand,
        getScreenReaderText,
        previousSearch,
        results,
        search,
        activeIndex,
        debouncedSetScreenReaderText
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        forceFocusSearch(true);
    }, [
        forceFocusSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e471ff516a544aad$var$CommandPaletteScreenReaderContent, {
        "data-testid": "command-palette.ui.modal.modal-content.screen-reader-content.command-palette-screen-reader-content",
        onFocus: onFocus
    }, screenReaderText);
};
const $e471ff516a544aad$export$a59db8e7afab3919 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getScreenReaderText = ({ activeCommand: activeCommand, results: results, activeIndex: activeIndex })=>{
        if (!activeCommand) return null;
        const selectedOptionLabel = activeCommand?.name;
        const selectedIndex = activeIndex + 1;
        const totalSuggestions = results.filter((result)=>!result.isGroup).length;
        return formatMessage((0, $j67DJ.default).selectedOption, {
            selectedOptionLabel: selectedOptionLabel,
            selectedIndex: selectedIndex,
            totalSuggestions: totalSuggestions
        });
    };
    return {
        getScreenReaderText: getScreenReaderText
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e471ff516a544aad$var$ScreenReaderOnly = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _19itidpf _kqswstnw _1bsbt94y _4t3it94y _ogtocqaw _slp34jg8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j67DJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bd2f3bb2588934c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1bd2f3bb2588934c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectedOption: {
        "id": "command-palette.modal.modal-content.screen-reader-content.selected-option",
        "defaultMessage": "{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions})"
    },
    selectedOptionWithSearch: {
        "id": "command-palette.modal.modal-content.screen-reader-content.selected-option-with-search",
        "defaultMessage": "{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions}) for {search}"
    }
});

});



parcelRegister("aV3mV", function(module, exports) {

$parcel$export(module.exports, "ModalWrapper", () => $065594b29b7f9be1$export$858bfd02c3f2fba5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4DwnT = parcelRequire("4DwnT");

var $d8lE2 = parcelRequire("d8lE2");
const $065594b29b7f9be1$export$858bfd02c3f2fba5 = ({ children: children })=>{
    const [{ expandedCommand: expandedCommand }] = (0, $d8lE2.useCommandPaletteExpandedCommand)();
    const Wrapper = (0, $5uXOq.useMemo)(()=>(0, $4DwnT.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Wrapper || (0, $5uXOq.Fragment), [
        expandedCommand
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($065594b29b7f9be1$var$ModalDialogWrapper, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $065594b29b7f9be1$var$ModalDialogWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko7vkz _19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr _bfhk1bhr _16qs1cd0",
            __cmplp.className
        ])
    });
});

});


parcelRegister("8niRf", function(module, exports) {

$parcel$export(module.exports, "ForgeCommandPaletteCommandsWithFF", () => $5276d7c6288ff309$export$77d9c831a8af7615);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $7CMCs = parcelRequire("7CMCs");

var $jZ0xT = parcelRequire("jZ0xT");

var $5bBva = parcelRequire("5bBva");

var $9vznj = parcelRequire("9vznj");
const $5276d7c6288ff309$export$6241f4da0c01b11b = ()=>{
    const { loading: loading, jiraCommand: jiraCommand, fullPageModules: fullPageModules } = (0, $jZ0xT.useForgeCommandPaletteModules)();
    if (loading) return null;
    if (!jiraCommand) return null;
    const pageCommands = jiraCommand.filter((extension)=>'page' in extension.properties.target);
    const modalCommands = jiraCommand.filter((extension)=>'resource' in extension.properties.target);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, pageCommands && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5bBva.ForgeLinkCommands), {
        commands: pageCommands,
        pageModules: fullPageModules
    }), modalCommands && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vznj.ForgeModalCommands), {
        commands: modalCommands
    }));
};
const $5276d7c6288ff309$export$303419414ed8f11b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "forge-compal",
        teamName: "tomatoes",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5276d7c6288ff309$export$6241f4da0c01b11b, null));
const $5276d7c6288ff309$export$77d9c831a8af7615 = (0, $cSD7y.componentWithFG)('forge-command-palette', $5276d7c6288ff309$export$303419414ed8f11b, ()=>null);

});
parcelRegister("jZ0xT", function(module, exports) {

$parcel$export(module.exports, "useForgeCommandPaletteModules", () => $5087f5003402cb52$export$21e295f0cacdf3f2);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $ld2hZ = parcelRequire("ld2hZ");

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $bSSG7 = parcelRequire("bSSG7");
const $5087f5003402cb52$var$jiraForgeLocalStorage = (0, $bSSG7.createLocalStorageProvider)('jira-forge-compal');
const $5087f5003402cb52$var$MODULES_TO_FETCH = [
    (0, $k2DRb.COMMAND_PALETTE_MODULE),
    (0, $k2DRb.GLOBAL_PAGE_MODULE),
    (0, $k2DRb.ADMIN_PAGE_MODULE),
    (0, $k2DRb.PROJECT_PAGE_MODULE),
    (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
    (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
    (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
];
const $5087f5003402cb52$export$21e295f0cacdf3f2 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [{ isOpen: isOpen }] = (0, $d8lE2.useCommandPalette)();
    const request = (0, $5uXOq.useCallback)(()=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            types: $5087f5003402cb52$var$MODULES_TO_FETCH,
            isAnonymous: isAnonymous,
            includeHidden: false,
            context: {}
        }), [
        cloudId,
        isAnonymous
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(request);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) return;
        const cachedData = $5087f5003402cb52$var$getCachedData();
        if (cachedData) return;
        fetch().then((newData)=>{
            if (newData) $5087f5003402cb52$var$jiraForgeLocalStorage.set($5087f5003402cb52$export$7b9c2315e94d8d2f, JSON.stringify({
                data: newData,
                timestamp: Date.now()
            }));
        });
    }, [
        fetch,
        isOpen
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if (!data) return {
            loading: loading,
            error: error,
            jiraCommand: [],
            fullPageModules: []
        };
        const { 'jira:command': jiraCommand, ...fullPageModules } = data;
        return {
            jiraCommand: jiraCommand,
            fullPageModules: Object.values(fullPageModules).flat(),
            loading: loading,
            error: error
        };
    }, [
        data,
        error,
        loading
    ]);
};
const $5087f5003402cb52$export$7b9c2315e94d8d2f = 'forge-compal-modules-cache';
const $5087f5003402cb52$var$CACHE_EXPIRY = 30000; // 30 seconds
const $5087f5003402cb52$var$getCachedData = ()=>{
    const cached = $5087f5003402cb52$var$jiraForgeLocalStorage.get($5087f5003402cb52$export$7b9c2315e94d8d2f);
    if (cached) {
        const { data: data, timestamp: timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < $5087f5003402cb52$var$CACHE_EXPIRY) return data;
    }
    return null;
};

});

parcelRegister("5bBva", function(module, exports) {

$parcel$export(module.exports, "ForgeLinkCommands", () => $38f175d6f9884e06$export$7a4b28a9f4469c71);

var $5uXOq = parcelRequire("5uXOq");

var $eGdV2 = parcelRequire("eGdV2");

var $5p1kJ = parcelRequire("5p1kJ");

var $jh7L9 = parcelRequire("jh7L9");

var $dAfqg = parcelRequire("dAfqg");

var $lVJAU = parcelRequire("lVJAU");

var $kQVfW = parcelRequire("kQVfW");

var $iSSZ5 = parcelRequire("iSSZ5");

var $70l8b = parcelRequire("70l8b");
const $38f175d6f9884e06$export$7a4b28a9f4469c71 = ({ commands: commands, pageModules: pageModules })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const commandsWithActions = (0, $5uXOq.useMemo)(()=>$38f175d6f9884e06$export$1bd5700c2fc72e18({
            commands: commands,
            projectContextData: projectContextData,
            push: push,
            pageModules: pageModules
        }), [
        commands,
        pageModules,
        projectContextData,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iSSZ5.RegisterForgeCommands), {
        commands: commandsWithActions
    });
};
const $38f175d6f9884e06$export$1bd5700c2fc72e18 = ({ commands: commands, projectContextData: projectContextData, push: push, pageModules: pageModules })=>{
    return commands.map((extension)=>{
        const { id: rawCommandPaletteExtensionId, properties: properties } = extension;
        const { title: title, keywords: keywords, shortcut: shortcut, icon: icon, target: target } = properties;
        const LeftIcon = (0, $kQVfW.FORGE_COMMAND_PALETTE_ICON_MAP)[icon];
        const components = LeftIcon ? {
            LeftIcon: LeftIcon
        } : {
            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                    label: ""
                })
        };
        return {
            id: rawCommandPaletteExtensionId,
            title: title,
            section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).forge,
            icon: icon,
            keywords: keywords?.join(' '),
            shortcut: shortcut,
            name: title,
            components: components,
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>{
                    const matchingPageModule = (0, $70l8b.findMatchingModule)({
                        pageModules: pageModules,
                        rawCommandPaletteExtensionId: rawCommandPaletteExtensionId,
                        target: target
                    });
                    if (!matchingPageModule) return null;
                    (0, $70l8b.navigateToPage)({
                        pageModule: matchingPageModule,
                        push: push,
                        projectContext: projectContextData
                    });
                }
            }
        };
    });
};

});
parcelRegister("kQVfW", function(module, exports) {

$parcel$export(module.exports, "FORGE_COMMAND_PALETTE_ICON_MAP", () => $83b77dd476f217b4$export$8ba7c361aaaf5df0);

var $99M5v = parcelRequire("99M5v");

var $eGdV2 = parcelRequire("eGdV2");

var $9Xmvg = parcelRequire("9Xmvg");

var $3Fq5M = parcelRequire("3Fq5M");

var $1Wiru = parcelRequire("1Wiru");

var $4ChK1 = parcelRequire("4ChK1");

var $4zUQ3 = parcelRequire("4zUQ3");

var $fwpGE = parcelRequire("fwpGE");

var $oZ7y4 = parcelRequire("oZ7y4");

var $eQfWH = parcelRequire("eQfWH");

var $7FST0 = parcelRequire("7FST0");

var $k2tiP = parcelRequire("k2tiP");

var $9H08G = parcelRequire("9H08G");
const $83b77dd476f217b4$export$8ba7c361aaaf5df0 = {
    add: (0, (/*@__PURE__*/$parcel$interopDefault($99M5v))),
    'arrow-right': (0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))),
    copy: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
    open: (0, (/*@__PURE__*/$parcel$interopDefault($9Xmvg))),
    page: (0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))),
    edit: (0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))),
    'user-avatar': (0, (/*@__PURE__*/$parcel$interopDefault($7FST0))),
    activity: (0, (/*@__PURE__*/$parcel$interopDefault($1Wiru))),
    settings: (0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))),
    undo: (0, (/*@__PURE__*/$parcel$interopDefault($9H08G))),
    document: (0, (/*@__PURE__*/$parcel$interopDefault($4zUQ3))),
    'notification-direct': (0, (/*@__PURE__*/$parcel$interopDefault($oZ7y4))),
    folder: (0, (/*@__PURE__*/$parcel$interopDefault($fwpGE)))
};

});
parcelRegister("99M5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6aaa418e9a366cd8$var$_react = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6aaa418e9a366cd8$var$_add = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("dZbEw")));

var $6aaa418e9a366cd8$var$_add2 = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("7ymNM")));
function $6aaa418e9a366cd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6aaa418e9a366cd8$var$AddIcon = (props)=>/*#__PURE__*/ $6aaa418e9a366cd8$var$_react.default.createElement($6aaa418e9a366cd8$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $6aaa418e9a366cd8$var$_add2.default
    }, props));
$6aaa418e9a366cd8$var$AddIcon.Name = 'AddIconMigration';
var $6aaa418e9a366cd8$var$_default = module.exports.default = $6aaa418e9a366cd8$var$AddIcon;

});
parcelRegister("7ymNM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57fd655943aa23fe$var$_react = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $57fd655943aa23fe$var$_add = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("dZbEw")));
function $57fd655943aa23fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57fd655943aa23fe$var$AddIcon = (props)=>/*#__PURE__*/ $57fd655943aa23fe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $57fd655943aa23fe$var$_add.default
    }));
$57fd655943aa23fe$var$AddIcon.displayName = 'AddIcon';
var $57fd655943aa23fe$var$_default = module.exports.default = $57fd655943aa23fe$var$AddIcon;

});


parcelRegister("9Xmvg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73fb14674561f421$var$_react = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $73fb14674561f421$var$_arrowUpRight = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("3sGLB")));

var $73fb14674561f421$var$_open = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("1FouZ")));
function $73fb14674561f421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73fb14674561f421$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $73fb14674561f421$var$_react.default.createElement($73fb14674561f421$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $73fb14674561f421$var$_open.default
    }, props));
$73fb14674561f421$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $73fb14674561f421$var$_default = module.exports.default = $73fb14674561f421$var$ArrowUpRightIcon;

});
parcelRegister("3sGLB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2855293259c2814d$var$_react = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2855293259c2814d$var$_baseNew = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2855293259c2814d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2855293259c2814d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $2855293259c2814d$var$_react.default.createElement($2855293259c2814d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$2855293259c2814d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $2855293259c2814d$var$_default = module.exports.default = $2855293259c2814d$var$ArrowUpRightIcon;

});

parcelRegister("1FouZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $136c9fbd1122fba5$var$_react = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $136c9fbd1122fba5$var$_arrowUpRight = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("3sGLB")));
function $136c9fbd1122fba5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $136c9fbd1122fba5$var$OpenIcon = (props)=>/*#__PURE__*/ $136c9fbd1122fba5$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $136c9fbd1122fba5$var$_arrowUpRight.default
    }));
$136c9fbd1122fba5$var$OpenIcon.displayName = 'OpenIcon';
var $136c9fbd1122fba5$var$_default = module.exports.default = $136c9fbd1122fba5$var$OpenIcon;

});


parcelRegister("3Fq5M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));

var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
function $2ab970d264bef26f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ab970d264bef26f$var$CopyIcon = (props)=>/*#__PURE__*/ $2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
    }, props));
$2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;

});
parcelRegister("8w53e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63353af41c1756be$var$_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $63353af41c1756be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63353af41c1756be$var$CopyIcon = (props)=>/*#__PURE__*/ $63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;

});

parcelRegister("eE13R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa959fe1f5a86e24$var$CopyIcon = (props)=>/*#__PURE__*/ $aa959fe1f5a86e24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $aa959fe1f5a86e24$var$_copy.default
    }));
$aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;

});


parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});


parcelRegister("4zUQ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e16a83764d093913025e315da6d2149>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35568549982e0c65$var$_react = $35568549982e0c65$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35568549982e0c65$var$_file = $35568549982e0c65$var$_interopRequireDefault((parcelRequire("1NlXW")));

var $35568549982e0c65$var$_document = $35568549982e0c65$var$_interopRequireDefault((parcelRequire("b2FF2")));
function $35568549982e0c65$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35568549982e0c65$var$FileIcon = (props)=>/*#__PURE__*/ $35568549982e0c65$var$_react.default.createElement($35568549982e0c65$var$_file.default, Object.assign({
        LEGACY_fallbackIcon: $35568549982e0c65$var$_document.default
    }, props));
$35568549982e0c65$var$FileIcon.Name = 'FileIconMigration';
var $35568549982e0c65$var$_default = module.exports.default = $35568549982e0c65$var$FileIcon;

});
parcelRegister("1NlXW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14eb6801df53e470$var$_react = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $14eb6801df53e470$var$_baseNew = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $14eb6801df53e470$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14eb6801df53e470$var$FileIcon = (props)=>/*#__PURE__*/ $14eb6801df53e470$var$_react.default.createElement($14eb6801df53e470$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$14eb6801df53e470$var$FileIcon.displayName = 'FileIcon';
var $14eb6801df53e470$var$_default = module.exports.default = $14eb6801df53e470$var$FileIcon;

});

parcelRegister("b2FF2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80a0329e75933379$var$_react = $80a0329e75933379$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $80a0329e75933379$var$_file = $80a0329e75933379$var$_interopRequireDefault((parcelRequire("1NlXW")));
function $80a0329e75933379$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $80a0329e75933379$var$DocumentIcon = (props)=>/*#__PURE__*/ $80a0329e75933379$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/></svg>`
    }, props, {
        newIcon: $80a0329e75933379$var$_file.default
    }));
$80a0329e75933379$var$DocumentIcon.displayName = 'DocumentIcon';
var $80a0329e75933379$var$_default = module.exports.default = $80a0329e75933379$var$DocumentIcon;

});


parcelRegister("eQfWH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::182e7300aed0f8931ea6d6a6afcdcbad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ace24a83748025fe$var$_react = $ace24a83748025fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ace24a83748025fe$var$_page = $ace24a83748025fe$var$_interopRequireDefault((parcelRequire("kdfZa")));

var $ace24a83748025fe$var$_page2 = $ace24a83748025fe$var$_interopRequireDefault((parcelRequire("eWXbg")));
function $ace24a83748025fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "PageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ace24a83748025fe$var$PageIcon = (props)=>/*#__PURE__*/ $ace24a83748025fe$var$_react.default.createElement($ace24a83748025fe$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $ace24a83748025fe$var$_page2.default
    }, props));
$ace24a83748025fe$var$PageIcon.Name = 'PageIconMigration';
var $ace24a83748025fe$var$_default = module.exports.default = $ace24a83748025fe$var$PageIcon;

});
parcelRegister("kdfZa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb716bf3c984513d$var$_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb716bf3c984513d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb716bf3c984513d$var$PageIcon = (props)=>/*#__PURE__*/ $eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;

});

parcelRegister("eWXbg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae246388ea520792$var$_react = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $ae246388ea520792$var$_page = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("kdfZa")));
function $ae246388ea520792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae246388ea520792$var$PageIcon = (props)=>/*#__PURE__*/ $ae246388ea520792$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $ae246388ea520792$var$_page.default
    }));
$ae246388ea520792$var$PageIcon.displayName = 'PageIcon';
var $ae246388ea520792$var$_default = module.exports.default = $ae246388ea520792$var$PageIcon;

});


parcelRegister("9H08G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2818f986336a4a51aa47fe5286974737>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70e83ccc33b2569d$var$_react = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $70e83ccc33b2569d$var$_undo = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("7sLAO")));

var $70e83ccc33b2569d$var$_undo2 = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("80QYV")));
function $70e83ccc33b2569d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for UndoIcon.
 * This component is UndoIcon, with `UNSAFE_fallbackIcon` set to "UndoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70e83ccc33b2569d$var$UndoIcon = (props)=>/*#__PURE__*/ $70e83ccc33b2569d$var$_react.default.createElement($70e83ccc33b2569d$var$_undo.default, Object.assign({
        LEGACY_fallbackIcon: $70e83ccc33b2569d$var$_undo2.default
    }, props));
$70e83ccc33b2569d$var$UndoIcon.Name = 'UndoIconMigration';
var $70e83ccc33b2569d$var$_default = module.exports.default = $70e83ccc33b2569d$var$UndoIcon;

});
parcelRegister("7sLAO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2edf8e8e6d811ed80e747695771356e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56f010d97236ea23$var$_react = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $56f010d97236ea23$var$_baseNew = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $56f010d97236ea23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56f010d97236ea23$var$UndoIcon = (props)=>/*#__PURE__*/ $56f010d97236ea23$var$_react.default.createElement($56f010d97236ea23$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$56f010d97236ea23$var$UndoIcon.displayName = 'UndoIcon';
var $56f010d97236ea23$var$_default = module.exports.default = $56f010d97236ea23$var$UndoIcon;

});

parcelRegister("80QYV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d576be12f027bbc$var$_react = $5d576be12f027bbc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5d576be12f027bbc$var$_undo = $5d576be12f027bbc$var$_interopRequireDefault((parcelRequire("7sLAO")));
function $5d576be12f027bbc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5d576be12f027bbc$var$UndoIcon = (props)=>/*#__PURE__*/ $5d576be12f027bbc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5.138 13.026a.98.98 0 0 0 .386 1.366 1.066 1.066 0 0 0 1.421-.371C8.051 12.167 10.104 11 12.37 11c2.437 0 4.619 1.351 5.648 3.429.246.498.868.71 1.388.473.519-.238.74-.833.493-1.333C18.528 10.802 15.618 9 12.37 9c-3.02 0-5.759 1.557-7.232 4.026"/><path d="M4.5 10v3.9c0 .607.494 1.1 1.102 1.1h3.896a1 1 0 1 0 0-2H6.503v-3A1 1 0 0 0 4.5 10"/></g></svg>`
    }, props, {
        newIcon: $5d576be12f027bbc$var$_undo.default
    }));
$5d576be12f027bbc$var$UndoIcon.displayName = 'UndoIcon';
var $5d576be12f027bbc$var$_default = module.exports.default = $5d576be12f027bbc$var$UndoIcon;

});



parcelRegister("iSSZ5", function(module, exports) {

$parcel$export(module.exports, "RegisterForgeCommands", () => $c0d56159cc0a2366$export$cc0cc5320637090e);

var $5uXOq = parcelRequire("5uXOq");

var $3Tty1 = parcelRequire("3Tty1");

var $1Kt4o = parcelRequire("1Kt4o");

var $556k7 = parcelRequire("556k7");

var $7m7w0 = parcelRequire("7m7w0");
const $c0d56159cc0a2366$export$cc0cc5320637090e = ({ commands: commands })=>{
    if (commands?.length === 0 || !commands) return null;
    const commandsWithShortcut = commands.filter((command)=>command.shortcut);
    if (commandsWithShortcut.length === 0) return null;
    /**
	 * As commands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const commandIds = commands.map(({ id: id })=>id).toString();
    const keyMap = (0, $7m7w0.mapCommandsToShortcuts)(commandsWithShortcut);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, keyMap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $556k7.RegisterCommands), {
        commands: commands,
        registrationId: (0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).COPY_URL,
        deps: [
            commandIds
        ]
    }));
};

});
parcelRegister("556k7", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $ba0d6dd9c2ef02f6$export$cd555833c78729f1);

var $5uXOq = parcelRequire("5uXOq");

var $buHQa = parcelRequire("buHQa");
const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buHQa.RegisterCommandsWithRegistry), props);

});
parcelRegister("buHQa", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $3f4c8625aa6e8942$export$b8955a01360d2876);

var $6QoIp = parcelRequire("6QoIp");
function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $6QoIp.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});


parcelRegister("7m7w0", function(module, exports) {

$parcel$export(module.exports, "mapCommandsToShortcuts", () => $9120b437e9e1df0d$export$495c3f0cdb073927);
function $9120b437e9e1df0d$export$495c3f0cdb073927(commandsWithShortcut) {
    if (!Array.isArray(commandsWithShortcut)) return null;
    if (commandsWithShortcut.length === 0) return null;
    const commandWithShortcut = commandsWithShortcut.filter((command)=>command.shortcut);
    const initialValue = {};
    return commandWithShortcut.reduce((acc, command)=>{
        acc[command.shortcut] = {
            callback: command.primaryAction.perform,
            registerInCommandPalette: {
                section: command.section,
                name: command.name,
                components: command.components
            }
        };
        return acc;
    }, initialValue);
}

});


parcelRegister("70l8b", function(module, exports) {

$parcel$export(module.exports, "findMatchingModule", () => $8c85a320eb0768bc$export$33158950c8814dc2);
$parcel$export(module.exports, "navigateToPage", () => $8c85a320eb0768bc$export$c515cccf018994b3);

var $fFfgi = parcelRequire("fFfgi");

var $lvk96 = parcelRequire("lvk96");

var $8zgGo = parcelRequire("8zgGo");

var $g6zTb = parcelRequire("g6zTb");

var $2bUNF = parcelRequire("2bUNF");

var $dIWQD = parcelRequire("dIWQD");

var $4NrfJ = parcelRequire("4NrfJ");

var $ZQIUi = parcelRequire("ZQIUi");

var $kjyUd = parcelRequire("kjyUd");

var $cgkkR = parcelRequire("cgkkR");

var $gYwHC = parcelRequire("gYwHC");

var $6h5Tf = parcelRequire("6h5Tf");

var $jP8zA = parcelRequire("jP8zA");
const $8c85a320eb0768bc$export$33158950c8814dc2 = ({ pageModules: pageModules, target: target, rawCommandPaletteExtensionId: rawCommandPaletteExtensionId })=>pageModules.find((page)=>{
        if (!('page' in target)) return false;
        const commandPaletteExtensionId = (0, $fFfgi.parseExtensionId)(rawCommandPaletteExtensionId);
        const { appId: appId, environmentId: environmentId, moduleKey: moduleKey } = (0, $fFfgi.parseExtensionId)(page.id);
        const isExtensionMatch = appId === commandPaletteExtensionId.appId && environmentId === commandPaletteExtensionId.environmentId && moduleKey === target.page;
        return isExtensionMatch;
    });
const $8c85a320eb0768bc$var$navigateToPageOldNav = ({ pageModule: pageModule, push: push, projectContext: projectContext })=>{
    switch(pageModule.type){
        case 'jira:adminPage':
            push((0, $lvk96.getItemHref)(pageModule));
            break;
        case 'jira:projectPage':
            if (!projectContext) break;
            push((0, $8zgGo.getItemHref)(pageModule, projectContext.projectType, projectContext.projectKey));
            break;
        case 'jira:globalPage':
            push((0, $4NrfJ.getItemHref)(pageModule));
            break;
        case 'jira:projectSettingsPage':
            if (!projectContext) break;
            push((0, $dIWQD.getItemHref)(pageModule, projectContext.projectType, projectContext.projectKey));
            break;
        case 'jira:personalSettingsPage':
            push((0, $g6zTb.getItemHref)(pageModule));
            break;
        case 'jiraServiceManagement:queuePage':
            if (!projectContext) break;
            push((0, $2bUNF.getItemHref)(pageModule, projectContext.projectKey));
            break;
        default:
            // This has no impact on runtime but whenever new page module will be added this will fail and will require to handle that case
            pageModule;
            break;
    }
};
const $8c85a320eb0768bc$export$ce33e03cb3231314 = ({ pageModule: pageModule, push: push, projectContext: projectContext })=>{
    switch(pageModule.type){
        case 'jira:adminPage':
            push((0, $ZQIUi.getItemHref)(pageModule));
            break;
        case 'jira:projectPage':
            if (!projectContext) break;
            push((0, $kjyUd.getItemHref)(pageModule, projectContext.projectType, projectContext.projectKey));
            break;
        case 'jira:globalPage':
            push((0, $4NrfJ.getItemHref)(pageModule));
            break;
        case 'jira:projectSettingsPage':
            if (!projectContext) break;
            push((0, $6h5Tf.getItemHref)(pageModule, projectContext.projectType, projectContext.projectKey));
            break;
        case 'jira:personalSettingsPage':
            push((0, $cgkkR.getItemHref)(pageModule));
            break;
        case 'jiraServiceManagement:queuePage':
            if (!projectContext) break;
            push((0, $gYwHC.getItemHref)(pageModule, projectContext.projectKey));
            break;
        default:
            // This has no impact on runtime but whenever new page module will be added this will fail and will require to handle that case
            pageModule;
            break;
    }
};
const $8c85a320eb0768bc$export$c515cccf018994b3 = (0, $jP8zA.functionWithFF)(// TODO: Find this ff out
'forge-command-palette', $8c85a320eb0768bc$export$ce33e03cb3231314, $8c85a320eb0768bc$var$navigateToPageOldNav);

});
parcelRegister("fFfgi", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $81150828491b2988$export$bae42cbaf7fa3e1b);

var $jbrzS = parcelRequire("jbrzS");
const $81150828491b2988$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $jbrzS.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("jbrzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $aRXoY = parcelRequire("aRXoY");

$3VFsf.__exportStar((parcelRequire("8T6Ee")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $df746fbe0ba5443e$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $df746fbe0ba5443e$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $df746fbe0ba5443e$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $df746fbe0ba5443e$var$InvalidAriError;
function $df746fbe0ba5443e$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $df746fbe0ba5443e$var$basicCharConstraint = $aRXoY.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $df746fbe0ba5443e$var$resourceTypeCharConstraints = $aRXoY.pattern(/^[a-z][a-z.-]*$/i);
const $df746fbe0ba5443e$var$resourceOwnerConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$basicCharConstraint
];
const $df746fbe0ba5443e$var$resourceTypeConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$resourceTypeCharConstraints
];
const $df746fbe0ba5443e$var$cloudIdConstraints = [
    $aRXoY.lengthBetween(3, 255)
];
const $df746fbe0ba5443e$var$siteResourceType = 'site';
const $df746fbe0ba5443e$var$resourceIdChars = /[\w-._~:@#]/.source;
const $df746fbe0ba5443e$var$resourceIdConstraints = [
    $aRXoY.pattern(new RegExp(`^${$df746fbe0ba5443e$var$resourceIdChars}+(/${$df746fbe0ba5443e$var$resourceIdChars}*)*(;v=${$df746fbe0ba5443e$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $df746fbe0ba5443e$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $df746fbe0ba5443e$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $df746fbe0ba5443e$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $df746fbe0ba5443e$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $df746fbe0ba5443e$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        return new $df746fbe0ba5443e$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $df746fbe0ba5443e$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $df746fbe0ba5443e$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $df746fbe0ba5443e$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $df746fbe0ba5443e$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $df746fbe0ba5443e$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $df746fbe0ba5443e$var$siteResourceType && !cloudId) return new $aRXoY.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'resourceOwner', $df746fbe0ba5443e$var$resourceOwnerConstraints),
            $aRXoY.validateField(this, 'resourceType', $df746fbe0ba5443e$var$resourceTypeConstraints),
            $aRXoY.validateField(this, 'resourceId', $df746fbe0ba5443e$var$resourceIdConstraints),
            $aRXoY.validateField(this, 'cloudId', $df746fbe0ba5443e$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $df746fbe0ba5443e$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $df746fbe0ba5443e$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $df746fbe0ba5443e$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parse(ariString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $df746fbe0ba5443e$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parseEncoded(encodedAriString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $df746fbe0ba5443e$var$parseEncoded;

});
parcelRegister("aRXoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aB0SS = parcelRequire("aB0SS");
class $7e9cee950eba220a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $7e9cee950eba220a$var$LengthConstraint;
class $7e9cee950eba220a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $7e9cee950eba220a$var$RegexConstraint;
class $7e9cee950eba220a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $7e9cee950eba220a$var$GeneralValidationError;
class $7e9cee950eba220a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $7e9cee950eba220a$var$ConstraintViolation;
function $7e9cee950eba220a$var$lengthBetween(min, max) {
    return new $7e9cee950eba220a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $7e9cee950eba220a$var$lengthBetween;
function $7e9cee950eba220a$var$pattern(regex) {
    return new $7e9cee950eba220a$var$RegexConstraint(regex);
}
module.exports.pattern = $7e9cee950eba220a$var$pattern;
function $7e9cee950eba220a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($aB0SS.isDefined);
    return violatedConstraints.length > 0 ? new $7e9cee950eba220a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $7e9cee950eba220a$var$validateField;

});
parcelRegister("aB0SS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $7b6e0ba147b061df$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $7b6e0ba147b061df$var$isPresent;
function $7b6e0ba147b061df$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $7b6e0ba147b061df$var$isDefined;
function $7b6e0ba147b061df$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $7b6e0ba147b061df$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $7b6e0ba147b061df$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $7b6e0ba147b061df$var$hasValueAtKey;

});


parcelRegister("8T6Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kQInL = parcelRequire("kQInL");
var $67889de6c03493da$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($67889de6c03493da$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $67889de6c03493da$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $67889de6c03493da$var$AppFamilyAriError;
class $67889de6c03493da$var$NotAppFamilyAriError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $67889de6c03493da$var$NotAppFamilyAriError;
class $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $67889de6c03493da$var$parseAppAri(ari) {
    return $kQInL.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $67889de6c03493da$var$parseAppAri;
function $67889de6c03493da$var$createAppAri(json) {
    return new $kQInL.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $67889de6c03493da$var$createAppAri;

});
parcelRegister("kQInL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8T6Ee = parcelRequire("8T6Ee");

var $jbrzS = parcelRequire("jbrzS");

var $aRXoY = parcelRequire("aRXoY");
const $f2db175f2d527230$var$versionPrefix = ';v=';
const $f2db175f2d527230$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $f2db175f2d527230$var$uuidConstraints = [
    $aRXoY.pattern(new RegExp(`^${$f2db175f2d527230$var$uuidRegExpString}$`, 'i'))
];
const $f2db175f2d527230$var$extensionGroupIdConstraints = [
    $aRXoY.pattern(new RegExp(`^(${$f2db175f2d527230$var$uuidRegExpString}|static)$`, 'i'))
];
class $f2db175f2d527230$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $8T6Ee.AppFamilyAri.resourceOwner) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$8T6Ee.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $8T6Ee.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceType must be one of ${$8T6Ee.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($f2db175f2d527230$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($f2db175f2d527230$var$versionPrefix) > versionIndex) throw new $8T6Ee.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($f2db175f2d527230$var$versionPrefix);
        const segments = mainResourceId.split('/').map($f2db175f2d527230$var$stripToUndefined);
        if (segments.length > 4) throw new $8T6Ee.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType || resourceType === $8T6Ee.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $8T6Ee.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        return new $f2db175f2d527230$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $8T6Ee.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'environmentId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'appId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'extensionGroupId', $f2db175f2d527230$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $jbrzS.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $8T6Ee.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$f2db175f2d527230$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $f2db175f2d527230$var$AppFamilyAriImpl;
function $f2db175f2d527230$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("lvk96", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $54335ef08c5b2562$export$ed6342e0e28465a6);
$parcel$export(module.exports, "default", () => $54335ef08c5b2562$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $1rTGO = parcelRequire("1rTGO");

var $2mmbv = parcelRequire("2mmbv");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $k51JQ = parcelRequire("k51JQ");

var $7Tlti = parcelRequire("7Tlti");

var $5anTI = parcelRequire("5anTI");

var $5NG4k = parcelRequire("5NG4k");
const $54335ef08c5b2562$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/settings/apps/${appId}/${envId}`;
};
const $54335ef08c5b2562$export$a70dd1f096fc6a5f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: data } = (0, $5anTI.useAdminForgeApps)();
    const pages = data?.adminPage ?? null;
    if (!pages?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $5NG4k.messages).forgeSectionTitle)
    }, pages.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $54335ef08c5b2562$export$ed6342e0e28465a6(extension),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            moduleName: (0, $k2DRb.ADMIN_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.ADMIN_PAGE_MODULE)
        }
    }));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54335ef08c5b2562$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mmbv.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54335ef08c5b2562$export$a70dd1f096fc6a5f, null));

});
parcelRegister("gjTBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab78cae21894a64c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $j9VTE = parcelRequire("j9VTE");
// Type needed on props to extract types with extract react types.
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $ab78cae21894a64c$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $ab78cae21894a64c$export$2e2bcd8739ae039 = $ab78cae21894a64c$var$Section;

});

parcelRegister("2mmbv", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $5a0c088cbc4d26b0$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $5a0c088cbc4d26b0$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $5a0c088cbc4d26b0$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.ADMIN_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $5a0c088cbc4d26b0$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.ADMIN_PAGE_MODULE),
        ...props,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    });

});

parcelRegister("k51JQ", function(module, exports) {

$parcel$export(module.exports, "ForgeSubpagesView", () => $b3f0da209e047dcf$export$9711365f685f75c0);
$parcel$export(module.exports, "ForgeItem", () => $b3f0da209e047dcf$export$26a5287439a1d287);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8vDvO = parcelRequire("8vDvO");

var $gjTBi = parcelRequire("gjTBi");

var $fl3Yy = parcelRequire("fl3Yy");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $jv9Yy = parcelRequire("jv9Yy");

var $8iQMc = parcelRequire("8iQMc");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");
const $b3f0da209e047dcf$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $b3f0da209e047dcf$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeIcon, {
        alt: "",
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
        spacing: "spacious",
        label: ""
    });
const $b3f0da209e047dcf$export$df3259e43d89ee7b = (props)=>{
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        href: url,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        analytics: {
            itemId: itemId,
            itemType: 'forge',
            module: moduleName
        }
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};
const $b3f0da209e047dcf$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, $8iQMc.ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgePageHeader, {
        avatarUrl: iconUrl || '',
        name: name,
        environmentType: environmentType,
        environmentKey: environmentKey,
        nestedMenuActive: nestedMenuActive
    });
const $b3f0da209e047dcf$export$9711365f685f75c0 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
    const selectedOn = (0, $5uXOq.useCallback)((route)=>[
            '',
            '/'
        ].includes(String(route || '').trim()) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, $4OCke.matchPartialUrlPathname)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeSubpagesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$961eebe0deda9ad3, props), sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
            key: index
        }, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jv9Yy.SectionHeader), null, section.header) : null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
                key: page.route,
                iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                    url: page.icon
                }) : null,
                href: $b3f0da209e047dcf$export$9ffb311b483a1e2b(url, page.route),
                selectedOn: selectedOn(page.route),
                analytics: {
                    itemId: itemId,
                    itemType: 'forge',
                    module: moduleName
                }
            }, page.title)))));
};
const $b3f0da209e047dcf$export$26a5287439a1d287 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
    const selectedOn = (0, $5uXOq.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
        url
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
    }, [
        overrides
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$df3259e43d89ee7b, props);
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'subpages'
        },
        id: `${itemId}-subpages`,
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        title: (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey),
        selectedOn: selectedOn,
        onClick: onNestedMenuItemClick,
        // @ts-expect-error - overrides types mismatch
        overrides: overrides
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b3f0da209e047dcf$var$ForgeSubpagesContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_14tkpxbi _t3zcv47k _1so41gjq",
            __cmplp.className
        ])
    });
});
const $b3f0da209e047dcf$var$ForgeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $jSfqD = parcelRequire("jSfqD");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jSfqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e63733262ea805c$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1aogK = parcelRequire("1aogK");

var $j9VTE = parcelRequire("j9VTE");
const $0e63733262ea805c$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $0e63733262ea805c$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0e63733262ea805c$var$styles.root,
            props.isSelected && $0e63733262ea805c$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $0e63733262ea805c$export$2e2bcd8739ae039 = $0e63733262ea805c$var$CustomItem;

});

parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("jv9Yy", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $c634a42deba697de$export$8adb256d999cd5a0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c2V4l = parcelRequire("c2V4l");

var $fpoBX = parcelRequire("fpoBX");
const $c634a42deba697de$var$textColorCssVar = '--section-header-text-color';
const $c634a42deba697de$var$opacityCssVar = '--section-header-opacity';
const $c634a42deba697de$var$colorThemeStyles = null;
const $c634a42deba697de$var$opacityThemeStyles = null;
const $c634a42deba697de$export$8adb256d999cd5a0 = ({ children: children })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement((0, $c2V4l.default), {
        // @ts-expect-error - className is a valid prop
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            [$c634a42deba697de$var$opacityCssVar]: item?.opacity,
            [$c634a42deba697de$var$textColorCssVar]: item?.color?.default
        },
        className: (0, $bwpsq.default)([
            item?.opacity && "_tzy4blmq",
            item?.color?.default && "_syazoa1y"
        ])
    }, children);
};

});
parcelRegister("c2V4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6289355db2eea81d$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mNf3 = parcelRequire("4mNf3");

var $j9VTE = parcelRequire("j9VTE");
const $6289355db2eea81d$var$styles = {
    headingItem: "_18zru2gc"
};
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $6289355db2eea81d$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    // @ts-expect-error - Although this isn't defined on props it is available because we've used
    // spread props below and on the jsx element in MenuHeadingItem.
    const UNSAFE_className = props.className;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4mNf3.default), {
        ...props,
        // @ts-expect-error
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $6289355db2eea81d$var$styles.headingItem,
            UNSAFE_className
        ])
    });
};
var $6289355db2eea81d$export$2e2bcd8739ae039 = $6289355db2eea81d$var$HeadingItem;

});


parcelRegister("8iQMc", function(module, exports) {

$parcel$export(module.exports, "ForgePageHeader", () => $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $apKqz = parcelRequire("apKqz");

var $fl3Yy = parcelRequire("fl3Yy");

var $fJoTF = parcelRequire("fJoTF");
const $5bbfd34eb4e2a6d6$var$containerNestedStyles = null;
const $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, $ujWmd.default), AddonIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
AddonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($apKqz))), Header: Header = (0, $fJoTF.CustomHeader), EnvironmentLozenge: EnvironmentLozenge = (0, $fl3Yy.EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, nestedMenuActive: nestedMenuActive })=>{
    return /*#__PURE__*/ $5uXOq.createElement(Header, {
        iconBefore: avatarUrl?.length ? /*#__PURE__*/ $5uXOq.createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: `${avatarUrl}?size=xxlarge`
        }) : /*#__PURE__*/ $5uXOq.createElement(AddonIcon, {
            label: "",
            size: "medium"
        }),
        iconAfter: /*#__PURE__*/ $5uXOq.createElement(EnvironmentLozenge, {
            environmentType: environmentType
        }),
        className: (0, $bwpsq.default)([
            nestedMenuActive && "_19bv183y"
        ])
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});
parcelRegister("fJoTF", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $d2408f7c0923c3e9$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jSfqD = parcelRequire("jSfqD");

var $fpoBX = parcelRequire("fpoBX");
const $d2408f7c0923c3e9$var$bgColorCssVar = '--header-bg-color';
const $d2408f7c0923c3e9$var$textColorCssVar = '--header-text-color';
const $d2408f7c0923c3e9$var$containerStyles = null;
const $d2408f7c0923c3e9$var$bgColorThemeStyles = null;
const $d2408f7c0923c3e9$var$colorThemeStyles = null;
const $d2408f7c0923c3e9$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_syaz1jnk _kqswh2mm _uizt1wug _vrjt140y _1cmdleuv _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_bfhk1im0",
            item?.color?.default && "_syaz1jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$d2408f7c0923c3e9$var$bgColorCssVar]: item?.background?.default,
            [$d2408f7c0923c3e9$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $d2408f7c0923c3e9$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...rest,
        component: $d2408f7c0923c3e9$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isTitleHeading: true
    }, children);
};

});


parcelRegister("kZj7F", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $2fbfde7c900477f4$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d2gYe = parcelRequire("d2gYe");

var $8UO8z = parcelRequire("8UO8z");

var $5Hj3V = parcelRequire("5Hj3V");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fpoBX = parcelRequire("fpoBX");

var $kavsL = parcelRequire("kavsL");
const $2fbfde7c900477f4$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $2fbfde7c900477f4$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5",
    customItem: "_4t3i1ady _vl7qglyw _slhpglyw _7upw1txw _1nrm18uv _1a3b18uv _1ydc18uv _c2wa1kw7 _4fpr1kw7 _1x281kw7 _1iohnqa1 _5goinqa1 _1726nqa1 _1q5t1r31 _nt751r31 _9nxe1r31 _1ohyglyw _49pcglyw _tpgfglyw _1r9xidpf _1hvwidpf _12gridpf"
};
const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $5uXOq.createElement("a", props, props.children);
const $2fbfde7c900477f4$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $5uXOq.createElement(WrapperComponent, null, /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $kavsL.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$2fbfde7c900477f4$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $bwpsq.default)([
                iconSecondaryColor && $2fbfde7c900477f4$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, className: className, ...props })=>/*#__PURE__*/ $5uXOq.createElement((0, $8UO8z.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $bwpsq.default)([
                $2fbfde7c900477f4$var$styles.customItem,
                className
            ])
        }, /*#__PURE__*/ $5uXOq.createElement((0, $5Hj3V.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("d2gYe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97d8a03a9ac2bd8e$var$_react = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97d8a03a9ac2bd8e$var$_arrowLeft = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("ctqwA")));

var $97d8a03a9ac2bd8e$var$_arrowLeftCircle = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("g9uZe")));
function $97d8a03a9ac2bd8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97d8a03a9ac2bd8e$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $97d8a03a9ac2bd8e$var$_react.default.createElement($97d8a03a9ac2bd8e$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $97d8a03a9ac2bd8e$var$_arrowLeftCircle.default
    }, props));
$97d8a03a9ac2bd8e$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $97d8a03a9ac2bd8e$var$_default = module.exports.default = $97d8a03a9ac2bd8e$var$ArrowLeftIcon;

});
parcelRegister("g9uZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2585eb44f99538$var$_react = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bc2585eb44f99538$var$_arrowLeft = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("ctqwA")));
function $bc2585eb44f99538$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc2585eb44f99538$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $bc2585eb44f99538$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $bc2585eb44f99538$var$_arrowLeft.default
    }));
$bc2585eb44f99538$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $bc2585eb44f99538$var$_default = module.exports.default = $bc2585eb44f99538$var$ArrowLeftCircleIcon;

});


parcelRegister("8UO8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0599b2a9b08db47e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bh9nY = parcelRequire("bh9nY");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $ayWDM = parcelRequire("ayWDM");
var $jSfqD = parcelRequire("jSfqD");
var $kzjuk = parcelRequire("kzjuk");

var $9btdk = parcelRequire("9btdk");

var $j9VTE = parcelRequire("j9VTE");

var $9zCCP = parcelRequire("9zCCP");
const $0599b2a9b08db47e$var$styles = {
    iconContainer: "_1e0c1nu9",
    nestingItem: "_udl3glyw _kqsfglyw _udrwglyw _13qvglyw _9mqr1kw7 _povs1kw7 _uv2d1kw7 _atks1kw7",
    nestingItemDisabled: "_1c06idpf _udl3glyw"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $0599b2a9b08db47e$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, className: className, isDisabled: isDisabled, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $j9VTE.useNestedContext)();
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const parentItemRef = (0, $5uXOq.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $5uXOq.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $9zCCP.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j9VTE.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kzjuk.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $9btdk.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "data-right-arrow": true,
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh9nY))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        isDisabled: isDisabled,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title
    };
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSfqD.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ]),
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        ref: activeParentRef,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ])
    });
};
var $0599b2a9b08db47e$export$2e2bcd8739ae039 = $0599b2a9b08db47e$var$NestingItem;

});
parcelRegister("bh9nY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $835890081946c47e$var$_react = $835890081946c47e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $835890081946c47e$var$_arrowRight = $835890081946c47e$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $835890081946c47e$var$_arrowRightCircle = $835890081946c47e$var$_interopRequireDefault((parcelRequire("1zw66")));
function $835890081946c47e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $835890081946c47e$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $835890081946c47e$var$_react.default.createElement($835890081946c47e$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $835890081946c47e$var$_arrowRightCircle.default
    }, props));
$835890081946c47e$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $835890081946c47e$var$_default = module.exports.default = $835890081946c47e$var$ArrowRightIcon;

});
parcelRegister("1zw66", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1251f532550be707$var$_react = $1251f532550be707$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1251f532550be707$var$_arrowRight = $1251f532550be707$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $1251f532550be707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1251f532550be707$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $1251f532550be707$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $1251f532550be707$var$_arrowRight.default
    }));
$1251f532550be707$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $1251f532550be707$var$_default = module.exports.default = $1251f532550be707$var$ArrowRightCircleIcon;

});


var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("ayWDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $860cc941614c9e62$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kJpBP = parcelRequire("kJpBP");

var $j9VTE = parcelRequire("j9VTE");
const $860cc941614c9e62$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $860cc941614c9e62$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $860cc941614c9e62$var$styles.root,
            props.isSelected && $860cc941614c9e62$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $860cc941614c9e62$export$2e2bcd8739ae039 = $860cc941614c9e62$var$ButtonItem;

});

parcelRegister("kzjuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdf97ddffeccb81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cw1vL = parcelRequire("cw1vL");

var $j9VTE = parcelRequire("j9VTE");
const $dfdf97ddffeccb81$var$outerContainerCSS = null;
const $dfdf97ddffeccb81$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $dfdf97ddffeccb81$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $dfdf97ddffeccb81$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    const scrollbar = (0, $cw1vL.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $dfdf97ddffeccb81$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $dfdf97ddffeccb81$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $dfdf97ddffeccb81$var$containerCSS.basic,
                    showTopScrollIndicator && $dfdf97ddffeccb81$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $dfdf97ddffeccb81$export$2e2bcd8739ae039 = $dfdf97ddffeccb81$var$NavigationContent;

});
parcelRegister("cw1vL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03f8a420074f68d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a03f8a420074f68d$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("9btdk", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $1598986e4d07c239$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $1598986e4d07c239$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");

var $VSDnB = parcelRequire("VSDnB");

var $6XySk = parcelRequire("6XySk");

var $8UO8z = parcelRequire("8UO8z");

var $9zCCP = parcelRequire("9zCCP");

var $j9VTE = parcelRequire("j9VTE");

var $cfT4M = parcelRequire("cfT4M");
const $1598986e4d07c239$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $1598986e4d07c239$var$nestableNavigationContentStyles = null;
const $1598986e4d07c239$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $1598986e4d07c239$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $5uXOq.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $1598986e4d07c239$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6XySk.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $9zCCP.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $5uXOq.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $1598986e4d07c239$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cfT4M.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ...motion,
                            className: (0, $bwpsq.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j9VTE.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UO8z.default), {
                                    title: "",
                                    id: $1598986e4d07c239$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $1598986e4d07c239$export$2e2bcd8739ae039 = $1598986e4d07c239$var$NestableNavigationContent;

});
parcelRegister("6XySk", function(module, exports) {

$parcel$export(module.exports, "default", () => $acf862f964b3fe45$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $d2gYe = parcelRequire("d2gYe");


var $ayWDM = parcelRequire("ayWDM");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $acf862f964b3fe45$var$GoBackItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $acf862f964b3fe45$export$2e2bcd8739ae039 = $acf862f964b3fe45$var$GoBackItem;

});

parcelRegister("9zCCP", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $edc749a9b64f215e$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $edc749a9b64f215e$export$ea18c2b5f0e24612);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
const $edc749a9b64f215e$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $9btdk.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $edc749a9b64f215e$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});

parcelRegister("cfT4M", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $0051a7791f96d83a$export$9e743a8c2a6b450e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8Sbj3 = parcelRequire("8Sbj3");
const $0051a7791f96d83a$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});



parcelRegister("5Hj3V", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $c3958cf153a091e2$export$62853c5766dad0c4);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $kqzba = parcelRequire("kqzba");
const $c3958cf153a091e2$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const extraEventData = (0, $5uXOq.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $5uXOq.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqzba.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("kqzba", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $790c5d1c3d335eca$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $kobfu = parcelRequire("kobfu");

var $koVbs = parcelRequire("koVbs");

var $bkXzF = parcelRequire("bkXzF");

var $h8OaL = parcelRequire("h8OaL");
const $790c5d1c3d335eca$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rko9j3y _11c8dcr7 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $790c5d1c3d335eca$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bkXzF))),
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $h8OaL.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $h8OaL.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.error
        ])
    }, "ERROR: ", (0, $kobfu.getErrorHash)(error)));
};

});
parcelRegister("bkXzF", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("h8OaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c8a71ff5065c1e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7c8a71ff5065c1e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("kavsL", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $e059487e30c8155a$export$729f3684d5c2b9b9);
const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});


parcelRegister("4OCke", function(module, exports) {

$parcel$export(module.exports, "matchPathname", () => $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $cf3ce1d2a79b8e17$export$63fdecce99465869);

var $f8l56 = parcelRequire("f8l56");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});


parcelRegister("7Tlti", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $25b31557e9750c03$export$29678d1e04c0e8c4);

var $8QpSo = parcelRequire("8QpSo");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $25b31557e9750c03$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, $8QpSo.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($25b31557e9750c03$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($25b31557e9750c03$var$normalizeSection);
    return [];
});

});

parcelRegister("5anTI", function(module, exports) {

$parcel$export(module.exports, "useAdminForgeApps", () => $8485dd1a37719428$export$5e650d426477650e);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $2YP9W = parcelRequire("2YP9W");

var $kKdpt = parcelRequire("kKdpt");
const $8485dd1a37719428$var$configPageFilter = (extension)=>extension.properties.useAsConfig;
const $8485dd1a37719428$var$getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
const $8485dd1a37719428$var$adminPageFilter = (extension)=>!$8485dd1a37719428$var$configPageFilter(extension) && !$8485dd1a37719428$var$getStartedPageFilter(extension);
const $8485dd1a37719428$export$5e650d426477650e = (routeName)=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5bkvv.forgeAdminModuleResource));
    const visibleExtensions = data ? data.filter((0, $5cmSg.isExtensionVisible)) : null;
    const stackData = visibleExtensions ? visibleExtensions.filter($8485dd1a37719428$var$adminPageFilter) : null;
    const stack = (0, $kKdpt.useForgeItemStack)(stackData, routeName);
    return (0, $5uXOq.useMemo)(()=>{
        if (!visibleExtensions) return {
            data: null,
            loading: loading,
            error: error,
            stack: stack
        };
        return {
            data: {
                adminPage: visibleExtensions.filter($8485dd1a37719428$var$adminPageFilter),
                configPage: visibleExtensions.filter($8485dd1a37719428$var$configPageFilter),
                getStartedPage: visibleExtensions.filter($8485dd1a37719428$var$getStartedPageFilter)
            },
            loading: loading,
            error: error,
            stack: stack
        };
    }, [
        visibleExtensions,
        loading,
        error,
        stack
    ]);
};

});
parcelRegister("5bkvv", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleResource", () => $3d515a0fe8e87c81$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $3d515a0fe8e87c81$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $3d515a0fe8e87c81$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectModuleResourceOnNav3Only", () => $3d515a0fe8e87c81$export$9f19b684a7493211);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $3d515a0fe8e87c81$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $3d515a0fe8e87c81$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $3d515a0fe8e87c81$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $3d515a0fe8e87c81$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $3d515a0fe8e87c81$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $3d515a0fe8e87c81$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $3d515a0fe8e87c81$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $3d515a0fe8e87c81$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $3d515a0fe8e87c81$export$e6be2f0ca0849869);

var $8O7FC = parcelRequire("8O7FC");

var $4R6GH = parcelRequire("4R6GH");

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $dK8AG = parcelRequire("dK8AG");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $1yLrr = parcelRequire("1yLrr");
const $3d515a0fe8e87c81$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $dK8AG.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $3d515a0fe8e87c81$export$b9489d8c5c5e3626 = (0, $2M1hQ.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.ADMIN_PAGE_MODULE], (0, $1yLrr.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$dcc98f4b36ce9223 = ()=>[
        $3d515a0fe8e87c81$export$b9489d8c5c5e3626
    ];
const $3d515a0fe8e87c81$export$72db683c2914a65e = (0, $2M1hQ.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$9f19b684a7493211 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources')), $3d515a0fe8e87c81$export$72db683c2914a65e);
const $3d515a0fe8e87c81$export$7523db37432ba090 = (0, $2M1hQ.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.BACKLOG_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$cfd99f451b423d3a = (0, $2M1hQ.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.BOARD_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$7b639f33f086f9f1 = (0, $2M1hQ.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.SPRINT_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$8a5aed164e925eb6 = (0, $2M1hQ.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$ec3265610584f9ce = ()=>[
        $3d515a0fe8e87c81$export$8a5aed164e925eb6
    ];
const $3d515a0fe8e87c81$export$7a928d209faf75f = (0, $2M1hQ.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$e81e11bbc3239153 = ()=>(0, $2YP9W.useResource)($3d515a0fe8e87c81$export$7a928d209faf75f);
const $3d515a0fe8e87c81$export$97b0827022fdafe3 = (0, $2M1hQ.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.GLOBAL_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$80b2f91dabb3dd65 = ()=>[
        $3d515a0fe8e87c81$export$97b0827022fdafe3
    ];
const $3d515a0fe8e87c81$export$ebf5369e4dcfad00 = (0, $2M1hQ.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$e6be2f0ca0849869 = (0, $2M1hQ.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_NAVIGATION)
        }).then(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (modules)=>modules[0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $3d515a0fe8e87c81$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("8O7FC", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $7c4745a46edf6307$export$89a1f01f2a7cb2a1);

var $2YZCu = parcelRequire("2YZCu");
const $7c4745a46edf6307$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $2YZCu.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("1yLrr", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $8bb90f56b7c2b78a$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5);

var $3JOCw = parcelRequire("3JOCw");

var $e0AC8 = parcelRequire("e0AC8");
const $8bb90f56b7c2b78a$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});


parcelRegister("kKdpt", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $dac9c7c54c5ccbb1$export$462f82a278743d46);

var $5uXOq = parcelRequire("5uXOq");

var $c70gQ = parcelRequire("c70gQ");

var $doZTA = parcelRequire("doZTA");

var $7Tlti = parcelRequire("7Tlti");
const $dac9c7c54c5ccbb1$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const matchedExtension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $7Tlti.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});
parcelRegister("c70gQ", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $b661f1f04cec9385$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $b661f1f04cec9385$export$25abed85383f0fbb);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");
const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $e0AC8.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});



parcelRegister("5NG4k", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ee3cf17e9eb209f8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ee3cf17e9eb209f8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.admin-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("8zgGo", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $4cec53abbd9c3c33$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeProjectSection", () => $4cec53abbd9c3c33$export$fb7da191295a7e22);
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $2vSU6 = parcelRequire("2vSU6");

var $1rTGO = parcelRequire("1rTGO");

var $bXK4r = parcelRequire("bXK4r");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $dAfqg = parcelRequire("dAfqg");

var $k51JQ = parcelRequire("k51JQ");

var $7Tlti = parcelRequire("7Tlti");

var $231OU = parcelRequire("231OU");

var $kBPYs = parcelRequire("kBPYs");
// @ts-expect-error - It's genuinely missing Jira Product Discovery.
const $4cec53abbd9c3c33$var$projectTypeRouteMap = {
    [(0, $2vSU6.CORE_PROJECT)]: 'core',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $4cec53abbd9c3c33$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${$4cec53abbd9c3c33$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $4cec53abbd9c3c33$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
    const { data: data } = (0, $231OU.useProjectForgeApps)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const filteredForgeAppsData = (0, $5uXOq.useMemo)(()=>overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
            overrides.selectedApp
        ] : data || [], [
        data,
        overrides
    ]);
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey, projectType: projectType } = projectContextData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bXK4r.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, $kBPYs.messages).forgeSectionTitle)
    }, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $4cec53abbd9c3c33$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            moduleName: (0, $k2DRb.PROJECT_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true,
            nestedMenuActive: nestedMenuActive,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PROJECT_PAGE_MODULE)
        }
    })));
};

});
parcelRegister("bXK4r", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $488beba58e0bb189$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $488beba58e0bb189$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $488beba58e0bb189$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $488beba58e0bb189$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("231OU", function(module, exports) {

$parcel$export(module.exports, "useProjectForgeApps", () => $1a247d2d1d6e7cdf$export$338edd25edcf3648);
$parcel$export(module.exports, "useProjectForgeAppsNav4", () => $1a247d2d1d6e7cdf$export$80e84933a3e2f677);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $324W5 = parcelRequire("324W5");

var $kKdpt = parcelRequire("kKdpt");
const $1a247d2d1d6e7cdf$export$338edd25edcf3648 = (routeName, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $5bkvv.forgeProjectModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $kKdpt.useForgeItemStack)(projectData, routeName);
    return (0, $5uXOq.useMemo)(()=>({
            data: projectData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $1a247d2d1d6e7cdf$export$80e84933a3e2f677 = (projectKey)=>$1a247d2d1d6e7cdf$export$338edd25edcf3648(undefined, projectKey);

});

parcelRegister("kBPYs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3e1e8355c24b18f2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3e1e8355c24b18f2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("g6zTb", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $7875dfd3feda0029$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgePersonalSettingsSection", () => $7875dfd3feda0029$export$3f793b2ffe120524);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $1rTGO = parcelRequire("1rTGO");

var $lLB03 = parcelRequire("lLB03");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $1C2yb = parcelRequire("1C2yb");

var $k51JQ = parcelRequire("k51JQ");

var $7Tlti = parcelRequire("7Tlti");

var $5qFPq = parcelRequire("5qFPq");

var $8zwb8 = parcelRequire("8zwb8");
const $7875dfd3feda0029$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `${(0, $1C2yb.getAppsPersonalSettingsPath)()}/${appId}/${envId}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7875dfd3feda0029$var$BaseForgePersonalSettingsSection = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: pages } = (0, $5qFPq.usePersonalSettingsForgeApps)();
    if (!pages?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $8zwb8.messages).forgeSectionTitle)
    }, pages.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $7875dfd3feda0029$export$ed6342e0e28465a6(extension),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            moduleName: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
        }
    }));
};
const $7875dfd3feda0029$export$3f793b2ffe120524 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLB03.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7875dfd3feda0029$var$BaseForgePersonalSettingsSection, null));

});
parcelRegister("lLB03", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $8f6f5ad08b6537de$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $8f6f5ad08b6537de$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $8f6f5ad08b6537de$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $8f6f5ad08b6537de$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
        ...props,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    });

});

parcelRegister("1C2yb", function(module, exports) {

$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$cff16c3a6aa7a3a9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $63706130a90445cd$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $63706130a90445cd$export$64a672523a583594);
$parcel$export(module.exports, "getAppsPersonalSettingsPath", () => $63706130a90445cd$export$1a7321c4210a3049);
const $63706130a90445cd$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $63706130a90445cd$export$a974f4af282a75ba = '/jira/settings/personal';
const $63706130a90445cd$export$693b70d1bcef8627 = `${$63706130a90445cd$export$a974f4af282a75ba}/general`;
const $63706130a90445cd$export$21946ea4c58fd4c9 = `${$63706130a90445cd$export$a974f4af282a75ba}/notifications`;
const $63706130a90445cd$export$cff16c3a6aa7a3a9 = `${$63706130a90445cd$export$a974f4af282a75ba}/digests`;
const $63706130a90445cd$export$1fffbb6055aa320a = `${$63706130a90445cd$export$a974f4af282a75ba}/apps`;
const $63706130a90445cd$export$2321c59d517801c8 = `${$63706130a90445cd$export$a974f4af282a75ba}/alert-notifications`;
function $63706130a90445cd$export$db9e3ccc1e5e3317() {
    return $63706130a90445cd$export$693b70d1bcef8627;
}
function $63706130a90445cd$export$88a45ae8c4b1c664() {
    return $63706130a90445cd$export$2321c59d517801c8;
}
function $63706130a90445cd$export$64a672523a583594() {
    return $63706130a90445cd$export$21946ea4c58fd4c9;
}
function $63706130a90445cd$export$1a7321c4210a3049() {
    return $63706130a90445cd$export$1fffbb6055aa320a;
}

});

parcelRegister("5qFPq", function(module, exports) {

$parcel$export(module.exports, "usePersonalSettingsForgeApps", () => $b27f048730b5f058$export$8d963c22c65d141a);

var $5uXOq = parcelRequire("5uXOq");

var $5bkvv = parcelRequire("5bkvv");

var $2YP9W = parcelRequire("2YP9W");

var $kKdpt = parcelRequire("kKdpt");
const $b27f048730b5f058$export$8d963c22c65d141a = (routeName)=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5bkvv.forgePersonalSettingsPageModuleResource));
    const stack = (0, $kKdpt.useForgeItemStack)(data, routeName);
    return (0, $5uXOq.useMemo)(()=>{
        return {
            data: data,
            loading: loading,
            error: error,
            stack: stack
        };
    }, [
        data,
        loading,
        error,
        stack
    ]);
};

});

parcelRegister("8zwb8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6c60cac2eca63d30$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6c60cac2eca63d30$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.personal-settings-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("2bUNF", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $233bf08156102065$export$ed6342e0e28465a6);
$parcel$export(module.exports, "default", () => $233bf08156102065$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $1rTGO = parcelRequire("1rTGO");

var $LoDvw = parcelRequire("LoDvw");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $dAfqg = parcelRequire("dAfqg");

var $k51JQ = parcelRequire("k51JQ");

var $7Tlti = parcelRequire("7Tlti");

var $iIGGa = parcelRequire("iIGGa");

var $Mw97N = parcelRequire("Mw97N");
const $233bf08156102065$export$ed6342e0e28465a6 = (extension, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/servicedesk/projects/${projectKey}/queues/apps/${appId}/${envId}`;
};
const $233bf08156102065$export$a133aa9cc8b5e080 = ()=>{
    const { data: data } = (0, $iIGGa.useServiceDeskQueueForgeApps)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey } = projectContextData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $Mw97N.messages).forgeSectionTitle)
    }, data.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $233bf08156102065$export$ed6342e0e28465a6(extension, projectKey),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            moduleName: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
        }
    }));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$233bf08156102065$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LoDvw.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($233bf08156102065$export$a133aa9cc8b5e080, null));

});
parcelRegister("LoDvw", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $d68c1b1fe01b723d$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $d68c1b1fe01b723d$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $d68c1b1fe01b723d$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $d68c1b1fe01b723d$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("iIGGa", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskQueueForgeApps", () => $1febfd879444642e$export$8a2bb837db423089);
$parcel$export(module.exports, "useServiceDeskQueueForgeAppsNav4", () => $1febfd879444642e$export$52b0be0dcb122e71);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $324W5 = parcelRequire("324W5");

var $kKdpt = parcelRequire("kKdpt");
const $1febfd879444642e$export$8a2bb837db423089 = (routeName, parentStack, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $5bkvv.forgeServiceDeskQueueModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const serviceDeskQueueData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $kKdpt.useForgeItemStack)(serviceDeskQueueData, routeName, parentStack);
    return (0, $5uXOq.useMemo)(()=>({
            data: serviceDeskQueueData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        serviceDeskQueueData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $1febfd879444642e$export$52b0be0dcb122e71 = (projectKey)=>$1febfd879444642e$export$8a2bb837db423089(undefined, undefined, projectKey);

});

parcelRegister("Mw97N", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0a930757ccc9f8ec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0a930757ccc9f8ec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.servicedesk-queue.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("dIWQD", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $484d156a252ecd0d$export$ed6342e0e28465a6);

var $e0AC8 = parcelRequire("e0AC8");
const $484d156a252ecd0d$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${projectType}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};

});

parcelRegister("4NrfJ", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $7a76aaaa3a23f02a$export$ed6342e0e28465a6);
$parcel$export(module.exports, "useGlobalForgeApps", () => $7a76aaaa3a23f02a$export$f834c14187f80532);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $2YP9W = parcelRequire("2YP9W");
const $7a76aaaa3a23f02a$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $7a76aaaa3a23f02a$export$f834c14187f80532 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5bkvv.forgeGlobalModuleResource));
    return (0, $5uXOq.useMemo)(()=>({
            data: data ? data.filter((0, $5cmSg.isExtensionVisible)) : null,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});

parcelRegister("ZQIUi", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $e7e6adf9a5bbb556$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeAdminSection", () => $e7e6adf9a5bbb556$export$a70dd1f096fc6a5f);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $4R6GH = parcelRequire("4R6GH");

var $1rTGO = parcelRequire("1rTGO");

var $2mmbv = parcelRequire("2mmbv");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $7Tlti = parcelRequire("7Tlti");

var $5anTI = parcelRequire("5anTI");

var $gTg91 = parcelRequire("gTg91");

var $6XrI0 = parcelRequire("6XrI0");
const $e7e6adf9a5bbb556$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/settings/apps/${appId}/${envId}`;
};
const $e7e6adf9a5bbb556$export$a70dd1f096fc6a5f = ({ analytics: analytics })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: data } = (0, $5anTI.useAdminForgeApps)();
    const pages = data?.adminPage ?? null;
    if (!pages?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mmbv.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), {
        isMenuListItem: (0, $4R6GH.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, formatMessage((0, $6XrI0.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, pages.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gTg91.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $e7e6adf9a5bbb556$export$ed6342e0e28465a6(extension),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            iconUrl: extension.properties.icon,
            analytics: analytics,
            showIcon: true
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.ADMIN_PAGE_MODULE)
        }
    }));
};

});
parcelRegister("gSZmd", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $dfe52a3a6f12c8c9$export$d4c4e98c5044dc8);

var $hEtBs = parcelRequire("hEtBs");
const $dfe52a3a6f12c8c9$export$d4c4e98c5044dc8 = (0, $hEtBs.List);

});

parcelRegister("1FdfO", function(module, exports) {

$parcel$export(module.exports, "MenuSection", () => $7bc49b2ac035272f$export$4b1545b4f2016d26);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9KnKW = parcelRequire("9KnKW");

var $1qQhw = parcelRequire("1qQhw");

var $bXf7n = parcelRequire("bXf7n");
const $7bc49b2ac035272f$export$4b1545b4f2016d26 = ({ children: children, testId: testId, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $9KnKW.useId)();
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bXf7n.MenuSectionContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            role: "group",
            "aria-labelledby": `${id}-heading`,
            children: children
        })
    });
    if (isMenuListItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qQhw.MenuListItem), {
        testId: testId,
        children: content
    });
    // Legacy. isMenuListItem should become default.
    return content;
};

});
parcelRegister("1qQhw", function(module, exports) {

$parcel$export(module.exports, "MenuListItem", () => $352eeaf5cfbddcbe$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUDGK = parcelRequire("eUDGK");
const $352eeaf5cfbddcbe$export$6c2f3257abc4825b = (0, $eUDGK.ListItem);

});

parcelRegister("bXf7n", function(module, exports) {

$parcel$export(module.exports, "MenuSectionContext", () => $1c4053efb9c0d283$export$728ac99b9c7eea8a);
$parcel$export(module.exports, "useMenuSectionContext", () => $1c4053efb9c0d283$export$8100cda602411810);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $1c4053efb9c0d283$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1c4053efb9c0d283$export$8100cda602411810 = ()=>{
    const context = (0, $5uXOq.useContext)($1c4053efb9c0d283$export$728ac99b9c7eea8a);
    (0, $3joPi.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};

});


parcelRegister("2CQvU", function(module, exports) {

$parcel$export(module.exports, "MenuSectionHeading", () => $2dcd93264b8e5f0d$export$5d3acdbf9237a364);
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bXf7n = parcelRequire("bXf7n");
const $2dcd93264b8e5f0d$var$styles = {
    root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
};
const $2dcd93264b8e5f0d$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $bXf7n.useMenuSectionContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
        id: `${id}-heading`,
        className: (0, $bwpsq.default)([
            $2dcd93264b8e5f0d$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("gTg91", function(module, exports) {

$parcel$export(module.exports, "ForgeItem", () => $13b8f615493442f4$export$26a5287439a1d287);

var $5uXOq = parcelRequire("5uXOq");

var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");

var $fl3Yy = parcelRequire("fl3Yy");

var $fkx1e = parcelRequire("fkx1e");

var $3TY9o = parcelRequire("3TY9o");

var $f8M0Y = parcelRequire("f8M0Y");

var $dWQjM = parcelRequire("dWQjM");

var $hDE1q = parcelRequire("hDE1q");
const $13b8f615493442f4$export$26a5287439a1d287 = (props)=>{
    const { id: itemId, url: url, showIcon: showIcon, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides, analytics: analytics } = props;
    const location = (0, $3TY9o.useLocation)();
    const shouldExpandAsDefault = (0, $5uXOq.useMemo)(()=>location.pathname.includes(url), [
        url,
        location
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
        return ()=>null;
    }, [
        overrides
    ]);
    const itemAnalytics = (0, $5uXOq.useMemo)(()=>{
        return {
            ...analytics,
            itemType: 'app',
            componentType: 'customItem',
            itemId: itemId
        };
    }, [
        analytics,
        itemId
    ]);
    const expandableItemAnalytics = (0, $5uXOq.useMemo)(()=>{
        return {
            ...itemAnalytics,
            level: 2,
            itemType: 'appSubpage',
            parentItemType: 'app'
        };
    }, [
        itemAnalytics
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDE1q.ForgeItemSimple), {
        ...props,
        analytics: itemAnalytics
    });
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWQjM.ForgeItemExpandable), {
        ...props,
        analytics: itemAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
        isDefaultExpanded: shouldExpandAsDefault
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkx1e.default), {
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8M0Y.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        testId: `navigation-sidebar.project-menu.forge-app.${itemId}.expandable-menu-item-trigger.root`,
        analytics: itemAnalytics,
        onClick: onNestedMenuItemClick
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWQjM.ForgeItemExpandable), {
        ...props,
        analytics: expandableItemAnalytics
    })));
};

});
parcelRegister("mwgEH", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItem", () => $c5233d2b5c8a7c4f$export$341dea48c30b36ff);
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $33etG = parcelRequire("33etG");

var $1qQhw = parcelRequire("1qQhw");

var $et13M = parcelRequire("et13M");
const $c5233d2b5c8a7c4f$var$relativeStyles = {
    root: "_kqswh2mm"
};
const $c5233d2b5c8a7c4f$export$341dea48c30b36ff = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $33etG.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qQhw.MenuListItem), {
                    ref: forwardedRef,
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        className: (0, $bwpsq.default)([
                            dropIndicator && $c5233d2b5c8a7c4f$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});

});
parcelRegister("et13M", function(module, exports) {

$parcel$export(module.exports, "AreAllAncestorsExpandedContext", () => $a721eaa4679cbd17$export$9c01e0e6a504d553);
$parcel$export(module.exports, "IsExpandedContext", () => $a721eaa4679cbd17$export$c856e5885cc34d81);
$parcel$export(module.exports, "SetIsExpandedContext", () => $a721eaa4679cbd17$export$48cb11cb8691f597);
$parcel$export(module.exports, "OnExpansionToggleContext", () => $a721eaa4679cbd17$export$572ce188c913ceba);
$parcel$export(module.exports, "LevelContext", () => $a721eaa4679cbd17$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "useIsExpanded", () => $a721eaa4679cbd17$export$37e565a09598825e);
$parcel$export(module.exports, "useSetIsExpanded", () => $a721eaa4679cbd17$export$c9a171ea8de5861b);
$parcel$export(module.exports, "useOnExpansionToggle", () => $a721eaa4679cbd17$export$56c8438498b72c7a);
$parcel$export(module.exports, "useLevel", () => $a721eaa4679cbd17$export$fdfe9e5e8183d4f2);
$parcel$export(module.exports, "useAreAllAncestorsExpanded", () => $a721eaa4679cbd17$export$57108b5f08ae5194);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $fknot = parcelRequire("fknot");
const $a721eaa4679cbd17$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a721eaa4679cbd17$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a721eaa4679cbd17$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a721eaa4679cbd17$export$572ce188c913ceba = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a721eaa4679cbd17$export$650d12d3c2ddb8fc = (0, $fknot.ExpandableMenuItemLevelContext);
const $a721eaa4679cbd17$export$37e565a09598825e = ()=>{
    const context = (0, $5uXOq.useContext)($a721eaa4679cbd17$export$c856e5885cc34d81);
    (0, $3joPi.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $a721eaa4679cbd17$export$c9a171ea8de5861b = ()=>{
    const context = (0, $5uXOq.useContext)($a721eaa4679cbd17$export$48cb11cb8691f597);
    (0, $3joPi.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $a721eaa4679cbd17$export$56c8438498b72c7a = ()=>(0, $5uXOq.useContext)($a721eaa4679cbd17$export$572ce188c913ceba);
const $a721eaa4679cbd17$export$fdfe9e5e8183d4f2 = ()=>(0, $5uXOq.useContext)($a721eaa4679cbd17$export$650d12d3c2ddb8fc);
const $a721eaa4679cbd17$export$57108b5f08ae5194 = ()=>(0, $5uXOq.useContext)($a721eaa4679cbd17$export$9c01e0e6a504d553) ?? true;

});
parcelRegister("fknot", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemLevelContext", () => $04e0b0327ebe6690$export$f8d6463f9b5ca897);

var $5uXOq = parcelRequire("5uXOq");
const $04e0b0327ebe6690$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $5uXOq.createContext)(0);

});



parcelRegister("lnznH", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemContent", () => $989ef304f4c01dfd$export$bd680a81504a92e9);
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $hEtBs = parcelRequire("hEtBs");

var $et13M = parcelRequire("et13M");
const $989ef304f4c01dfd$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $989ef304f4c01dfd$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $et13M.useIsExpanded)();
    const level = (0, $et13M.useLevel)();
    const hasExpanded = (0, $5uXOq.useRef)(false);
    const areAllAncestorsExpanded = (0, $et13M.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEtBs.List), {
                ref: forwardedRef,
                xcss: (0, $DEWI6.cx)($989ef304f4c01dfd$var$styles.content, !isExpanded && $989ef304f4c01dfd$var$styles.collapsedContent),
                children: children
            })
        })
    });
});

});

parcelRegister("fkx1e", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bbdedcb6c6b4aaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cZa9B = parcelRequire("cZa9B");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $7bbdedcb6c6b4aaf$export$3776992222b2b40f = {
    EXPAND: 'expand',
    COLLAPSE: 'collapse'
};
const $7bbdedcb6c6b4aaf$var$ExpandableMenuItemTriggerWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (event, analyticsEvent, { isExpanded: isExpanded })=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, {
            ...analyticsAttributes,
            expandAction: isExpanded ? $7bbdedcb6c6b4aaf$export$3776992222b2b40f.EXPAND : $7bbdedcb6c6b4aaf$export$3776992222b2b40f.COLLAPSE
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
var $7bbdedcb6c6b4aaf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($7bbdedcb6c6b4aaf$var$ExpandableMenuItemTriggerWithAnalytics);

});
parcelRegister("cZa9B", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemTrigger", () => $299b2713b0d220a7$export$fe6fe51056867f4d);
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $iy9RA = parcelRequire("iy9RA");

var $bpC55 = parcelRequire("bpC55");

var $fdP8o = parcelRequire("fdP8o");

var $cs9Q6 = parcelRequire("cs9Q6");

var $et13M = parcelRequire("et13M");
// Widening type to `string` to side-step Compiled cssMap typescript warnings with unknown properties
const $299b2713b0d220a7$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $299b2713b0d220a7$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $299b2713b0d220a7$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $299b2713b0d220a7$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2"
};
const $299b2713b0d220a7$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($iy9RA))) : (0, (/*@__PURE__*/$parcel$interopDefault($bpC55)));
    const chevronElem = /*#__PURE__*/ (0, $2OMIu.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $299b2713b0d220a7$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $299b2713b0d220a7$var$iconStyles.providedElemBefore
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $299b2713b0d220a7$export$fe6fe51056867f4d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const onExpansionToggle = (0, $et13M.useOnExpansionToggle)();
    const isExpanded = (0, $et13M.useIsExpanded)();
    const setIsExpanded = (0, $et13M.useSetIsExpanded)();
    const itemRef = (0, $5uXOq.useRef)(null);
    const handleIconClick = (0, $5uXOq.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $cs9Q6.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    });
    // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)($299b2713b0d220a7$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        label: isExpanded ? 'Collapse' : 'Expand',
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($299b2713b0d220a7$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    });
    // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: itemRef,
        className: (0, $bwpsq.default)([
            $299b2713b0d220a7$var$wrapperStyles.root,
            providedElemBefore && $299b2713b0d220a7$var$wrapperStyles.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fdP8o.MenuItemBase), {
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});

});
parcelRegister("fdP8o", function(module, exports) {

$parcel$export(module.exports, "MenuItemBase", () => $453992fef59345a2$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $620nX = parcelRequire("620nX");

var $5JjdN = parcelRequire("5JjdN");

var $5McnS = parcelRequire("5McnS");
var $3Lty3 = parcelRequire("3Lty3");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");
var $btzsC = parcelRequire("btzsC");

var $ivhXk = parcelRequire("ivhXk");


var $et13M = parcelRequire("et13M");

var $aV1jL = parcelRequire("aV1jL");

var $4qwFZ = parcelRequire("4qwFZ");

// Using `lazy` so that only consumers who want drag and drop
// need to include code for the drag handle.
const $453992fef59345a2$var$LazyDragHandle = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("ckLZt")));
const $453992fef59345a2$var$tooltipStyles = {
    root: "_2rkoglpi _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
const $453992fef59345a2$var$MenuItemTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $btzsC.default), {
        ...rest,
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $453992fef59345a2$var$tooltipStyles.root,
            className
        ]),
        // "css" does not "exist" - it gets transformed into "className" by compiled
        ref: ref,
        children: children
    });
});
function $453992fef59345a2$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $453992fef59345a2$var$defaultAvatarValues = {
    size: 'small'
};
const $453992fef59345a2$var$elemAfterDisplayVar = '--elem-after-display';
const $453992fef59345a2$var$actionsOnHoverDisplayVar = '--actions-on-hover-display';
const $453992fef59345a2$var$notchColorVar = '--notch-color';
// Note: this is also used in `drag-handle.tsx`
const $453992fef59345a2$var$dragHandleDisplayVar = '--drag-handle-display';
const $453992fef59345a2$var$dragCursorAnimation = null;
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $453992fef59345a2$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $453992fef59345a2$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $453992fef59345a2$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $453992fef59345a2$var$containerStyles = {
    root: "_2rkoglpi _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3izwfg _4cvr1h6o _uiztglyw _syaz1gjq _ek6gglyw _1yyu3acm _91ju1txw _1swv108i _1ojv1txw _irr3108i _1brr1txw _109x1txw",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_ek6g1txw",
    removeElemAfterOnHover: "_1mfcglyw _1sjuglyw",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _irr3n7od",
    hasDescription: "_4t3ickbl",
    dragging: "_tzy41ou4"
};
const $453992fef59345a2$var$buttonOrAnchorStyles = {
    root: "_2rkoglpi _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk18uv _syaz1gjq _4cvr1h6o _y3gnv2br _14iu1ji5",
    selected: "_syazaqb7 _14iu19ru",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _7psyru3m _11om6b4r _1uy01amc _bir2q7pw"
};
const $453992fef59345a2$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $453992fef59345a2$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $453992fef59345a2$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $453992fef59345a2$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _1e0c1c3z _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $453992fef59345a2$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $453992fef59345a2$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1guo18uv _12s918uv"
};
const $453992fef59345a2$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ const $453992fef59345a2$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $453992fef59345a2$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ const $453992fef59345a2$var$MenuItemBaseNoRef = ({ testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $et13M.useLevel)();
    const setFlyoutMenuOpen = (0, $aV1jL.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $aV1jL.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $5uXOq.useRef)(null);
    const descriptionRef = (0, $5uXOq.useRef)(null);
    const tooltipOnClick = (0, $5uXOq.useRef)(null);
    const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, $5uXOq.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $453992fef59345a2$var$isTextClamped(label)) return true;
        return Boolean(description && $453992fef59345a2$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $4qwFZ.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            $453992fef59345a2$var$interactiveContentStyles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                // This extends the clickable area of nested menu items to the width
                // of the root level menu items, while being visually indented.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                style: {
                    insetInlineStart: `calc(-1 * ${level} * ${(0, $64ba54a200a2d4aa$export$d492445a79a49b48)})`
                },
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $453992fef59345a2$var$extendButtonOrAnchorStyles.root
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    $453992fef59345a2$var$textStyles.root,
                    !showElemBefore && $453992fef59345a2$var$textStyles.noElemBeforeIndent
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        weight: "medium",
                        maxLines: 1,
                        color: $453992fef59345a2$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        ref: labelRef,
                        children: children
                    }),
                    description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        size: "small",
                        maxLines: 1,
                        ref: descriptionRef,
                        children: description
                    })
                ]
            }),
            hasDragIndicator ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($453992fef59345a2$var$LazyDragHandle, {})
            }) : null,
            dropIndicator
        ]
    });
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $620nX.AvatarContext).Provider, {
        value: $453992fef59345a2$var$defaultAvatarValues,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: visualContentRef,
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, $bwpsq.default)([
                $453992fef59345a2$var$containerStyles.root,
                isSelected && $453992fef59345a2$var$containerStyles.selected,
                isDragging && $453992fef59345a2$var$containerStyles.dragging,
                description && $453992fef59345a2$var$containerStyles.hasDescription,
                showHoverActionsWhenNotHovered && $453992fef59345a2$var$containerStyles.showHoverActions,
                showHoverActionsWhenNotHovered && elemAfter && $453992fef59345a2$var$containerStyles.removeElemAfter,
                actionsOnHover && elemAfter && $453992fef59345a2$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                isDisabled && $453992fef59345a2$var$containerStyles.disabled
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                    content: ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    children: children
                                }),
                                description ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    children: description
                                }) : null
                            ]
                        }),
                    position: "right",
                    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
                    component: $453992fef59345a2$var$MenuItemTooltip,
                    ignoreTooltipPointerEvents: true,
                    hideTooltipOnMouseDown: true,
                    // We don't need a duplicate hidden element containing tooltip content
                    // as the content of the tooltip matches what is rendered for the menu item.
                    isScreenReaderAnnouncementDisabled: true,
                    canAppear: canTooltipAppear,
                    children: (tooltipProps)=>{
                        // Putting the tooltip onClick into a ref.
                        // This way we don't need to create a new `onClick` function on each
                        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
                        tooltipOnClick.current = tooltipProps.onClick;
                        const sharedProps = {
                            ...tooltipProps,
                            'aria-controls': ariaControls,
                            'aria-haspopup': ariaHasPopup,
                            ref: (0, $5JjdN.default)([
                                forwardedRef,
                                tooltipProps.ref
                            ]),
                            testId: testId,
                            interactionName: interactionName
                        };
                        return isLink ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5McnS.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $DEWI6.cx)($453992fef59345a2$var$buttonOrAnchorStyles.root, $453992fef59345a2$var$topLevelSiblingStyles.root, isSelected && $453992fef59345a2$var$buttonOrAnchorStyles.selected, hasDragIndicator && $453992fef59345a2$var$buttonOrAnchorStyles.hasDragIndicator),
                            // Needed to override Anchor style due to a compiled/emotion conflict
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            style: {
                                textDecoration: 'none'
                            },
                            "aria-current": isSelected ? 'page' : undefined,
                            href: href,
                            target: target,
                            /**
           * For anchors we don't want to have the standard drag and drop behaviour.
           *
           * Thinking on the topic:
           *
           * - Anchors look visually similar to buttons in the sidenav
           * - Why should some menu items be natively draggable, while others are not?
           * - A user cannot know which menu items are "natively" draggable (ie anchors)
           * - If you wire up an anchor to be draggable using our standard affordances
           *   it will have a different preview experience to native anchor dragging.
           *
           * To promote consistency, all elements need to use the same visual affordances.
           *
           * Anchor elements will automatically attach URL information
           * to the native data store.
           *
           * When `hasDragIndicator` is `true` we are expecting consumers to register
           * the element as draggable through the `draggable()` Pragmatic drag and drop function.
           * The `draggable()` function will add `draggable="true"` to the element.
           */ draggable: hasDragIndicator ? undefined : false,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $bwpsq.default)([
                                        $453992fef59345a2$var$notchStyles.root
                                    ])
                                }),
                                interactiveElemContent
                            ]
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $DEWI6.cx)($453992fef59345a2$var$buttonOrAnchorStyles.root, $453992fef59345a2$var$topLevelSiblingStyles.root, isSelected && $453992fef59345a2$var$buttonOrAnchorStyles.selected, hasDragIndicator && $453992fef59345a2$var$buttonOrAnchorStyles.hasDragIndicator),
                            "aria-expanded": ariaExpanded,
                            isDisabled: isDisabled,
                            children: interactiveElemContent
                        });
                    }
                }),
                showElemBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $453992fef59345a2$var$elemBeforeStyles.root,
                        $453992fef59345a2$var$topLevelSiblingStyles.root,
                        $453992fef59345a2$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemBefore
                }),
                actionsOnHover && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $453992fef59345a2$var$actionsOnHoverStyles.root
                    ]),
                    children: actionsOnHover
                }),
                elemAfter && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $453992fef59345a2$var$elemAfterStyles.root,
                        $453992fef59345a2$var$topLevelSiblingStyles.root,
                        $453992fef59345a2$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemAfter
                }),
                actions && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $453992fef59345a2$var$actionStyles.root,
                        $453992fef59345a2$var$topLevelSiblingStyles.root,
                        $453992fef59345a2$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: actions
                })
            ]
        })
    });
};
const $453992fef59345a2$export$859b390bf71e044e = (0, $ivhXk.forwardRefWithGeneric)($453992fef59345a2$var$MenuItemBaseNoRef);

});
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $64ba54a200a2d4aa$export$d492445a79a49b48 = '12px';

parcelRegister("aV1jL", function(module, exports) {

$parcel$export(module.exports, "IsOpenContext", () => $f9ed7d1271d6aaec$export$efa4d9670e96ac31);
$parcel$export(module.exports, "SetIsOpenContext", () => $f9ed7d1271d6aaec$export$4c55b1c61a116b42);
$parcel$export(module.exports, "useFlyoutMenuOpen", () => $f9ed7d1271d6aaec$export$6927118f874a49aa);
$parcel$export(module.exports, "useSetFlyoutMenuOpen", () => $f9ed7d1271d6aaec$export$538ac1aa421adb94);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $f9ed7d1271d6aaec$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $f9ed7d1271d6aaec$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $eGmKJ.default));
const $f9ed7d1271d6aaec$export$6927118f874a49aa = ()=>(0, $5uXOq.useContext)($f9ed7d1271d6aaec$export$efa4d9670e96ac31);
const $f9ed7d1271d6aaec$export$538ac1aa421adb94 = ()=>(0, $5uXOq.useContext)($f9ed7d1271d6aaec$export$4c55b1c61a116b42);

});

parcelRegister("4qwFZ", function(module, exports) {

$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $f540ea5c01f27028$export$f4b8e24fae579c6f);
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $f540ea5c01f27028$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});

parcelRegister("ckLZt", function(module, exports) {

let $8fac9434f8bf2033$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fac9434f8bf2033$var$load("l6pXO").then(()=>parcelRequire('jqmSK'));

});


parcelRegister("cs9Q6", function(module, exports) {

$parcel$export(module.exports, "useScrollMenuItemIntoView", () => $7d0fedb322aa4679$export$2c52ec851fcc6058);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $et13M = parcelRequire("et13M");
function $7d0fedb322aa4679$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ if (typeof element.scrollIntoViewIfNeeded === 'function') {
        element.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $7d0fedb322aa4679$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $et13M.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $5uXOq.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $3joPi.default)(element, 'Element ref must be set');
            $7d0fedb322aa4679$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

});



parcelRegister("3TY9o", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $98b56a9c283f50ed$export$45d76561a5302f2b);

var $lODMY = parcelRequire("lODMY");
const $98b56a9c283f50ed$export$45d76561a5302f2b = (0, $lODMY.createRouterSelector)((state)=>state.location);

});

parcelRegister("f8M0Y", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $d43af7d718f087c0$export$fe0464db4dc93ab4);

var $5uXOq = parcelRequire("5uXOq");

var $hRf4g = parcelRequire("hRf4g");

var $dcP6E = parcelRequire("dcP6E");
const $d43af7d718f087c0$export$fe0464db4dc93ab4 = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("dcP6E", function(module, exports) {

$parcel$export(module.exports, "ContainerAvatar", () => $99c01944d2dda31e$export$f35a2d11bd6ae97);
/* container-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $99c01944d2dda31e$var$styles = {
    root: "_2rkoiti9 _vchhusvi _4t3igktf _1bsbgktf"
};
const $99c01944d2dda31e$export$f35a2d11bd6ae97 = ({ src: src })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        src: src,
        alt: "",
        className: (0, $bwpsq.default)([
            $99c01944d2dda31e$var$styles.root
        ])
    });

});


parcelRegister("dWQjM", function(module, exports) {

$parcel$export(module.exports, "ForgeItemExpandable", () => $13c9cddc75a5c96e$export$532bd53ddb8882b3);

var $5uXOq = parcelRequire("5uXOq");

var $aAbfD = parcelRequire("aAbfD");
var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");
var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");

var $8kVg1 = parcelRequire("8kVg1");

var $fkx1e = parcelRequire("fkx1e");

var $1juF8 = parcelRequire("1juF8");

var $7C7jZ = parcelRequire("7C7jZ");

var $f8M0Y = parcelRequire("f8M0Y");
const $13c9cddc75a5c96e$var$createPageUrl = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $13c9cddc75a5c96e$var$ForgeItemExpandableWithHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $7C7jZ.useGetLinkProps)();
    const { id: itemId, url: url, section: section, analytics: analytics } = props;
    const subItemAnalytics = (0, $5uXOq.useMemo)(()=>analytics && {
            ...analytics,
            level: analytics && analytics.level + 1
        }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
        isDefaultExpanded: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkx1e.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8M0Y.ForgeIcon), null),
        analytics: analytics
    }, section.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1juF8.default), {
            key: page.route,
            ...getLinkProps($13c9cddc75a5c96e$var$createPageUrl(url, page.route)),
            analytics: subItemAnalytics,
            onClick: ()=>{
                (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)))));
};
const $13c9cddc75a5c96e$var$ForgeItemExpandableWithoutHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $7C7jZ.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, url: url, section: section, analytics: analytics } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1juF8.default), {
            key: page.route,
            elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8M0Y.ForgeIcon), {
                url: page.icon
            }) : undefined,
            ...getLinkProps($13c9cddc75a5c96e$var$createPageUrl(url, page.route)),
            analytics: analytics,
            onClick: ()=>{
                (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)));
};
const $13c9cddc75a5c96e$export$532bd53ddb8882b3 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, analytics: analytics } = props;
    const hasSectionsWithHeader = sections?.some((section)=>!!section.header);
    return sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13c9cddc75a5c96e$var$ForgeItemExpandableWithHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon,
            analytics: analytics
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !hasSectionsWithHeader && index !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aAbfD.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13c9cddc75a5c96e$var$ForgeItemExpandableWithoutHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon,
            analytics: analytics
        })))));
};

});
parcelRegister("aAbfD", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $f1ca0f480f6cde16$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $f1ca0f480f6cde16$var$styles = null;
const $f1ca0f480f6cde16$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("hr", {
        /**
 * The existing usage of these dividers is presentational,
 * so we are removing the separator semantics by default.
 *
 * In the future we may consider allowing opt-in separator semantics,
 * but it probably isn't necessary.
 */ role: "none",
        className: (0, $bwpsq.default)([
            "_h7alglyw _179rglyw _mqm2zgxb _1bsb1osq"
        ])
    });

});

parcelRegister("1juF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7af6d3b30799ed49$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cJFfS = parcelRequire("cJFfS");


var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");
function $7af6d3b30799ed49$var$LinkMenuItemWithAnalytics({ analytics: analytics, onClick: onClick, ...rest }, ref) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    }, [
        analytics,
        createAnalyticsEvent,
        onClick
    ]) : (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$7af6d3b30799ed49$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($7af6d3b30799ed49$var$LinkMenuItemWithAnalytics);

});
parcelRegister("cJFfS", function(module, exports) {

$parcel$export(module.exports, "LinkMenuItem", () => $daf8eb0f19c00aff$export$d2cad7a1cce7b35f);
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5JjdN = parcelRequire("5JjdN");

var $ivhXk = parcelRequire("ivhXk");

var $eUDGK = parcelRequire("eUDGK");

var $fdP8o = parcelRequire("fdP8o");

var $cs9Q6 = parcelRequire("cs9Q6");
const $daf8eb0f19c00aff$var$listItemStyles = {
    root: "_10m98stt"
};
const $daf8eb0f19c00aff$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $cs9Q6.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $5uXOq.useMemo)(()=>{
        return (0, $5JjdN.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUDGK.ListItem), {
        ref: ref,
        xcss: $daf8eb0f19c00aff$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fdP8o.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $daf8eb0f19c00aff$export$d2cad7a1cce7b35f = (0, $ivhXk.forwardRefWithGeneric)($daf8eb0f19c00aff$var$LinkMenuItemNoRef);

});

const $ce8062101363feb9$export$6dd9406e478a1fe2 = 'navigationItem';
const $ce8062101363feb9$export$b887e88d8d0739f6 = 'button';
const $ce8062101363feb9$export$64fed82162bd367 = 'dropdownItem';


parcelRegister("7C7jZ", function(module, exports) {

$parcel$export(module.exports, "useGetLinkProps", () => $a1cefbecfd084e6c$export$a3307878c8496d13);

var $5uXOq = parcelRequire("5uXOq");

var $9VXkC = parcelRequire("9VXkC");

var $3TY9o = parcelRequire("3TY9o");
const $a1cefbecfd084e6c$export$a3307878c8496d13 = ()=>{
    const location = (0, $3TY9o.useLocation)();
    const getLinkProps = (0, $5uXOq.useCallback)((menuItemPath, options)=>$a1cefbecfd084e6c$var$getMenuLinkPropsFromUrlPath({
            currentPath: location.pathname,
            menuItemPath: menuItemPath,
            options: options
        }), [
        location.pathname
    ]);
    const getLinkPropsFromRoute = (0, $5uXOq.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
        const menuItemPath = (0, $9VXkC.generatePath)(menuItemRoute.path, pathParamValues);
        return getLinkProps(menuItemPath, options);
    }, [
        getLinkProps
    ]);
    return {
        getLinkPropsFromRoute: getLinkPropsFromRoute,
        getLinkProps: /**
		 * Consider using getLinkPropsFromRoute instead, to be able to reuse the page route object, rather than copying its url path around.
		 */ getLinkProps
    };
};
const $a1cefbecfd084e6c$var$defaultOptions = {
    shouldMatchExactPath: true
};
const $a1cefbecfd084e6c$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
    const { shouldMatchExactPath: shouldMatchExactPath } = {
        ...$a1cefbecfd084e6c$var$defaultOptions,
        ...options
    };
    return {
        href: menuItemPath,
        isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
    };
};

});


parcelRegister("hDE1q", function(module, exports) {

$parcel$export(module.exports, "ForgeItemSimple", () => $04ff6fa538c1792f$export$df3259e43d89ee7b);

var $5uXOq = parcelRequire("5uXOq");

var $8kVg1 = parcelRequire("8kVg1");

var $fl3Yy = parcelRequire("fl3Yy");

var $1juF8 = parcelRequire("1juF8");

var $7C7jZ = parcelRequire("7C7jZ");

var $f8M0Y = parcelRequire("f8M0Y");
const $04ff6fa538c1792f$export$df3259e43d89ee7b = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $7C7jZ.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, overrides: overrides, analytics: analytics } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1juF8.default), {
        analytics: analytics,
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8M0Y.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        ...getLinkProps(url, {
            shouldMatchExactPath: false
        }),
        onClick: ()=>{
            (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
                startTime: performance.now()
            });
        }
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});


parcelRegister("6XrI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e018de661085d264$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e018de661085d264$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-forge.admin-section.heading",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("kjyUd", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $248e447f84362a58$export$ed6342e0e28465a6);
$parcel$export(module.exports, "useForgeProjectSectionAppsData", () => $248e447f84362a58$export$d842b2285df6024c);
$parcel$export(module.exports, "renderForgeProjectSectionItem", () => $248e447f84362a58$export$5ca83c51de550ed4);
$parcel$export(module.exports, "ForgeProjectSection", () => $248e447f84362a58$export$fb7da191295a7e22);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $1rTGO = parcelRequire("1rTGO");

var $bXK4r = parcelRequire("bXK4r");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $7Tlti = parcelRequire("7Tlti");

var $231OU = parcelRequire("231OU");



var $gTg91 = parcelRequire("gTg91");

var $dAfqg = parcelRequire("dAfqg");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $248e447f84362a58$var$projectTypeRouteMap = {
    [(0, $2vSU6.CORE_PROJECT)]: 'core',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $248e447f84362a58$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${$248e447f84362a58$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $248e447f84362a58$var$analytics = {
    actionSubjectId: (0, $d59b407ab907bf7b$export$8d155d2412839524),
    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
    level: 2
};
const $248e447f84362a58$var$ForgeProjectSectionOld = ({ overrides: overrides, projectKey: projectKey })=>{
    const { data: data } = (0, $231OU.useProjectForgeAppsNav4)(projectKey);
    const { data: projectContext } = (0, $dAfqg.useProjectContext)({
        matchParams: {
            projectKey: projectKey
        }
    });
    if (!data?.length || !projectKey || !projectContext) return null;
    const { projectType: projectType } = projectContext;
    const filteredForgeAppsData = overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
        overrides.selectedApp
    ] : data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bXK4r.TriggerAnalyticsWrapper), null, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gTg91.ForgeItem), {
            key: extension.id,
            id: extension.id,
            analytics: $248e447f84362a58$var$analytics,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $248e447f84362a58$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            iconUrl: extension.properties.icon,
            showIcon: true,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PROJECT_PAGE_MODULE)
        }
    }));
};
const $248e447f84362a58$export$d842b2285df6024c = ({ overrides: overrides, projectKey: projectKey })=>{
    const { data: data } = (0, $231OU.useProjectForgeAppsNav4)(projectKey);
    if (!data?.length || !projectKey) return null;
    return overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
        overrides.selectedApp
    ] : data;
};
const $248e447f84362a58$export$5ca83c51de550ed4 = ({ extension: extension, projectType: projectType, projectKey: projectKey, overrides: overrides })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gTg91.ForgeItem), {
        key: extension.id,
        id: extension.id,
        analytics: $248e447f84362a58$var$analytics,
        environmentType: extension.environmentType,
        environmentKey: extension.environmentKey,
        url: $248e447f84362a58$export$ed6342e0e28465a6(extension, projectType, projectKey),
        name: extension.properties.title,
        sections: (0, $7Tlti.toSections)(extension),
        iconUrl: extension.properties.icon,
        showIcon: true,
        overrides: overrides
    });
const $248e447f84362a58$var$ForgeProjectSectionNew = ({ overrides: overrides, projectKey: projectKey })=>{
    const filteredForgeAppsData = $248e447f84362a58$export$d842b2285df6024c({
        overrides: overrides,
        projectKey: projectKey
    });
    const { data: projectContext } = (0, $dAfqg.useProjectContext)({
        matchParams: {
            projectKey: projectKey
        }
    });
    if (filteredForgeAppsData === null || !projectContext) return null;
    const { projectType: projectType } = projectContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bXK4r.TriggerAnalyticsWrapper), null, filteredForgeAppsData.map((extension)=>$248e447f84362a58$export$5ca83c51de550ed4({
            extension: extension,
            projectType: projectType,
            projectKey: projectKey,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PROJECT_PAGE_MODULE)
        }
    }));
};
const $248e447f84362a58$export$fb7da191295a7e22 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('more_for_nav_4_level_3'), $248e447f84362a58$var$ForgeProjectSectionNew, $248e447f84362a58$var$ForgeProjectSectionOld);

});
const $d59b407ab907bf7b$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $d59b407ab907bf7b$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';

const $1e554a683893bd46$export$4165a3d0da3bd147 = 'fixedItem';
const $1e554a683893bd46$export$95b0c331af13d819 = 'fixedItemButton';
const $1e554a683893bd46$export$74712b62056d422e = 'fixedItemAction';
const $1e554a683893bd46$export$3ac911b122986477 = 'customItem';
const $1e554a683893bd46$export$9bd6c21d500ae611 = 'customItemButton';
const $1e554a683893bd46$export$5374c2c2d3ece55e = 'customItemAction';
const $1e554a683893bd46$export$56981f28056f258e = 'customItemDropdownAction';
const $1e554a683893bd46$export$17bca95234dea43b = 'fixedItemDropdownAction';


parcelRegister("cgkkR", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $e6199dcec27ba842$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgePersonalSettingsSection", () => $e6199dcec27ba842$export$3f793b2ffe120524);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $1rTGO = parcelRequire("1rTGO");

var $lLB03 = parcelRequire("lLB03");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $7Tlti = parcelRequire("7Tlti");

var $5qFPq = parcelRequire("5qFPq");

var $gTg91 = parcelRequire("gTg91");

var $1C2yb = parcelRequire("1C2yb");

var $djjD2 = parcelRequire("djjD2");
const $e6199dcec27ba842$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `${(0, $1C2yb.getAppsPersonalSettingsPath)()}/${appId}/${envId}`;
};
const $e6199dcec27ba842$var$BaseForgePersonalSettingsSection = ({ analytics: analytics })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: pages } = (0, $5qFPq.usePersonalSettingsForgeApps)();
    if (!pages?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, formatMessage((0, $djjD2.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, pages.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gTg91.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $e6199dcec27ba842$export$ed6342e0e28465a6(extension),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            iconUrl: extension.properties.icon,
            analytics: analytics,
            showIcon: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
        }
    }));
};
const $e6199dcec27ba842$export$3f793b2ffe120524 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLB03.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6199dcec27ba842$var$BaseForgePersonalSettingsSection, props));

});
parcelRegister("djjD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6604478e7561c24b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6604478e7561c24b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-forge.personal-settings-section.heading",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("gYwHC", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $3bb28aaecf9e4241$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeServiceDeskQueueSection", () => $3bb28aaecf9e4241$export$a133aa9cc8b5e080);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $LoDvw = parcelRequire("LoDvw");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $7Tlti = parcelRequire("7Tlti");

var $iIGGa = parcelRequire("iIGGa");

var $gTg91 = parcelRequire("gTg91");
const $3bb28aaecf9e4241$export$ed6342e0e28465a6 = (extension, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/servicedesk/projects/${projectKey}/queues/apps/${appId}/${envId}`;
};
const $3bb28aaecf9e4241$export$a133aa9cc8b5e080 = ({ projectKey: projectKey, analytics: analytics })=>{
    const { data: data } = (0, $iIGGa.useServiceDeskQueueForgeAppsNav4)(projectKey);
    if (!data?.length || !projectKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LoDvw.TriggerAnalyticsWrapper), null, data.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gTg91.ForgeItem), {
            key: extension.id,
            id: extension.id,
            analytics: analytics,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $3bb28aaecf9e4241$export$ed6342e0e28465a6(extension, projectKey),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
        }
    }));
};

});

parcelRegister("6h5Tf", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $05480743e07dbe7c$export$ed6342e0e28465a6);

var $e0AC8 = parcelRequire("e0AC8");
const $05480743e07dbe7c$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${projectType}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};

});

parcelRegister("jP8zA", function(module, exports) {

$parcel$export(module.exports, "functionWithFF", () => $5ce3dbf423abf4c9$export$3b8cbae22108d228);

var $co1wz = parcelRequire("co1wz");

var $e5wyW = parcelRequire("e5wyW");
const $5ce3dbf423abf4c9$export$3b8cbae22108d228 = (featureFlagName, functionTrue, functionFalse)=>(0, $e5wyW.functionWithCondition)(()=>(0, $co1wz.ff)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("co1wz", function(module, exports) {

$parcel$export(module.exports, "ff", () => $f06ca7674c5de753$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $f06ca7674c5de753$export$757bc67afadef4a0);
$parcel$export(module.exports, "getFeatureFlagValue", () => $f06ca7674c5de753$export$7064bb599f663d7e);

var $gSA3s = parcelRequire("gSA3s");

var $f9Owr = parcelRequire("f9Owr");

var $6b6Tk = parcelRequire("6b6Tk");

var $5vjD3 = parcelRequire("5vjD3");
function $f06ca7674c5de753$export$a6dcfcb59016e126(featureFlagName, defaultValue) {
    const client = (0, $5vjD3.getFeatureFlagClient)();
    const flag = client.getFlagEvaluation(featureFlagName, {
        default: defaultValue
    });
    if (!flag) return defaultValue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return flag.value;
}
const $f06ca7674c5de753$var$getBooleanFeatureFlagUsingClient = (featureFlagName, defaultValue)=>{
    const client = (0, $5vjD3.getFeatureFlagClient)();
    return client.getBooleanValue(featureFlagName, {
        default: defaultValue,
        shouldTrackExposureEvent: false
    });
};
const $f06ca7674c5de753$var$getMultivariateFeatureFlagUsingClient = (featureFlagName, defaultValue, possibleValues)=>{
    const client = (0, $5vjD3.getFeatureFlagClient)();
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'T'.
    return client.getVariantValue(featureFlagName, {
        default: defaultValue,
        // @ts-expect-error - TS2322 - Type 'T[]' is not assignable to type 'string[]'.
        oneOf: possibleValues,
        shouldTrackExposureEvent: false
    });
};
/**
 * The feature flag client can be configured to fire automatic exposure events when evaluating
 * feature flag values. For the Track All Changes project, we need all flag evaluations to go
 * through this client so that we can collect these events for all feature flags.
 * See https://hello.atlassian.net/browse/FD-18145 for more information.
 */ const $f06ca7674c5de753$var$isFeatureFlagClientUsedForAllEvaluations = ()=>(0, $6b6Tk.isAutomaticExposureCollectionEnabled)();
const $f06ca7674c5de753$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const impl = $f06ca7674c5de753$var$isFeatureFlagClientUsedForAllEvaluations() ? $f06ca7674c5de753$var$getBooleanFeatureFlagUsingClient : (0, $f9Owr.ff);
    const value = impl(featureFlagName, defaultValue);
    (0, $gSA3s.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
};
function $f06ca7674c5de753$export$757bc67afadef4a0(featureFlagName, defaultValue, possibleValues) {
    const impl = $f06ca7674c5de753$var$isFeatureFlagClientUsedForAllEvaluations() ? $f06ca7674c5de753$var$getMultivariateFeatureFlagUsingClient : (0, $f9Owr.getMultivariateFeatureFlag);
    const value = impl(featureFlagName, defaultValue, possibleValues);
    (0, $gSA3s.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
}
function $f06ca7674c5de753$export$7064bb599f663d7e(featureFlagName, defaultValue) {
    const impl = $f06ca7674c5de753$var$isFeatureFlagClientUsedForAllEvaluations() ? $f06ca7674c5de753$export$a6dcfcb59016e126 : (0, $f9Owr.getFeatureFlagValue);
    const value = impl(featureFlagName, defaultValue);
    (0, $gSA3s.addFeatureFlagAccessed)(featureFlagName, value);
    return impl(featureFlagName, defaultValue);
}

});
parcelRegister("f9Owr", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagValue", () => $132d3c81dd7dc6d5$export$7064bb599f663d7e);
$parcel$export(module.exports, "ff", () => $132d3c81dd7dc6d5$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $132d3c81dd7dc6d5$export$757bc67afadef4a0);

var $y7eb2 = parcelRequire("y7eb2");

var $i3F9x = parcelRequire("i3F9x");
function $132d3c81dd7dc6d5$export$7064bb599f663d7e(featureFlagName, defaultValue) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (typeof (0, $y7eb2._haveValuesArrived) !== 'undefined' && !(0, $y7eb2._haveValuesArrived)() && globalVar.__SSR_IS_FAST_META_ENABLED__ && typeof globalVar.__SSR_SYNC_FF__ === 'function') {
        const flagInSSR = globalVar.__SSR_SYNC_FF__(featureFlagName, defaultValue);
        return flagInSSR;
    }
    return (0, $i3F9x.parseFeatureFlagValue)((0, $y7eb2.default)(), featureFlagName, defaultValue);
}
const $132d3c81dd7dc6d5$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const flagValue = $132d3c81dd7dc6d5$export$7064bb599f663d7e(featureFlagName, defaultValue);
    const isValid = typeof flagValue === 'boolean';
    return isValid ? flagValue : defaultValue;
};
const $132d3c81dd7dc6d5$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues)=>{
    const flagValue = $132d3c81dd7dc6d5$export$7064bb599f663d7e(featureFlagName, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    defaultValue);
    const isValid = typeof flagValue === 'string' && possibleValues.includes(flagValue);
    return isValid ? flagValue : defaultValue;
};

});
parcelRegister("i3F9x", function(module, exports) {

$parcel$export(module.exports, "parseFeatureFlagValue", () => $065a28307d89ac77$export$cd8c68e04b9439b5);
function $065a28307d89ac77$export$cd8c68e04b9439b5(featureFlags, featureFlagName, defaultValue) {
    const flagValue = featureFlags[featureFlagName];
    if (flagValue === undefined) return defaultValue;
    if (typeof flagValue === 'object' && 'value' in flagValue) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return flagValue.value;
    // This _should never happen_, but we need to validate it to remove
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return flagValue;
}

});


parcelRegister("5vjD3", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagClient", () => $c8a65b90bf0928c3$export$43a6e0552eef5ca9);

var $8QpSo = parcelRequire("8QpSo");
parcelRequire("kRatU");
var $9PqPj = parcelRequire("9PqPj");

var $y7eb2 = parcelRequire("y7eb2");

var $fjcgS = parcelRequire("fjcgS");
const $c8a65b90bf0928c3$var$getAnalyticsClientInstance = ()=>(0, $fjcgS.getAnalyticsWebClientPromise)().then((analyticsClient)=>analyticsClient.getInstance());
const $c8a65b90bf0928c3$var$createFeatureFlagClient = ()=>{
    const client = new (0, $9PqPj.default)({
        analyticsHandler: {
            sendOperationalEvent: async (event)=>{
                if (!false) $c8a65b90bf0928c3$var$getAnalyticsClientInstance().then((analyticsClient)=>{
                    // SSR doesn't have an analytics client
                    if (!analyticsClient) return;
                    // customize event data here if needed
                    analyticsClient.sendOperationalEvent(event);
                });
            }
        },
        flags: undefined
    });
    return client;
};
const $c8a65b90bf0928c3$var$featureFlagClient = $c8a65b90bf0928c3$var$createFeatureFlagClient();
const $c8a65b90bf0928c3$var$getFeatureFlags = ()=>{
    const flags = (0, $y7eb2.default)();
    if (Object.keys(flags).length === 0) {
        if (false) {
            const err = new Error("Feature flags are not available yet. The feature flag client can't be initialized");
            // print out the stack trace for SSR, so we can have better understanding on
            // which module is using the client too early.
            // in SSR, we use bunyan to replace the console.error, so we can use the standard
            // log format for apps.
            // eslint-disable-next-line no-console
            console.error({
                err: err
            });
        } else // eslint-disable-next-line no-console
        console.error("Feature flags are not available yet. The feature flag client can't be initialized");
    }
    return flags;
};
const $c8a65b90bf0928c3$var$configureFeatureFlagClient = ()=>{
    const flags = $c8a65b90bf0928c3$var$getFeatureFlags();
    // @ts-expect-error - TS2345 - Argument of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/utils/feature-flagging-using-meta/src/common/types").Flags' is not assignable to parameter of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@atlaskit/feature-flag-client/dist/types/types").Flags'.
    $c8a65b90bf0928c3$var$featureFlagClient.setFlags(flags);
    if (!false) $c8a65b90bf0928c3$var$featureFlagClient.setIsAutomaticExposuresEnabled(true);
    return $c8a65b90bf0928c3$var$featureFlagClient;
};
// NOTE: `memoizeOne` is doing unnecessary checks, what we need in this file is
// a simple local variable implementation, if local variable doesn't exist then
// create it.
const $c8a65b90bf0928c3$var$getMemoizedFeatureFlagClient = (0, $8QpSo.default)($c8a65b90bf0928c3$var$configureFeatureFlagClient);
let $c8a65b90bf0928c3$var$builtFeatureFlagClient;
const $c8a65b90bf0928c3$export$43a6e0552eef5ca9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled === true) {
        if (typeof $c8a65b90bf0928c3$var$builtFeatureFlagClient === 'undefined' || globalVar.invalidateFeatureFlagsClient_DO_NOT_USE === true) {
            globalVar.invalidateFeatureFlagsClient_DO_NOT_USE = false;
            $c8a65b90bf0928c3$var$builtFeatureFlagClient = (0, $8QpSo.default)($c8a65b90bf0928c3$var$configureFeatureFlagClient);
        }
        return $c8a65b90bf0928c3$var$builtFeatureFlagClient();
    }
    return $c8a65b90bf0928c3$var$getMemoizedFeatureFlagClient();
};

});
parcelRegister("kRatU", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("9PqPj")).default);

var $9PqPj = parcelRequire("9PqPj");

var $bECnN = parcelRequire("bECnN");

});
parcelRegister("9PqPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0fec51a21ec5a78$export$2e2bcd8739ae039);

var $bECnN = parcelRequire("bECnN");

var $jSerw = parcelRequire("jSerw");

var $furey = parcelRequire("furey");

var $bo3Uw = parcelRequire("bo3Uw");
class $b0fec51a21ec5a78$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $jSerw.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $jSerw.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $bo3Uw.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $furey.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $bECnN.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $bECnN.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $bECnN.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $jSerw.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $jSerw.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $bECnN.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $jSerw.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $bECnN.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("bECnN", function(module, exports) {

$parcel$export(module.exports, "ExposureTriggerReason", () => $0ceddc1f24830f6f$export$2c20ffeba7dbc068);
var $0ceddc1f24830f6f$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("jSerw", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $8918e231cb30b34e$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $8918e231cb30b34e$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $8918e231cb30b34e$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $8918e231cb30b34e$export$891630e169ca14a4);
const $8918e231cb30b34e$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $8918e231cb30b34e$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $8918e231cb30b34e$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $8918e231cb30b34e$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $8918e231cb30b34e$var$validateFlag = (flagKey, flag)=>{
    if ($8918e231cb30b34e$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $8918e231cb30b34e$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$8918e231cb30b34e$var$validateFlag(key, flags[key]));
};

});

parcelRegister("furey", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7101c4822b75c1$export$2e2bcd8739ae039);
const $7c7101c4822b75c1$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $7c7101c4822b75c1$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $7c7101c4822b75c1$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("bo3Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7d7cbcbf7ac517$export$2e2bcd8739ae039);

var $bECnN = parcelRequire("bECnN");
class $9b7d7cbcbf7ac517$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $bECnN.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $bECnN.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});








parcelRegister("9vznj", function(module, exports) {

$parcel$export(module.exports, "ForgeModalCommands", () => $231545cdad367ca6$export$e809448cf604f95b);

var $5uXOq = parcelRequire("5uXOq");

var $hRf4g = parcelRequire("hRf4g");

var $jh7L9 = parcelRequire("jh7L9");

var $4NjWT = parcelRequire("4NjWT");

var $5p1kJ = parcelRequire("5p1kJ");

var $iSSZ5 = parcelRequire("iSSZ5");

var $kQVfW = parcelRequire("kQVfW");
const $231545cdad367ca6$export$e809448cf604f95b = ({ commands: commands })=>{
    const [modalExtension, setModalExtension] = (0, $5uXOq.useState)(null);
    const commandsWithActions = (0, $5uXOq.useMemo)(()=>$231545cdad367ca6$export$1bd5700c2fc72e18(commands, setModalExtension), [
        commands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iSSZ5.RegisterForgeCommands), {
        commands: commandsWithActions
    }), modalExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4NjWT.AsyncCommandPalette), {
        onClose: ()=>{
            setModalExtension(null);
        },
        extension: modalExtension
    }));
};
const $231545cdad367ca6$export$1bd5700c2fc72e18 = (commands, setModalExtension)=>commands.map((extension)=>{
        const { id: id, properties: properties } = extension;
        const { title: title, keywords: keywords, shortcut: shortcut, icon: icon } = properties;
        const LeftIcon = (0, $kQVfW.FORGE_COMMAND_PALETTE_ICON_MAP)[icon];
        const components = LeftIcon ? {
            LeftIcon: LeftIcon
        } : {
            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                    label: ""
                })
        };
        return {
            id: id,
            title: title,
            icon: icon,
            keywords: keywords?.join(' '),
            section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).forge,
            components: components,
            shortcut: shortcut,
            name: title,
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>{
                    setModalExtension(extension);
                }
            }
        };
    });

});
parcelRegister("4NjWT", function(module, exports) {

$parcel$export(module.exports, "AsyncCommandPalette", () => $df245d0d47f1a693$export$2f4d02791542901d);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $k2DRb = parcelRequire("k2DRb");

var $h5Itv = parcelRequire("h5Itv");
const $df245d0d47f1a693$var$extensionData = {
    type: (0, $k2DRb.COMMAND_PALETTE_MODULE)
};
const $df245d0d47f1a693$var$extraProps = {
    module: (0, $k2DRb.COMMAND_PALETTE_MODULE),
    type: (0, $k2DRb.COMMAND_PALETTE_MODULE),
    extensionData: $df245d0d47f1a693$var$extensionData,
    contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
};
const $df245d0d47f1a693$export$2f4d02791542901d = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "command-palette-extension"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5Itv.LazyCommandPaletteRenderer), {
        ...props,
        ...$df245d0d47f1a693$var$extraProps
    }));
};

});
parcelRegister("h5Itv", function(module, exports) {

$parcel$export(module.exports, "LazyCommandPaletteRenderer", () => $bd48e795710e11a8$export$b7c61214514d7cfe);

var $1rTGO = parcelRequire("1rTGO");

var $kxZPA = parcelRequire("kxZPA");

const $bd48e795710e11a8$export$b7c61214514d7cfe = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9jD14")).then((module)=>module.CommandPalette), {
    ssr: false,
    moduleId: "./src/packages/forge/forge-ui/src/ui/components/command-palette/index.tsx"
}));

});
parcelRegister("9jD14", function(module, exports) {

let $01c011261da75b76$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $01c011261da75b76$var$load("76n7a"),
    $01c011261da75b76$var$load("l253H"),
    $01c011261da75b76$var$load("3yAl4"),
    $01c011261da75b76$var$load("kNFvF"),
    $01c011261da75b76$var$load("ffQaD"),
    $01c011261da75b76$var$load("kvRbA"),
    $01c011261da75b76$var$load("9TDgC")
]).then(()=>parcelRequire('h5ocY'));

});





const $896c010256263437$export$70d2130cb02f61fa = 'command-palette-integration.ui.container';

parcelRegister("ezMlR", function(module, exports) {

$parcel$export(module.exports, "useCloseDotMenu", () => $707e8861343b9d8f$export$64ace3e915332feb);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $2f2jJ = parcelRequire("2f2jJ");

var $a0UwL = parcelRequire("a0UwL");
const $707e8861343b9d8f$export$64ace3e915332feb = ()=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, $a0UwL.useShortcuts)();
    const [{ isOpen: isOpen }, { open: open }] = (0, $d8lE2.useCommandPaletteIsOpen)();
    (0, $5uXOq.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (isOpen) return ()=>{};
        const handler = (ev)=>{
            const modifier = (0, $2f2jJ.isMacOs)() ? ev.metaKey : ev.ctrlKey;
            if (modifier && ev.key === 'k') {
                const hasMonolithDotMenu = typeof JIRA !== 'undefined' && typeof JIRA?.Shifter?.dialog?.destroyed === 'function' && !JIRA?.Shifter?.dialog?.destroyed();
                const dotOpen = isShortcutsDialogVisible || hasMonolithDotMenu;
                if (!dotOpen) return;
                if (isShortcutsDialogVisible) setShortcutsDialogVisibility(false);
                if (hasMonolithDotMenu) JIRA.Shifter?.hide?.();
                open();
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handler);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handler);
        };
    }, [
        isOpen,
        isShortcutsDialogVisible,
        open,
        setShortcutsDialogVisibility
    ]);
};

});

parcelRegister("3oeAD", function(module, exports) {

$parcel$export(module.exports, "useCompalBridge", () => $c76ba512e58a6b71$export$9e0258ef367c1984);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
const $c76ba512e58a6b71$export$9e0258ef367c1984 = ()=>{
    const { open: open } = (0, $d8lE2.useActionsCommandPalette)();
    (0, $5uXOq.useEffect)(()=>{
        if (typeof window !== 'undefined') window.JIRA_COMPAL = {
            open: open
        };
        return ()=>{
            if (typeof window !== 'undefined') window.JIRA_COMPAL = undefined;
        };
    }, [
        open
    ]);
};

});

parcelRegister("ht5ui", function(module, exports) {

$parcel$export(module.exports, "useDisableCompalIfEmbed", () => $4545569469c3ab86$export$2b4e2f60c6063c36);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $clHWF = parcelRequire("clHWF");
const $4545569469c3ab86$export$2b4e2f60c6063c36 = ()=>{
    const { isEmbed: isEmbed } = (0, $clHWF.useIsEmbed)();
    const { setIsDisabled: setIsDisabled } = (0, $d8lE2.useActionsCommandPalette)();
    (0, $5uXOq.useEffect)(()=>{
        setIsDisabled(isEmbed);
    }, [
        isEmbed,
        setIsDisabled
    ]);
};

});
parcelRegister("clHWF", function(module, exports) {

$parcel$export(module.exports, "useIsEmbed", () => $9e75791e9a51e8c8$export$ce94463dec1ccebd);

var $doZTA = parcelRequire("doZTA");
const $9e75791e9a51e8c8$export$ce94463dec1ccebd = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $doZTA.useRouter)();
    if (pathname.endsWith('/embed')) return {
        isEmbed: true
    };
    return {
        isEmbed: false
    };
};

});


parcelRegister("6ixD4", function(module, exports) {

$parcel$export(module.exports, "useRegisterDismissCommand", () => $92e0506512f81009$export$ba1bbbf46b23917);

var $5uXOq = parcelRequire("5uXOq");

var $5p1kJ = parcelRequire("5p1kJ");

var $d8lE2 = parcelRequire("d8lE2");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gFHnq = parcelRequire("gFHnq");
const $92e0506512f81009$export$ba1bbbf46b23917 = ()=>{
    const [{ isOpen: isOpen }, { close: close }] = (0, $d8lE2.useCommandPaletteIsOpen)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isOpen) return ()=>{};
        const dismissCommandPalette = (ev)=>{
            if (!(0, $gFHnq.isCommandPaletteTrigger)(ev)) return;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent((0, $5p1kJ.COMMAND_PALETTE_PRESSED_ANALYTICS)), (0, $5p1kJ.COMMAND_PALETTE_ID), {
                key: 'k',
                isDismissing: true
            });
            ev.preventDefault();
            close();
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('keydown', dismissCommandPalette);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('keydown', dismissCommandPalette);
        };
    }, [
        close,
        createAnalyticsEvent,
        isOpen
    ]);
    return null;
};

});
parcelRegister("gFHnq", function(module, exports) {

$parcel$export(module.exports, "isCommandPaletteTrigger", () => $76605c8ea5774ab1$export$fdcbda728f65a22a);

var $2f2jJ = parcelRequire("2f2jJ");
const $76605c8ea5774ab1$export$fdcbda728f65a22a = (ev)=>{
    if (ev.key !== 'k') return false;
    if ((0, $2f2jJ.isMacOs)()) {
        if (!ev.metaKey) return false;
    } else if (!ev.ctrlKey) return false;
    return true;
};

});


parcelRegister("kqiyM", function(module, exports) {

$parcel$export(module.exports, "useRegisterSections", () => $21829c9b16b4c530$export$322b8dfd66fee25d);

var $5uXOq = parcelRequire("5uXOq");

var $5p1kJ = parcelRequire("5p1kJ");

var $eC7F7 = parcelRequire("eC7F7");

var $koVbs = parcelRequire("koVbs");

var $9B2hh = parcelRequire("9B2hh");
const $21829c9b16b4c530$export$d67bb364b16506d = {
    [(0, $5p1kJ.COMMAND_PALETTE_SECTIONS).containerNavigation]: {
        message: (0, $9B2hh.messages).containerNavigationSection,
        priority: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS_PRIORITY).containerNavigation,
        actionCategory: 'containerNavigation'
    },
    [(0, $5p1kJ.COMMAND_PALETTE_SECTIONS).siteNavigation]: {
        message: (0, $9B2hh.messages).siteNavigationSection,
        priority: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS_PRIORITY).siteNavigation,
        actionCategory: 'siteNavigation'
    },
    [(0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions]: {
        message: (0, $9B2hh.messages).quickActionsSection,
        priority: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS_PRIORITY).quickActions,
        actionCategory: 'quickActions'
    },
    [(0, $5p1kJ.COMMAND_PALETTE_SECTIONS).personalSettings]: {
        message: (0, $9B2hh.messages).personalSettingsSection,
        priority: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS_PRIORITY).personalSettings,
        actionCategory: 'personalSettings'
    },
    [(0, $5p1kJ.COMMAND_PALETTE_SECTIONS).help]: {
        message: (0, $9B2hh.messages).helpSection,
        priority: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS_PRIORITY).help,
        actionCategory: 'help'
    },
    [(0, $5p1kJ.COMMAND_PALETTE_SECTIONS).jiraSettings]: {
        message: (0, $9B2hh.messages).jiraSettingsSection,
        priority: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS_PRIORITY).jiraSettings,
        actionCategory: 'jiraSettings'
    },
    [(0, $5p1kJ.COMMAND_PALETTE_SECTIONS).atlassianAdmin]: {
        message: (0, $9B2hh.messages).atlassianAdminSection,
        priority: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS_PRIORITY).atlassianAdmin,
        actionCategory: 'atlassianAdmin'
    },
    [(0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickSearch]: {
        message: (0, $9B2hh.messages).quickSearchSection,
        priority: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS_PRIORITY).quickSearch,
        actionCategory: 'quickSearch'
    },
    [(0, $5p1kJ.COMMAND_PALETTE_SECTIONS).forge]: {
        message: (0, $9B2hh.messages).forgeSection,
        priority: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS_PRIORITY).forge,
        actionCategory: 'forge'
    }
};
const $21829c9b16b4c530$export$322b8dfd66fee25d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sections = (0, $5uXOq.useMemo)(()=>Object.entries($21829c9b16b4c530$export$d67bb364b16506d).reduce((acc, [key, entry])=>{
            acc[key] = {
                name: formatMessage(entry.message),
                priority: entry.priority,
                actionCategory: entry.actionCategory
            };
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}), [
        formatMessage
    ]);
    (0, $eC7F7.useRegisterCommandSections)(sections);
};

});
parcelRegister("eC7F7", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandSections", () => $8353d0ce7d354bfa$export$24e75e2bcad1489a);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
const $8353d0ce7d354bfa$export$24e75e2bcad1489a = (sections, deps = [])=>{
    const { registerSections: registerSections, unregisterSections: unregisterSections } = (0, $d8lE2.useActionsCommandPalette)();
    const ids = Object.keys(sections);
    (0, $5uXOq.useEffect)(()=>{
        registerSections(sections);
        return ()=>{
            unregisterSections(sections);
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ...deps,
        registerSections,
        unregisterSections,
        ids.toString()
    ]);
};

});

parcelRegister("9B2hh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $586d67dad3dfd299$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $586d67dad3dfd299$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    containerNavigationSection: {
        "id": "command-palette-integration.controllers.use-register-sections.container-navigation-section",
        "defaultMessage": "Navigation"
    },
    siteNavigationSection: {
        "id": "command-palette-integration.controllers.use-register-sections.site-navigation-section",
        "defaultMessage": "Site navigation"
    },
    quickActionsSection: {
        "id": "command-palette-integration.controllers.use-register-sections.quick-actions-section",
        "defaultMessage": "Quick actions"
    },
    personalSettingsSection: {
        "id": "command-palette-integration.controllers.use-register-sections.personal-settings-section",
        "defaultMessage": "Personal settings"
    },
    helpSection: {
        "id": "command-palette-integration.controllers.use-register-sections.help-section",
        "defaultMessage": "Help"
    },
    jiraSettingsSection: {
        "id": "command-palette-integration.controllers.use-register-sections.jira-settings-section",
        "defaultMessage": "Jira Settings"
    },
    atlassianAdminSection: {
        "id": "command-palette-integration.controllers.use-register-sections.atlassian-admin-section",
        "defaultMessage": "Atlassian admin"
    },
    quickSearchSection: {
        "id": "command-palette-integration.controllers.use-register-sections.quick-search-section",
        "defaultMessage": "Search work"
    },
    forgeSection: {
        "id": "command-palette-integration.controllers.use-register-sections.forge-section",
        "defaultMessage": "Forge Apps"
    }
});

});


parcelRegister("30J2m", function(module, exports) {

$parcel$export(module.exports, "FooterFeedbackContent", () => $11380617c82cbaf5$export$63ddf0170f2bf579);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $d8lE2 = parcelRequire("d8lE2");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $fMS7c = parcelRequire("fMS7c");

var $aai1s = parcelRequire("aai1s");
const $11380617c82cbaf5$export$63ddf0170f2bf579 = ()=>{
    const [openFeedbackCollectorDialog] = (0, $fMS7c.useCommandPaletteFeedbackCollector)();
    const { close: close } = (0, $d8lE2.useActionsCommandPalette)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11380617c82cbaf5$var$FeedbackContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11380617c82cbaf5$var$TextWrapper, null, " ", formatMessage((0, $aai1s.messages).feedbackContentText), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11380617c82cbaf5$var$FeedbackButton, {
        appearance: "subtle-link",
        testId: "command-palette-integration.ui.footer-feedback-content.feedback-button",
        onClick: (event, analyticsEvent)=>{
            close();
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openCommandPaletteFeedbackForm');
            openFeedbackCollectorDialog();
        }
    }, formatMessage((0, $aai1s.messages).feedbackButtonText)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11380617c82cbaf5$var$FeedbackContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1txw _2lx2vrvc _4cvr1h6o _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc _syaz1gjq _1bah1y6m _16ai1gjq",
            __cmplp.className
        ])
    });
});
const $11380617c82cbaf5$var$TextWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1gjq _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11380617c82cbaf5$var$FeedbackButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _4cvr1h6o _k48p1wq8 _18u0v77o _ca0qidpf _u5f3v77o _n3tdidpf _19bvv77o _syazp1wj _4t3i1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fMS7c", function(module, exports) {

$parcel$export(module.exports, "useCommandPaletteFeedbackCollector", () => $2494c13edd81f2e7$export$6db0caae08144d99);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $aai1s = parcelRequire("aai1s");
const $2494c13edd81f2e7$export$6db0caae08144d99 = ()=>{
    const { openFeedbackCollector: openFeedbackCollector, resetFeedbackCollectorState: resetFeedbackCollectorState } = (0, $dseDh.useFeedbackCollectorActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const openCommandPaletteFeedbackCollector = (0, $5uXOq.useCallback)((props)=>{
        openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_COMMAND_PALETTE),
            feedbackTitle: formatMessage((0, $aai1s.messages).feedbackTitle),
            ...props
        });
    }, [
        formatMessage,
        openFeedbackCollector
    ]);
    return [
        openCommandPaletteFeedbackCollector,
        resetFeedbackCollectorState
    ];
};

});
parcelRegister("aai1s", function(module, exports) {

$parcel$export(module.exports, "messages", () => $78e02ca0c9823c33$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $78e02ca0c9823c33$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    feedbackTitle: {
        "id": "command-palette-integration.controllers.use-feedback-collector.feedback-title",
        "defaultMessage": "Share your thoughts"
    },
    feedbackButtonText: {
        "id": "command-palette-integration.controllers.use-feedback-collector.feedback-button-text",
        "defaultMessage": "Let us know"
    },
    feedbackContentText: {
        "id": "command-palette-integration.controllers.use-feedback-collector.feedback-content-text",
        "defaultMessage": "Got feedback?"
    }
});

});



parcelRegister("faBOu", function(module, exports) {

$parcel$export(module.exports, "useRegisterInitialCommands", () => $5c9653a49e3aeaec$export$c84e12da7f59adc);

var $1Kt4o = parcelRequire("1Kt4o");

var $5zCdk = parcelRequire("5zCdk");

var $lAw61 = parcelRequire("lAw61");

var $auYbh = parcelRequire("auYbh");

var $gLlXj = parcelRequire("gLlXj");
const $5c9653a49e3aeaec$export$c84e12da7f59adc = ()=>{
    const copyCommand = (0, $auYbh.useCopyPageUrlCommand)();
    const navigationCommands = (0, $gLlXj.useNavigationCommands)();
    const { issueNavigatorLink: issueNavigatorLink } = (0, $lAw61.useIssueNavigatorLink)();
    (0, $5zCdk.useRegisterCommands)((0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).COPY_URL, [
        copyCommand
    ]);
    (0, $5zCdk.useRegisterCommands)((0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).NAVIGATION_COMMANDS, navigationCommands, [
        issueNavigatorLink
    ]);
};

});
parcelRegister("5zCdk", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommands", () => $c2fc115f119fcec7$export$3f626f8a5dbc29e4);

var $6QoIp = parcelRequire("6QoIp");
const $c2fc115f119fcec7$export$3f626f8a5dbc29e4 = (0, $6QoIp.useRegisterCommandsWithRegistry);

});

parcelRegister("lAw61", function(module, exports) {

$parcel$export(module.exports, "useIssueNavigatorLink", () => $76a7c5131d60f2ad$export$3e785a826ba5bd41);

var $2vSU6 = parcelRequire("2vSU6");

var $43qGj = parcelRequire("43qGj");

var $dAfqg = parcelRequire("dAfqg");

var $gg0fv = parcelRequire("gg0fv");
const $76a7c5131d60f2ad$export$3e785a826ba5bd41 = ()=>{
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const { data: features } = (0, $43qGj.useFeatures)();
    if (!projectContextData?.projectType || !projectContextData?.projectKey || typeof projectContextData?.simplified !== 'boolean') return {
        issueNavigatorLink: null
    };
    const issueNavigatorLink = (0, $gg0fv.generateNinBasePath)(projectContextData.projectKey, projectContextData.projectType, projectContextData.simplified);
    // Service Desk and Business Projects have Issue Navigator feature permanently on
    let isIssueNavigatoraEnabled = true;
    // Only Jira Software projects have the ability to toggle the Issue Navigator feature
    if (projectContextData.projectType === (0, $2vSU6.SOFTWARE_PROJECT)) isIssueNavigatoraEnabled = features?.hasSIN || false;
    return {
        issueNavigatorLink: isIssueNavigatoraEnabled ? issueNavigatorLink : null
    };
};

});
parcelRegister("43qGj", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $64d4caaed133b77d$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $4bPSV = parcelRequire("4bPSV");

var $hDSPU = parcelRequire("hDSPU");

var $iHqA4 = parcelRequire("iHqA4");

var $j8sa8 = parcelRequire("j8sa8");
const $64d4caaed133b77d$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $hDSPU.useSidebarFeatureToggled)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $4bPSV.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $5uXOq.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $iHqA4.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4bPSV", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4795c1c4367ea315$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");
const $4795c1c4367ea315$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});

parcelRegister("hDSPU", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $605ea180d8f833cc$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $605ea180d8f833cc$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $605ea180d8f833cc$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6wyfe = parcelRequire("6wyfe");
const $605ea180d8f833cc$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $605ea180d8f833cc$var$store = (0, $iXqE5.createStore)({
    name: 'feature-toggle',
    initialState: $605ea180d8f833cc$var$initialState,
    actions: $6wyfe.actions
});
const $605ea180d8f833cc$export$fc97652867e5867e = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store);
const $605ea180d8f833cc$export$207b461610a7fca6 = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $605ea180d8f833cc$export$e7699ed698eeb9ec = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $605ea180d8f833cc$export$9eef668f94562feb = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("6wyfe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $158a47dbcbb0832b$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");

var $3Jf4N = parcelRequire("3Jf4N");

var $czzsL = parcelRequire("czzsL");

var $iZZTd = parcelRequire("iZZTd");

var $ke207 = parcelRequire("ke207");
const $158a47dbcbb0832b$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $158a47dbcbb0832b$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $iZZTd.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $czzsL.filterAndSort)(data);
                (0, $czzsL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $158a47dbcbb0832b$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $3Jf4N.getFeatureMap)({
            isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $158a47dbcbb0832b$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $3Jf4N.getFeatureMap)();
        if ((0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $3Jf4N.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $czzsL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $ke207.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $158a47dbcbb0832b$export$e324594224ef24da = {
    fetchFeatures: $158a47dbcbb0832b$var$fetchFeatures,
    updateFeature: $158a47dbcbb0832b$var$updateFeature,
    syncFeatures: $158a47dbcbb0832b$var$syncFeatures,
    clearSiderbarFeatureToggled: $158a47dbcbb0832b$var$clearSiderbarFeatureToggled
};

});
parcelRegister("3Jf4N", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $d07f845012e39eac$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $d07f845012e39eac$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $d07f845012e39eac$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "getFeatureMap", () => $d07f845012e39eac$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $d07f845012e39eac$export$f5e4c120ac01b615);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8QpSo = parcelRequire("8QpSo");

var $QasRB = parcelRequire("QasRB");

var $dME4E = parcelRequire("dME4E");

var $aZ5rg = parcelRequire("aZ5rg");

var $lfDf7 = parcelRequire("lfDf7");

var $eQfWH = parcelRequire("eQfWH");

var $k2Gga = parcelRequire("k2Gga");
const $d07f845012e39eac$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $d07f845012e39eac$export$143e1d685830adbe = 'manage-feature-menu-item';
const $d07f845012e39eac$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ5rg))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            'software-list'
        ]
    }
};
const $d07f845012e39eac$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2Gga))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $d07f845012e39eac$export$6ac50cf33852adb5 = (0, $8QpSo.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2Gga))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        ...isListViewEnabled && $d07f845012e39eac$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $d07f845012e39eac$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});
parcelRegister("QasRB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8757186054f9d759a1f776986ffd32d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09ccf97ba5b2cc01$var$_react = $09ccf97ba5b2cc01$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $09ccf97ba5b2cc01$var$_backlog = $09ccf97ba5b2cc01$var$_interopRequireDefault((parcelRequire("bRTCF")));

var $09ccf97ba5b2cc01$var$_backlog2 = $09ccf97ba5b2cc01$var$_interopRequireDefault((parcelRequire("adDD5")));
function $09ccf97ba5b2cc01$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BacklogIcon.
 * This component is BacklogIcon, with `UNSAFE_fallbackIcon` set to "BacklogIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09ccf97ba5b2cc01$var$BacklogIcon = (props)=>/*#__PURE__*/ $09ccf97ba5b2cc01$var$_react.default.createElement($09ccf97ba5b2cc01$var$_backlog.default, Object.assign({
        LEGACY_fallbackIcon: $09ccf97ba5b2cc01$var$_backlog2.default
    }, props));
$09ccf97ba5b2cc01$var$BacklogIcon.Name = 'BacklogIconMigration';
var $09ccf97ba5b2cc01$var$_default = module.exports.default = $09ccf97ba5b2cc01$var$BacklogIcon;

});
parcelRegister("bRTCF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a3fca7537c506d3$var$_react = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8a3fca7537c506d3$var$_baseNew = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8a3fca7537c506d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a3fca7537c506d3$var$BacklogIcon = (props)=>/*#__PURE__*/ $8a3fca7537c506d3$var$_react.default.createElement($8a3fca7537c506d3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$8a3fca7537c506d3$var$BacklogIcon.displayName = 'BacklogIcon';
var $8a3fca7537c506d3$var$_default = module.exports.default = $8a3fca7537c506d3$var$BacklogIcon;

});

parcelRegister("adDD5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7709dbddc6671c4c$var$_react = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7709dbddc6671c4c$var$_backlog = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("bRTCF")));
function $7709dbddc6671c4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7709dbddc6671c4c$var$BacklogIcon = (props)=>/*#__PURE__*/ $7709dbddc6671c4c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $7709dbddc6671c4c$var$_backlog.default
    }));
$7709dbddc6671c4c$var$BacklogIcon.displayName = 'BacklogIcon';
var $7709dbddc6671c4c$var$_default = module.exports.default = $7709dbddc6671c4c$var$BacklogIcon;

});


parcelRegister("aZ5rg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e406a416cb0a4f8d2c2370983b384961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ff3d1eb1c83e4c4$var$_react = $7ff3d1eb1c83e4c4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7ff3d1eb1c83e4c4$var$_listBulleted = $7ff3d1eb1c83e4c4$var$_interopRequireDefault((parcelRequire("bEjt9")));

var $7ff3d1eb1c83e4c4$var$_bulletList = $7ff3d1eb1c83e4c4$var$_interopRequireDefault((parcelRequire("90gd1")));
function $7ff3d1eb1c83e4c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "BulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ff3d1eb1c83e4c4$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $7ff3d1eb1c83e4c4$var$_react.default.createElement($7ff3d1eb1c83e4c4$var$_listBulleted.default, Object.assign({
        LEGACY_fallbackIcon: $7ff3d1eb1c83e4c4$var$_bulletList.default
    }, props));
$7ff3d1eb1c83e4c4$var$ListBulletedIcon.Name = 'ListBulletedIconMigration';
var $7ff3d1eb1c83e4c4$var$_default = module.exports.default = $7ff3d1eb1c83e4c4$var$ListBulletedIcon;

});
parcelRegister("bEjt9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87b28849bcb64a34$var$_react = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87b28849bcb64a34$var$_baseNew = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87b28849bcb64a34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87b28849bcb64a34$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $87b28849bcb64a34$var$_react.default.createElement($87b28849bcb64a34$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$87b28849bcb64a34$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $87b28849bcb64a34$var$_default = module.exports.default = $87b28849bcb64a34$var$ListBulletedIcon;

});

parcelRegister("90gd1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68e0afe9fd548c5c$var$_react = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $68e0afe9fd548c5c$var$_listBulleted = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("bEjt9")));
function $68e0afe9fd548c5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68e0afe9fd548c5c$var$BulletListIcon = (props)=>/*#__PURE__*/ $68e0afe9fd548c5c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $68e0afe9fd548c5c$var$_listBulleted.default
    }));
$68e0afe9fd548c5c$var$BulletListIcon.displayName = 'BulletListIcon';
var $68e0afe9fd548c5c$var$_default = module.exports.default = $68e0afe9fd548c5c$var$BulletListIcon;

});


parcelRegister("k2Gga", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478474977414af6f20354d0841ac3249>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e974c67850595917$var$_react = $e974c67850595917$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e974c67850595917$var$_roadmap = $e974c67850595917$var$_interopRequireDefault((parcelRequire("ifnb0")));

var $e974c67850595917$var$_roadmap2 = $e974c67850595917$var$_interopRequireDefault((parcelRequire("i3vuN")));
function $e974c67850595917$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RoadmapIcon.
 * This component is RoadmapIcon, with `UNSAFE_fallbackIcon` set to "RoadmapIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e974c67850595917$var$RoadmapIcon = (props)=>/*#__PURE__*/ $e974c67850595917$var$_react.default.createElement($e974c67850595917$var$_roadmap.default, Object.assign({
        LEGACY_fallbackIcon: $e974c67850595917$var$_roadmap2.default
    }, props));
$e974c67850595917$var$RoadmapIcon.Name = 'RoadmapIconMigration';
var $e974c67850595917$var$_default = module.exports.default = $e974c67850595917$var$RoadmapIcon;

});
parcelRegister("i3vuN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d250f039686fbf24$var$_react = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d250f039686fbf24$var$_roadmap = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("ifnb0")));
function $d250f039686fbf24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d250f039686fbf24$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d250f039686fbf24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $d250f039686fbf24$var$_roadmap.default
    }));
$d250f039686fbf24$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d250f039686fbf24$var$_default = module.exports.default = $d250f039686fbf24$var$RoadmapIcon;

});



parcelRegister("czzsL", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $0a04151ee5a00965$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $0a04151ee5a00965$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $0a04151ee5a00965$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $0a04151ee5a00965$export$5da1e8c5ba5c0dc2);

var $hqTkp = parcelRequire("hqTkp");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $3Jf4N = parcelRequire("3Jf4N");
const $0a04151ee5a00965$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $0a04151ee5a00965$export$d0e0de50c701304c = (features)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $0a04151ee5a00965$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $0a04151ee5a00965$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $0a04151ee5a00965$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $jcw0u.default)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});
parcelRegister("hqTkp", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, values) : [];
});
module.exports = $cb0fc8686550aa11$var$without;

});


parcelRegister("iZZTd", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $140b4a0769fd2090$export$c20100b185d41ab0);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $140b4a0769fd2090$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $eusud.performGetRequest)((0, $8djOx.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8djOx", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $45a3789113fa4e8b$export$3f9939d302766b52);
const $45a3789113fa4e8b$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("ke207", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $1ce9149bd154bcf9$export$61f6bbb745b3a3);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $1ce9149bd154bcf9$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $eusud.performPutRequest)((0, $8djOx.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("iHqA4", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $b80f211a69d994c6$export$2946f555c6f48127);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $1J3t1 = parcelRequire("1J3t1");

var $1XJ20 = parcelRequire("1XJ20");

var $hDSPU = parcelRequire("hDSPU");

var $j8sa8 = parcelRequire("j8sa8");
const $b80f211a69d994c6$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $hDSPU.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $5uXOq.useRef)(false);
    const previousData = (0, $1XJ20.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $5uXOq.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $5uXOq.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("j8sa8", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $d568e02a383436d9$export$7deca16ba2d9eb74);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $dkqym = parcelRequire("dkqym");
const $d568e02a383436d9$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("dkqym", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $61794ef454831b86$export$9df3a539e50a284b);

var $9OXo1 = parcelRequire("9OXo1");
const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});




parcelRegister("gg0fv", function(module, exports) {

$parcel$export(module.exports, "generateNinBasePath", () => $1f09af27cff5f032$export$47d9a807c1277671);

var $2vSU6 = parcelRequire("2vSU6");
const $1f09af27cff5f032$export$ddaf187654250a8d = '/issues/';
const $1f09af27cff5f032$export$47d9a807c1277671 = (projectKey, projectType, isSimplifiedProject)=>{
    const getMainPath = (projectPath, simplified = true)=>`/jira/${projectPath}${!simplified ? '/c' : ''}/projects/${projectKey}/issues`;
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return getMainPath('core');
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return getMainPath('servicedesk');
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return getMainPath('software', isSimplifiedProject);
        default:
            return $1f09af27cff5f032$export$ddaf187654250a8d; // Fall back to GIN
    }
};

});


parcelRegister("auYbh", function(module, exports) {

$parcel$export(module.exports, "useCopyPageUrlCommand", () => $65c115d952a83ae0$export$e4eb2b3d3a5a5045);

var $5uXOq = parcelRequire("5uXOq");

var $3Fq5M = parcelRequire("3Fq5M");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $jh7L9 = parcelRequire("jh7L9");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $bSVn9 = parcelRequire("bSVn9");

var $gHgQ0 = parcelRequire("gHgQ0");
const $65c115d952a83ae0$export$e4eb2b3d3a5a5045 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const copyToClipboard = async ()=>{
        try {
            await (0, $gHgQ0.getNavigator)().clipboard.writeText((0, $gHgQ0.getWindow)().location.href);
            showFlag({
                type: 'success',
                title: (0, $bSVn9.messages).successTitleCopiedUrl,
                messageId: 'command-palette-integration.ui.initial-commands.use-copy-page-url.show-flag.success',
                messageType: 'transactional'
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            showFlag({
                type: 'error',
                title: (0, $bSVn9.messages).errorTitleCopiedUrl,
                description: (0, $bSVn9.messages).errorDescriptionCopiedUrl,
                messageId: 'command-palette-integration.ui.initial-commands.use-copy-page-url.show-flag.error',
                messageType: 'transactional'
            });
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'commandPaletteCopyUrlToClipboard',
                    packageName: 'jiraCommandPaletteIntegration',
                    teamName: 'deliveroo'
                }
            });
        }
    };
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    return {
        id: 'copy-page-url',
        name: formatMessage((0, $bSVn9.messages).commandCommandLabel),
        keywords: getKeywords('copyCurrentPageUrlSynonyms'),
        primaryAction: {
            type: (0, $jh7L9.CommandActionType).PERFORM,
            perform: copyToClipboard
        },
        section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
        priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).copyUrl,
        components: {
            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
                    spacing: "spacious",
                    label: formatMessage((0, $bSVn9.messages).commandCommandLabel)
                })
        },
        analytics: {
            action: 'copyPageURL'
        }
    };
};

});
parcelRegister("5rVQI", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $c7aab549acec9d6e$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $c7aab549acec9d6e$export$5ea2dca0a260365d = /*#__PURE__*/ function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openFilterPopup"] = 5] = "openFilterPopup";
    return COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY;
}({});

});

parcelRegister("bSVn9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $afbd00f8ee321a49$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $afbd00f8ee321a49$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    successTitleCopiedUrl: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.success-title-copied-url",
        "defaultMessage": "Page URL copied to clipboard"
    },
    errorTitleCopiedUrl: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.error-title-copied-url",
        "defaultMessage": "We couldn't copy the page URL"
    },
    errorDescriptionCopiedUrl: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.error-description-copied-url",
        "defaultMessage": "Please check your browser settings."
    },
    commandCommandLabel: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.command-command-label",
        "defaultMessage": "Copy current page URL"
    }
});

});

parcelRegister("gHgQ0", function(module, exports) {

$parcel$export(module.exports, "getWindow", () => $aa7ea9975b9801d2$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getNavigator", () => $aa7ea9975b9801d2$export$a56241c767c1d89f);
/* istanbul ignore file */ const $aa7ea9975b9801d2$export$38b2d434cce3ea22 = ()=>window;
const $aa7ea9975b9801d2$export$a56241c767c1d89f = ()=>navigator;

});


parcelRegister("gLlXj", function(module, exports) {

$parcel$export(module.exports, "useNavigationCommands", () => $8320b3f6a0447126$export$997e3c408ba63e3b);

var $5uXOq = parcelRequire("5uXOq");

var $eGdV2 = parcelRequire("eGdV2");

var $k2tiP = parcelRequire("k2tiP");

var $3JGmH = parcelRequire("3JGmH");

var $5p1kJ = parcelRequire("5p1kJ");

var $4l54H = parcelRequire("4l54H");

var $eG9rp = parcelRequire("eG9rp");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $1C2yb = parcelRequire("1C2yb");

var $h9iZl = parcelRequire("h9iZl");

var $cYlk7 = parcelRequire("cYlk7");

var $jP33S = parcelRequire("jP33S");

var $dDmlh = parcelRequire("dDmlh");

var $b6S3k = parcelRequire("b6S3k");

var $8jQu6 = parcelRequire("8jQu6");

var $foR3E = parcelRequire("foR3E");

var $7ziML = parcelRequire("7ziML");

var $9OXo1 = parcelRequire("9OXo1");

var $lAw61 = parcelRequire("lAw61");


var $afAJS = parcelRequire("afAJS");
const $8320b3f6a0447126$export$997e3c408ba63e3b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const { issueNavigatorLink: issueNavigatorLink } = (0, $lAw61.useIssueNavigatorLink)();
    const { hideAndTransformNavigationCommands: hideAndTransformNavigationCommands } = (0, $4l54H.useTransformNavigationCommands)();
    const { data: data } = (0, $cYlk7.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const email = data.user?.emailAddress;
    const accountSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(email || undefined);
    const [isPlansVisible] = (0, $h9iZl.useNavigationPlansVisibility)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const commands = hideAndTransformNavigationCommands([
        {
            command: {
                id: (0, $e4a6563fd1445b08$export$2d4af8d3471f446),
                name: formatMessage((0, $afAJS.default).viewAllProjects),
                keywords: getKeywords('viewAllProjectsSynonyms'),
                section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).siteNavigation,
                priority: (0, $5p1kJ.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToProjects,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                            spacing: "spacious",
                            label: formatMessage((0, $afAJS.default).viewAllProjects)
                        })
                },
                analytics: {
                    action: 'viewAllProjects'
                }
            },
            path: (0, $foR3E.projectsDirectoryRoute)
        },
        {
            command: {
                id: (0, $e4a6563fd1445b08$export$bfa43d3c5bfbcf35),
                name: formatMessage((0, $afAJS.default).viewAllFilters),
                keywords: getKeywords('viewAllFiltersSynonyms'),
                section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).siteNavigation,
                priority: (0, $5p1kJ.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToFilters,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                            spacing: "spacious",
                            label: formatMessage((0, $afAJS.default).viewAllFilters)
                        })
                },
                analytics: {
                    action: 'viewAllFilters'
                }
            },
            path: (0, $b6S3k.filtersDirectoryRoute)
        },
        {
            command: {
                id: (0, $e4a6563fd1445b08$export$538e0daca84e7e29),
                name: formatMessage((0, $afAJS.default).viewAllDashboards),
                keywords: getKeywords('viewAllDashboardsSynonyms'),
                section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).siteNavigation,
                priority: (0, $5p1kJ.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToDashboards,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                            spacing: "spacious",
                            label: formatMessage((0, $afAJS.default).viewAllDashboards)
                        })
                },
                analytics: {
                    action: 'viewAllDashboards'
                }
            },
            path: (0, $dDmlh.dashboardsDirectoryRoute)
        },
        {
            command: {
                id: (0, $e4a6563fd1445b08$export$98cbb2f7230db2a1),
                name: formatMessage((0, $afAJS.default).goToPersonalSettings),
                keywords: getKeywords('goToPersonalSettingsSynonyms'),
                section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).personalSettings,
                priority: (0, $5p1kJ.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).goToPersonalSettings,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
                            spacing: "spacious",
                            label: formatMessage((0, $afAJS.default).goToPersonalSettings)
                        })
                },
                analytics: {
                    action: 'goToPersonalSettings'
                }
            },
            path: (0, $7ziML.generalPersonalSettingsRoute),
            hideCommandPath: (0, $1C2yb.getGeneralPersonalSettingsPath)()
        },
        {
            command: {
                id: (0, $e4a6563fd1445b08$export$7e8556985118cd1e),
                name: formatMessage((0, $afAJS.default).viewAllBoards),
                keywords: getKeywords('viewAllBoardsSynonyms'),
                section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).siteNavigation,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                            spacing: "spacious",
                            label: formatMessage((0, $afAJS.default).viewAllBoards)
                        })
                },
                priority: (0, $5p1kJ.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToBoards,
                analytics: {
                    action: 'viewAllBoards'
                }
            },
            path: (0, $jP33S.boardsDirectoryRoute)
        },
        {
            command: {
                id: (0, $e4a6563fd1445b08$export$7976f2daa1e8078a),
                name: formatMessage((0, $afAJS.default).goToAccountSettings),
                keywords: getKeywords('goToAccountSettingsSynonyms'),
                section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).personalSettings,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
                            spacing: "spacious",
                            label: formatMessage((0, $afAJS.default).goToAccountSettings)
                        })
                },
                priority: (0, $5p1kJ.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).goToAccountSettings,
                analytics: {
                    action: 'goToAccountSettings'
                }
            },
            path: accountSettingsLink,
            shouldAlwaysOpenNewTab: true
        },
        ...issueNavigatorLink ? [
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$f3211b812cd1a523),
                    name: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $afAJS.default).goToIssuesIssueTermRefresh : (0, $afAJS.default).goToIssues),
                    keywords: getKeywords('goToIssuesSynonyms'),
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).containerNavigation,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                                spacing: "spacious",
                                label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $afAJS.default).goToIssuesIssueTermRefresh : (0, $afAJS.default).goToIssues)
                            })
                    },
                    priority: (0, $5p1kJ.COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY).goToIssues,
                    analytics: {
                        action: 'goToIssues'
                    }
                },
                path: issueNavigatorLink,
                hideCommandPath: (0, $foR3E.projectsDirectoryRoute).path
            }
        ] : [],
        ...isPlansVisible ? [
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$653733b43ae1b993),
                    name: formatMessage((0, $afAJS.default).viewAllPlans),
                    keywords: getKeywords('viewAllPlansSynonyms'),
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).siteNavigation,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                                spacing: "spacious",
                                label: formatMessage((0, $afAJS.default).viewAllPlans)
                            })
                    },
                    priority: (0, $5p1kJ.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToPlans,
                    analytics: {
                        action: 'viewAllPlans'
                    }
                },
                path: (0, $8jQu6.plansDirectoryRoute)
            }
        ] : [],
        ...isSiteAdmin ? [
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$9ede11404253696),
                    name: formatMessage((0, $afAJS.default).goToUserManagement),
                    keywords: getKeywords('goToUserManagementSynonyms'),
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).atlassianAdmin,
                    priority: (0, $5p1kJ.COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY).userManagement,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
                                spacing: "spacious",
                                label: formatMessage((0, $afAJS.default).goToUserManagement)
                            })
                    },
                    analytics: {
                        action: 'goToUserManagement'
                    }
                },
                path: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                shouldAlwaysOpenNewTab: true
            },
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$bf77ae178e5e5984),
                    name: formatMessage((0, $afAJS.default).goToBilling),
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).atlassianAdmin,
                    priority: (0, $5p1kJ.COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY).billing,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
                                spacing: "spacious",
                                label: formatMessage((0, $afAJS.default).goToBilling)
                            })
                    },
                    analytics: {
                        action: 'goToBilling'
                    }
                },
                path: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                shouldAlwaysOpenNewTab: true
            }
        ] : []
    ]);
    return commands;
};

});
parcelRegister("3JGmH", function(module, exports) {

$parcel$export(module.exports, "JIRA_SETTINGS_SECTION_IDS", () => $421ed2d9886b9bc8$export$7266225366740ba0);
$parcel$export(module.exports, "ADMIN_SETTINGS_ITEM_IDS", () => $421ed2d9886b9bc8$export$4718c8ac53a477e1);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_IDS", () => $421ed2d9886b9bc8$export$b23679adb37958a8);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_HREFS", () => $421ed2d9886b9bc8$export$9cc74e3c0b8831f9);
const $421ed2d9886b9bc8$export$7266225366740ba0 = {
    SETTINGS_TITLE: 'settings-title',
    SITE_ADMIN: 'site-admin',
    SYSTEM_ADMIN: 'system-admin',
    OPS_ADMIN: 'ops-admin',
    TRUSTED_USER: 'trusted-user',
    PERSONAL: 'personal-settings'
};
const $421ed2d9886b9bc8$export$4718c8ac53a477e1 = {
    SYSTEM: 'admin-system-menu',
    APPLICATIONS: 'admin-applications-menu',
    ISSUES: 'admin-issues-menu',
    WORK: 'admin-issues-menu-issue-term-refresh',
    PLUGINS: 'admin-plugins-menu',
    RECOMMENDATIONS: 'admin-recommendations',
    MANAGE_PROJECTS: 'admin-manage-project-menu'
};
const $421ed2d9886b9bc8$export$b23679adb37958a8 = {
    USER_MANAGEMENT: 'user-management-section',
    BILLING: 'admin-billing-section'
};
const $421ed2d9886b9bc8$export$9cc74e3c0b8831f9 = {
    USER_MANAGEMENT: '/admin/users?referrerName=JIRA',
    BILLING: '/admin/billing-preview?referrerName=JIRA'
};

});

parcelRegister("2EqxS", function(module, exports) {

$parcel$export(module.exports, "useAtlassianPersonalSettingsLink", () => $58d844745b0a5554$export$8ac70acdad00754b);
$parcel$export(module.exports, "useSwitchAccountLink", () => $58d844745b0a5554$export$dce6af3168fb6ced);
$parcel$export(module.exports, "useProfileLink", () => $58d844745b0a5554$export$b8f25e615dd30d7b);
$parcel$export(module.exports, "getBeforeEntity", () => $58d844745b0a5554$export$5b8580d0254a9349);
$parcel$export(module.exports, "getBoardLink", () => $58d844745b0a5554$export$ff5c49b7852aca68);
$parcel$export(module.exports, "getLinkFromProject", () => $58d844745b0a5554$export$dd9458ee44edd0c6);
$parcel$export(module.exports, "getQueueLink", () => $58d844745b0a5554$export$b44363840d1b683e);
$parcel$export(module.exports, "getIsClassicSoftwareProject", () => $58d844745b0a5554$export$286ea82aef1c76e9);
$parcel$export(module.exports, "getUsersApps", () => $58d844745b0a5554$export$ad0fd737fbd4a083);

var $ebyGx = parcelRequire("ebyGx");

var $5euJh = parcelRequire("5euJh");

var $j0xEB = parcelRequire("j0xEB");

var $iN5FK = parcelRequire("iN5FK");

var $hqguB = parcelRequire("hqguB");

var $kk6FJ = parcelRequire("kk6FJ");

var $ludxj = parcelRequire("ludxj");

var $urQ6o = parcelRequire("urQ6o");

var $7M8Tn = parcelRequire("7M8Tn");

var $7wTzh = parcelRequire("7wTzh");

var $lB6pS = parcelRequire("lB6pS");

var $lyCs2 = parcelRequire("lyCs2");

var $ee0rS = parcelRequire("ee0rS");

var $90yGq = parcelRequire("90yGq");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");
const $58d844745b0a5554$export$ab902790e443b0ec = ()=>`${(0, $5euJh.getATLContextUrl)('id')}/login`;
const $58d844745b0a5554$export$8ac70acdad00754b = (destinationAccountEmail)=>{
    const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
    const destinationUrl = `${(0, $5euJh.getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
    return destinationAccountEmail ? `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        application: 'jira',
        continue: destinationUrl,
        login_hint: destinationAccountEmail,
        prompt: 'none'
    })}` : destinationUrl;
};
const $58d844745b0a5554$export$dce6af3168fb6ced = ()=>{
    const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
    const { href: href } = (0, $j0xEB.default)() || {};
    return `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        application: 'jira',
        continue: href,
        prompt: 'select_account'
    })}`;
};
const $58d844745b0a5554$export$b8f25e615dd30d7b = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    return `/jira/people/${accountId || ''}`;
};
const $58d844745b0a5554$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
        id: String(favoriteItems[0].id),
        type: favoriteItems[0].type
    } : {
        id: undefined,
        type: undefined
    };
const $58d844745b0a5554$export$ff5c49b7852aca68 = (item)=>{
    const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
    const boardId = String(id);
    if (parentType === 'project') {
        // @ts-expect-error - TS2339 - Property 'nextgen' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectKey' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectType' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, $hqguB.jiraBusinessProjectRedirectRoute)
        };
        if (projectType === 'service_desk') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $kk6FJ.jsmBoardRoute)
        };
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7wTzh.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $lB6pS.classicSoftwareBoardRoute)
        };
    }
    if (parentType === 'user') {
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { userAccountId: accountId } = attributes;
        return {
            params: {
                boardId: boardId,
                accountId: accountId
            },
            query: {},
            route: (0, $lyCs2.userBoardRoute)
        };
    }
    return {
        params: undefined,
        query: undefined,
        route: undefined
    };
};
const $58d844745b0a5554$export$dd9458ee44edd0c6 = (item)=>{
    const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
    if (projectType === 'business') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $hqguB.jiraBusinessProjectRedirectRoute)
    };
    if (boardId !== undefined) {
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7wTzh.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $lB6pS.classicSoftwareBoardRoute)
        };
    }
    if (projectType === 'service_desk') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $ludxj.projectServiceDeskRoute)
    };
    return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $iN5FK.browseProjectRedirectRoute)
    };
};
const $58d844745b0a5554$export$b44363840d1b683e = (item)=>{
    const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
    return {
        params: {
            projectKey: projectKey,
            ...queuesCategory != null && queuesCategory !== '' ? {
                practiceType: (0, $ee0rS.toShortFormItsmPractice)(queuesCategory)
            } : {},
            queueId: String(id)
        },
        route: queuesCategory != null && queuesCategory !== '' ? (0, $urQ6o.customPracticeQueueRoute) : (0, $7M8Tn.customQueueRoute)
    };
};
const $58d844745b0a5554$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
const $58d844745b0a5554$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, $lmyls.ADDON_ID).DISCOVER);

});
parcelRegister("j0xEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b1198aeec732ce1$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $9b1198aeec732ce1$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("iN5FK", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRoute", () => $84aa7aa5982a6e60$export$f9cac37753487f39);
const $84aa7aa5982a6e60$export$f9cac37753487f39 = {
    name: 'browse-project-redirect',
    path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
    exact: true
};

});

parcelRegister("hqguB", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $abd9824736763ae8$export$73b60789ceb8e1eb);
const $abd9824736763ae8$export$73b60789ceb8e1eb = {
    name: 'classic-business-redirect',
    path: '/jira/core/projects/:projectKey',
    exact: true
};

});

parcelRegister("kk6FJ", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRoute", () => $f1ec4cbb5ae8c6af$export$a192088aab559fa1);
const $f1ec4cbb5ae8c6af$export$a192088aab559fa1 = {
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: 'servicedesk-boards',
    exact: true
};

});

parcelRegister("ludxj", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRoute", () => $be54e9dad71bd630$export$1cfc858068dd8718);
const $be54e9dad71bd630$export$1cfc858068dd8718 = {
    name: 'servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey',
    exact: true
};

});

parcelRegister("urQ6o", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueRoute", () => $41bd265d7c0f4884$export$59d0bd42aa07faad);
const $41bd265d7c0f4884$export$59d0bd42aa07faad = {
    name: 'servicedesk-practice-custom-and-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("7M8Tn", function(module, exports) {

$parcel$export(module.exports, "customQueueRoute", () => $c0c93413dba087be$export$e1fac82ca0b0d637);
const $c0c93413dba087be$export$e1fac82ca0b0d637 = {
    name: 'servicedesk-queues-custom-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("7wTzh", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRoute", () => $4f781bb234c1132b$export$9ae2c0a566d4e0f6);
const $4f781bb234c1132b$export$9ae2c0a566d4e0f6 = {
    name: 'software-boards',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("lB6pS", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $9dbec22457c8ec85$export$131d51ca54849e97);
const $9dbec22457c8ec85$export$131d51ca54849e97 = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("lyCs2", function(module, exports) {

$parcel$export(module.exports, "userBoardRoute", () => $a9c2c98045690ca6$export$57a2a0fe739f16);
const $a9c2c98045690ca6$export$57a2a0fe739f16 = {
    name: 'rapidboard-user-board',
    path: '/jira/people/:accountId/boards/:boardId'
};

});

parcelRegister("ee0rS", function(module, exports) {

$parcel$export(module.exports, "toShortFormItsmPractice", () => $3a8490f36704bba6$export$db58a56259f511a2);

var $oCMSG = parcelRequire("oCMSG");
const $3a8490f36704bba6$var$longToShortConversionMap = {
    [(0, $oCMSG.CHANGES)]: (0, $oCMSG.SHORT_FORM_CHANGES),
    [(0, $oCMSG.INCIDENTS)]: (0, $oCMSG.SHORT_FORM_INCIDENTS),
    [(0, $oCMSG.PROBLEMS)]: (0, $oCMSG.SHORT_FORM_PROBLEMS),
    [(0, $oCMSG.SERVICE_REQUEST)]: (0, $oCMSG.SHORT_FORM_SERVICE_REQUEST),
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: (0, $oCMSG.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $oCMSG.DEVELOPER_ESCALATION)]: (0, $oCMSG.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $3a8490f36704bba6$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $3a8490f36704bba6$var$longToShortConversionMap;
}
const $3a8490f36704bba6$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($3a8490f36704bba6$var$isLongForm(workCategoryKey)) return $3a8490f36704bba6$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});

parcelRegister("lmyls", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $ee51d260cb059727$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $ee51d260cb059727$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $ee51d260cb059727$export$adf978edbdfaf080);
const $ee51d260cb059727$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $ee51d260cb059727$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    COMMUNICATIONS: 'COMMUNICATIONS',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};
const $ee51d260cb059727$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    CONTENT: 'CONTENT',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS',
    OPERATIONS_GENERAL_CONFIGURATION: 'OPERATIONS_GENERAL_CONFIGURATION'
};

});

parcelRegister("6cNb0", function(module, exports) {

$parcel$export(module.exports, "testIdConcat", () => $c1f136d19203abbc$export$794609946480f79c);
$parcel$export(module.exports, "testIdGenerate", () => $c1f136d19203abbc$export$3b86b974ae586844);
const $c1f136d19203abbc$var$PREFIX = 'atlassian-navigation-';
const $c1f136d19203abbc$var$SEPARATOR = '--';
const $c1f136d19203abbc$var$isValid = (value)=>value != null && value !== '';
const $c1f136d19203abbc$export$794609946480f79c = (id, ...items)=>[
        id,
        ...items
    ].filter(Boolean).join($c1f136d19203abbc$var$SEPARATOR).toLowerCase();
const $c1f136d19203abbc$export$3b86b974ae586844 = (first, ...rest)=>// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    $c1f136d19203abbc$export$794609946480f79c($c1f136d19203abbc$var$PREFIX + ($c1f136d19203abbc$var$isValid(first) ? `-${first}` : ''), ...rest);

});


parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>// eslint-disable-next-line react-hooks/react-compiler
    (0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});

parcelRegister("jP33S", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRoute", () => $3c2c0ea0e55873e8$export$f0fc6f4e8be87e85);
const $3c2c0ea0e55873e8$export$f0fc6f4e8be87e85 = {
    name: 'boards-directory',
    path: '/jira/boards'
};

});

parcelRegister("dDmlh", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $fd66dc0239264856$export$41bba408475cab16);
const $fd66dc0239264856$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});

parcelRegister("b6S3k", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $45a85df0dbaf23d9$export$6350f52c8b40042d);
const $45a85df0dbaf23d9$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});

parcelRegister("8jQu6", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $f8b07af15c3bb184$export$143b4a1ef2ffc051);
const $f8b07af15c3bb184$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});

parcelRegister("foR3E", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $00577c595d2649c4$export$74114064f06cd71b);
const $00577c595d2649c4$export$74114064f06cd71b = {
    name: 'projects-directory',
    path: '/jira/projects',
    exact: true
};

});

parcelRegister("7ziML", function(module, exports) {

$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $bac161cf2450c76e$export$7a6c9715a86f906b);
const $bac161cf2450c76e$export$7a6c9715a86f906b = {
    name: 'personal-settings-general',
    path: '/jira/settings/personal/general'
};

});

const $e4a6563fd1445b08$export$2d4af8d3471f446 = 'view-all-projects';
const $e4a6563fd1445b08$export$bfa43d3c5bfbcf35 = 'view-all-filters';
const $e4a6563fd1445b08$export$538e0daca84e7e29 = 'view-all-dashboards';
const $e4a6563fd1445b08$export$f3211b812cd1a523 = 'go-to-issues';
const $e4a6563fd1445b08$export$98cbb2f7230db2a1 = 'go-to-personal-settings';
const $e4a6563fd1445b08$export$7e8556985118cd1e = 'view-all-boards';
const $e4a6563fd1445b08$export$7976f2daa1e8078a = 'go-to-account-settings';
const $e4a6563fd1445b08$export$653733b43ae1b993 = 'view-all-plans';
const $e4a6563fd1445b08$export$9ede11404253696 = 'site-admin-user-management';
const $e4a6563fd1445b08$export$bf77ae178e5e5984 = 'site-admin-billing';

parcelRegister("afAJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9764882f15a7a1cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9764882f15a7a1cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllProjects: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-projects",
        "defaultMessage": "View all projects"
    },
    viewAllFilters: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-filters",
        "defaultMessage": "View all filters"
    },
    viewAllDashboards: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-dashboards",
        "defaultMessage": "View all dashboards"
    },
    goToIssues: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-issues",
        "defaultMessage": "Go to issues"
    },
    goToPersonalSettings: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-personal-settings",
        "defaultMessage": "Go to personal settings"
    },
    viewAllBoards: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-boards",
        "defaultMessage": "View all boards"
    },
    goToAccountSettings: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-account-settings",
        "defaultMessage": "Go to account settings"
    },
    viewAllPlans: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-plans",
        "defaultMessage": "View all plans"
    },
    goToUserManagement: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-user-management",
        "defaultMessage": "Go to user management"
    },
    goToBilling: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-billing",
        "defaultMessage": "Go to billing"
    },
    goToIssuesIssueTermRefresh: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-issues-issue-term-refresh",
        "defaultMessage": "Go to work items"
    }
});

});



parcelRegister("ad6ff", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1e99e569448179a2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1e99e569448179a2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    defaultPlaceholder: {
        "id": "command-palette-integration.default-placeholder",
        "defaultMessage": "Search actions, settings, or type \"/\" to search work"
    },
    noResultsFound: {
        "id": "command-palette-integration.no-results-found",
        "defaultMessage": "No commands match your search."
    },
    onErrorFallback: {
        "id": "command-palette-integration.on-error-fallback",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    },
    recommendedSection: {
        "id": "command-palette-integration.recommended-section",
        "defaultMessage": "Recommended"
    },
    defaultSearchInputAriaLabel: {
        "id": "command-palette-integration.default-search-input-aria-label",
        "defaultMessage": "Search actions, settings, or type forward slash to search work"
    }
});

});

parcelRegister("79Tnk", function(module, exports) {

$parcel$export(module.exports, "RegisterDynamicCommands", () => $dbf14dd9a47bf5f0$export$54040e80edbe5eaf);

var $5uXOq = parcelRequire("5uXOq");

var $3kC6W = parcelRequire("3kC6W");

var $bWyrc = parcelRequire("bWyrc");

var $jM38v = parcelRequire("jM38v");
const $dbf14dd9a47bf5f0$export$54040e80edbe5eaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWyrc.InitialiseAdminNavCommands), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3kC6W.QuickSearchCommands), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jM38v.ThemeModeCommands), null));

});
parcelRegister("3kC6W", function(module, exports) {

$parcel$export(module.exports, "QuickSearchCommands", () => $aaacf6dc51c0b9d5$export$6e94ce71acbaa493);

var $5uXOq = parcelRequire("5uXOq");

var $1Kt4o = parcelRequire("1Kt4o");

var $fVMIs = parcelRequire("fVMIs");

var $18wuq = parcelRequire("18wuq");

var $b5pc0 = parcelRequire("b5pc0");
const $aaacf6dc51c0b9d5$var$useQuickSearchCommands = ()=>{
    const subscribe = (0, $fVMIs.useSubscribeCommands)();
    const { quickSearchCommand: quickSearchCommand } = (0, $b5pc0.useQuickSearchCommand)({
        keepSearch: false
    });
    (0, $5uXOq.useEffect)(()=>subscribe((0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).QUICK_SEARCH, [
            quickSearchCommand
        ]), [
        quickSearchCommand,
        subscribe
    ]);
    return null;
};
const $aaacf6dc51c0b9d5$var$QuickSearchCommandsInner = ()=>{
    $aaacf6dc51c0b9d5$var$useQuickSearchCommands();
    return null;
};
const $aaacf6dc51c0b9d5$export$6e94ce71acbaa493 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $18wuq.QuickSearchWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aaacf6dc51c0b9d5$var$QuickSearchCommandsInner, null));

});
parcelRegister("fVMIs", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommands", () => $05800ad334e2646e$export$c13b008422be19c7);

var $fIZf0 = parcelRequire("fIZf0");
const $05800ad334e2646e$export$c13b008422be19c7 = (0, $fIZf0.useSubscribeCommandsWithRegistry);

});


parcelRegister("bWyrc", function(module, exports) {

$parcel$export(module.exports, "InitialiseAdminNavCommands", () => $a4eff5f6fd6b7353$export$397d6a5dfe0b6bae);

var $5uXOq = parcelRequire("5uXOq");

var $ioK7w = parcelRequire("ioK7w");

var $d8lE2 = parcelRequire("d8lE2");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");
const $a4eff5f6fd6b7353$var$entryPointParams = {};
const $a4eff5f6fd6b7353$export$397d6a5dfe0b6bae = ()=>{
    const [initialised, setInitialised] = (0, $5uXOq.useState)(false);
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $ioK7w.compalAdminNavigationEntrypoint), $a4eff5f6fd6b7353$var$entryPointParams);
    const [{ isOpen: isOpen }] = (0, $d8lE2.useCommandPaletteIsOpen)();
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (!initialised) return;
        if (isOpen) entryPointActions.load();
        else entryPointActions.unload();
    }, [
        isOpen,
        entryPointActions,
        initialised
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!initialised && isOpen) setInitialised(true);
    }, [
        isOpen,
        initialised
    ]);
    const props = (0, $5uXOq.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "commandPaletteAsyncAdminNavigation",
        packageName: "jiraCommandPaletteIntegration",
        teamName: "deliveroo",
        fallback: null,
        errorFallback: "flag",
        runtimeProps: props
    });
};

});
parcelRegister("ioK7w", function(module, exports) {

$parcel$export(module.exports, "compalAdminNavigationEntrypoint", () => $9df289896dcd40f5$export$ec97befbb495acbe);
/* istanbul ignore file */ 
var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $9df289896dcd40f5$export$ec97befbb495acbe = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aksRD")).then((module)=>module.AdminNavCommands), {
        moduleId: "1ee8a073",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aksRD", function(module, exports) {

let $7852296e952949c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7852296e952949c6$var$load("76n7a"),
    $7852296e952949c6$var$load("l253H"),
    $7852296e952949c6$var$load("dY9ie")
]).then(()=>parcelRequire('kki7C'));

});



parcelRegister("jM38v", function(module, exports) {

$parcel$export(module.exports, "ThemeModeCommands", () => $4013ec61deab79f6$export$cecc9cf59bb74e7d);

var $5uXOq = parcelRequire("5uXOq");

var $k2tiP = parcelRequire("k2tiP");

var $5p1kJ = parcelRequire("5p1kJ");

var $eG9rp = parcelRequire("eG9rp");

var $1Kt4o = parcelRequire("1Kt4o");

var $5zCdk = parcelRequire("5zCdk");

var $jh7L9 = parcelRequire("jh7L9");

var $b9op4 = parcelRequire("b9op4");

var $8XWT9 = parcelRequire("8XWT9");

var $gbWPi = parcelRequire("gbWPi");

var $koVbs = parcelRequire("koVbs");

var $2Ql51 = parcelRequire("2Ql51");

var $QbdOh = parcelRequire("QbdOh");
const $4013ec61deab79f6$export$17b41f710dd67667 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { theme: currentTheme = 'light', setTheme: setTheme } = (0, $2Ql51.useThemePreference)();
    const { triggerCustomNavBarColorsFlag: triggerCustomNavBarColorsFlag } = (0, $gbWPi.default)();
    const setThemeWithCustomNavBarFlag = (0, $5uXOq.useCallback)(async (newTheme)=>{
        await setTheme(newTheme);
        triggerCustomNavBarColorsFlag(newTheme);
    }, [
        setTheme,
        triggerCustomNavBarColorsFlag
    ]);
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const createThemeCommand = (0, $5uXOq.useCallback)((theme, message, priority)=>({
            id: `command-palette-integration-change-theme-mode-${theme}`,
            name: formatMessage(message),
            keywords: theme === 'auto' ? getKeywords('matchSystemThemeSynonyms') : getKeywords('switchDarkThemeSynonyms'),
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>setThemeWithCustomNavBarFlag(theme)
            },
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
                        spacing: "spacious",
                        label: formatMessage(message)
                    })
            },
            section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).personalSettings,
            priority: priority,
            analytics: {
                action: 'toggleTheme'
            }
        }), [
        formatMessage,
        getKeywords,
        setThemeWithCustomNavBarFlag
    ]);
    const themeModeCommands = (0, $5uXOq.useMemo)(()=>{
        const availableThemesMode = {
            dark: createThemeCommand('dark', (0, $QbdOh.messages).commandDarkTheme, (0, $5p1kJ.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToDarkTheme),
            light: createThemeCommand('light', (0, $QbdOh.messages).commandLightTheme, (0, $5p1kJ.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToLightTheme),
            auto: createThemeCommand('auto', (0, $QbdOh.messages).commandAutoTheme, (0, $5p1kJ.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToSystemTheme)
        };
        const listOfCommands = [];
        Object.entries(availableThemesMode).forEach(([key, command])=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (key !== currentTheme && (0, $b9op4.ThemeOptions).includes(key)) listOfCommands.push(command);
        });
        return listOfCommands;
    }, [
        createThemeCommand,
        currentTheme
    ]);
    return themeModeCommands;
};
const $4013ec61deab79f6$export$cecc9cf59bb74e7d = ()=>{
    const [{ flagIsDismissed: flagIsDismissed }] = (0, $8XWT9.useCustomNavBarColorWarnings)();
    const command = $4013ec61deab79f6$export$17b41f710dd67667();
    const commandIds = command.map(({ id: id })=>id).toString();
    (0, $5zCdk.useRegisterCommands)((0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).THEME_MODE, command, [
        commandIds,
        flagIsDismissed
    ]);
    return null;
};

});
parcelRegister("b9op4", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $a1d11c8212b90b3e$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $a1d11c8212b90b3e$export$2faeed762aac6741);
// This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $a1d11c8212b90b3e$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';

});

parcelRegister("8XWT9", function(module, exports) {

$parcel$export(module.exports, "useCustomNavBarColorWarnings", () => $28ca8e14b9652104$export$c3d02c4eeb80172a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $hrJZF = parcelRequire("hrJZF");
const $28ca8e14b9652104$var$initialState = {
    isLoading: true,
    isLoadingWithRelay: false
};
const $28ca8e14b9652104$var$CustomNavBarColorsFlagDismissalStore = (0, $iXqE5.createStore)({
    initialState: $28ca8e14b9652104$var$initialState,
    actions: $hrJZF.actions,
    name: 'custom-nav-bar-colors-flag-dismissal'
});
const $28ca8e14b9652104$export$c3d02c4eeb80172a = (0, $3sQ5x.createHook)($28ca8e14b9652104$var$CustomNavBarColorsFlagDismissalStore);

});
parcelRegister("hrJZF", function(module, exports) {

$parcel$export(module.exports, "actions", () => $77586aec2cac1312$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $aIx7d = parcelRequire("aIx7d");
const $77586aec2cac1312$export$e324594224ef24da = {
    initialFetch: ()=>async ({ setState: setState, getState: getState })=>{
            const { isLoading: isLoading } = getState();
            if (!isLoading) return;
            setState({
                isLoading: false
            });
            const [flagDismissedRes, sectionMessageDismissedRes] = await Promise.allSettled([
                (0, $aIx7d.getCustomNavBarFlagDismissed)(),
                (0, $aIx7d.getCustomNavBarMessageDismissed)()
            ]);
            setState({
                flagIsDismissed: flagDismissedRes.status === 'fulfilled' ? flagDismissedRes.value || false : false,
                sectionMessageIsDismissed: sectionMessageDismissedRes.status === 'fulfilled' ? sectionMessageDismissedRes.value || false : false
            });
        },
    setIsLoadingWithRelay: ()=>({ setState: setState })=>{
            setState({
                isLoadingWithRelay: true,
                isLoading: false
            });
        },
    setFlagIsDismissed: (data = true, setRemote = true)=>({ setState: setState })=>{
            setState({
                flagIsDismissed: data
            });
            if (setRemote) (0, $aIx7d.setCustomNavBarFlagDismissed)(data);
        },
    setMessageIsDismissed: (data = true, setRemote = true)=>({ setState: setState })=>{
            setState({
                sectionMessageIsDismissed: data
            });
            if (setRemote) (0, $aIx7d.setCustomNavBarMessageDismissed)(data);
        }
};

});
parcelRegister("aIx7d", function(module, exports) {

$parcel$export(module.exports, "setCustomNavBarFlagDismissed", () => $8c6bdc5d8e0ccf04$export$96c3ac24c205921e);
$parcel$export(module.exports, "getCustomNavBarFlagDismissed", () => $8c6bdc5d8e0ccf04$export$4875b5188973cc41);
$parcel$export(module.exports, "getCustomNavBarMessageDismissed", () => $8c6bdc5d8e0ccf04$export$234ec7e66f5f0d80);
$parcel$export(module.exports, "setCustomNavBarMessageDismissed", () => $8c6bdc5d8e0ccf04$export$81fcff1db07fc096);

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $dDTxW = parcelRequire("dDTxW");
const $8c6bdc5d8e0ccf04$export$96c3ac24c205921e = async (value)=>{
    try {
        await (0, $aHuqL.userPreferenceAPI).set((0, $dDTxW.CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'setCustomNavBarFlagDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $8c6bdc5d8e0ccf04$export$4875b5188973cc41 = async ()=>{
    try {
        return await (0, $aHuqL.userPreferenceAPI).get((0, $dDTxW.CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode !== 404) (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'getCustomNavBarFlagDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};
const $8c6bdc5d8e0ccf04$export$234ec7e66f5f0d80 = async ()=>{
    try {
        return await (0, $aHuqL.userPreferenceAPI).get((0, $dDTxW.CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode !== 404) (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'getCustomNavBarMessageDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};
const $8c6bdc5d8e0ccf04$export$81fcff1db07fc096 = async (value)=>{
    try {
        await (0, $aHuqL.userPreferenceAPI).set((0, $dDTxW.CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'setCustomTopNavDarkModeDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("dDTxW", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY", () => $c0e20f2a55cada89$export$e322337c75e7fd2e);
$parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY", () => $c0e20f2a55cada89$export$d37f7f5db461e560);
$parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_FLAG_ID", () => $c0e20f2a55cada89$export$385ef2d36e85217);
$parcel$export(module.exports, "HELP_ARTICLE_ID", () => $c0e20f2a55cada89$export$1da9e2242c8f1be7);

var $7HGHK = parcelRequire("7HGHK");
const $c0e20f2a55cada89$export$e322337c75e7fd2e = 'jira.user.theme.custom-nav-bar-flag.dismissed';
const $c0e20f2a55cada89$export$d37f7f5db461e560 = 'jira.user.theme.custom-nav-bar-section-message.dismissed';
const $c0e20f2a55cada89$export$385ef2d36e85217 = (0, $7HGHK.toFlagId)('onThemeChangeCustomColorsFlag');
const $c0e20f2a55cada89$export$1da9e2242c8f1be7 = '1QC8AUgw7MAmoVtoYXQDxM';

});




parcelRegister("gbWPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd9ca6946fb47c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9MAC1 = parcelRequire("9MAC1");

var $pa9q9 = parcelRequire("pa9q9");

var $4R6GH = parcelRequire("4R6GH");

var $dDTxW = parcelRequire("dDTxW");

var $8XWT9 = parcelRequire("8XWT9");

var $aPd0G = parcelRequire("aPd0G");
/**
 * Manages the logic for showing a warning about custom navigation bar colors.
 * Determines whether the warning should be displayed based on feature flags, theme settings,
 * and whether the warning has been previously dismissed. Aimed at ensuring users are aware
 * of potential issues with custom color schemes in the navigation bar.
 */ const $8bd9ca6946fb47c1$var$useCustomNavBarColorsFlag = ()=>{
    const { hasFlag: hasFlag, showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [{ navigationTheme: navigationTheme }] = (0, $9MAC1.useTheme)();
    const [{ flagIsDismissed: flagIsDismissed, sectionMessageIsDismissed: sectionMessageIsDismissed, isLoading: isLoading, isLoadingWithRelay: isLoadingWithRelay }, { setFlagIsDismissed: setFlagIsDismissed, initialFetch: initialFetch }] = (0, $8XWT9.useCustomNavBarColorWarnings)();
    (0, $5uXOq.useEffect)(()=>{
        if (isLoadingWithRelay && (0, $4R6GH.fg)('custom-nav-theme-preferences-to-mainissueagg')) return;
        initialFetch();
    }, [
        initialFetch,
        isLoadingWithRelay
    ]);
    const handleDismiss = (0, $5uXOq.useCallback)(()=>{
        dismissFlag((0, $dDTxW.CUSTOM_NAV_BAR_COLORS_FLAG_ID));
        setFlagIsDismissed();
    }, [
        dismissFlag,
        setFlagIsDismissed
    ]);
    const shouldShowFlag = (0, $5uXOq.useCallback)((theme)=>!isLoading && !hasFlag?.((0, $dDTxW.CUSTOM_NAV_BAR_COLORS_FLAG_ID)) && (theme === 'dark' || theme === 'auto') && navigationTheme.usesCustomColours && flagIsDismissed === false && sectionMessageIsDismissed === false, [
        hasFlag,
        navigationTheme.usesCustomColours,
        isLoading,
        flagIsDismissed,
        sectionMessageIsDismissed
    ]);
    const triggerCustomNavBarColorsFlag = (0, $5uXOq.useCallback)((newTheme)=>{
        if (shouldShowFlag(newTheme)) showFlag({
            id: (0, $dDTxW.CUSTOM_NAV_BAR_COLORS_FLAG_ID),
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPd0G.default), {
                    ...props,
                    messageId: "custom-nav-bar-colors-flag.custom-nav-bar-colors-warning-flag",
                    messageType: "transactional",
                    onDismiss: handleDismiss,
                    analyticsAttributes: {
                        backgroundColor: navigationTheme.backgroundColor,
                        highlightColor: navigationTheme.highlightColor
                    }
                })
        });
    }, [
        shouldShowFlag,
        handleDismiss,
        showFlag,
        navigationTheme
    ]);
    return {
        triggerCustomNavBarColorsFlag: triggerCustomNavBarColorsFlag
    };
};
var $8bd9ca6946fb47c1$export$2e2bcd8739ae039 = $8bd9ca6946fb47c1$var$useCustomNavBarColorsFlag;

});
parcelRegister("9MAC1", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $a1f770a9d49220c1$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $a1f770a9d49220c1$export$11eb671888ed6e7d);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $LtWMd = parcelRequire("LtWMd");
const $a1f770a9d49220c1$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $a1f770a9d49220c1$var$Store = (0, $iXqE5.createStore)({
    name: 'theme',
    initialState: $a1f770a9d49220c1$var$initialState,
    actions: $LtWMd
});
const $a1f770a9d49220c1$export$74e6aa5aeff5e82e = (0, $51nlc.createSubscriber)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$93d4e7f90805808f = (0, $3sQ5x.createHook)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$11eb671888ed6e7d = (0, $gg7kZ.createContainer)($a1f770a9d49220c1$var$Store, {
    onInit: $LtWMd.bootstrap
});

});
parcelRegister("LtWMd", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $9594f0aa641d3463$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $9594f0aa641d3463$export$722fbec263ad908a);

const $9594f0aa641d3463$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $829f609a65d26a98$exports).N0 || ajsHighlightColor !== (0, $829f609a65d26a98$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || "var(--ds-background-inverse-subtle, #00000029)",
            highlightColor: ajsHighlightColor || "var(--ds-text-brand, #0C66E4)"
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $9594f0aa641d3463$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("aPd0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1272b579c76deef$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1jWct = parcelRequire("1jWct");

var $3KRpp = parcelRequire("3KRpp");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $dDTxW = parcelRequire("dDTxW");

var $6aFdn = parcelRequire("6aFdn");
const $d1272b579c76deef$export$e5995f97d3b9e5eb = 'router-resources.theme-preference.custom-nav-bar-colors-flag';
const $d1272b579c76deef$var$CustomNavBarColorsFlag = ({ onDismiss: onDismiss, analyticsAttributes: analyticsAttributes, messageId: messageId, messageType: messageType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onOpenInProductHelpArticle = (0, $5Zxxp.useHelpPanelLink)();
    const onDismissFn = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'customTopNavUserFlagWarningDismissButton', analyticsAttributes);
        onDismiss();
    }, [
        onDismiss,
        analyticsAttributes
    ]);
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.InfoFlag), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
                spacing: "spacious",
                color: "var(--ds-icon-information, #1D7AFC)",
                label: ""
            }),
            testId: $d1272b579c76deef$export$e5995f97d3b9e5eb,
            id: (0, $dDTxW.CUSTOM_NAV_BAR_COLORS_FLAG_ID),
            title: formatMessage((0, $6aFdn.default).title),
            description: formatMessage((0, $6aFdn.default).description),
            onDismissed: onDismissFn,
            messageId: messageId ?? 'custom-nav-bar-colors-flag.ui.info-flag',
            messageType: messageType ?? 'transactional',
            actions: [
                {
                    content: formatMessage((0, $6aFdn.default).learnMoreAction),
                    onClick: (_, analyticsEvent)=>{
                        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'customTopNavUserFlagWarningMoreButton', analyticsAttributes);
                        onOpenInProductHelpArticle((0, $dDTxW.HELP_ARTICLE_ID));
                    }
                },
                {
                    content: formatMessage((0, $6aFdn.default).dismissAction),
                    onClick: onDismissFn
                }
            ]
        }), [
        formatMessage,
        onDismissFn,
        onOpenInProductHelpArticle,
        analyticsAttributes,
        messageId,
        messageType
    ]);
};
var $d1272b579c76deef$export$2e2bcd8739ae039 = $d1272b579c76deef$var$CustomNavBarColorsFlag;

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8XC7W")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $kxZPA.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("8XC7W")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $kxZPA.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("a8Hbj")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $kxZPA.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("a8Hbj")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("iNWLk", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $6377b132f88aa82c$export$8b4a0fffcddd96f4);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");
const $6377b132f88aa82c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, children));

});

parcelRegister("8XC7W", function(module, exports) {

let $686168aa9b882863$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $686168aa9b882863$var$load("ffQaD"),
    $686168aa9b882863$var$load("kvRbA"),
    $686168aa9b882863$var$load("76n7a"),
    $686168aa9b882863$var$load("l253H"),
    $686168aa9b882863$var$load("eH8ke")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("a8Hbj", function(module, exports) {

let $761c25b21fad9e16$var$load = (parcelRequire("28QjX"))(4);
module.exports = $761c25b21fad9e16$var$load("1PJIF").then(()=>parcelRequire('5pz6a'));

});


parcelRegister("5Zxxp", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $b0d1b3c2fea05784$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $b0d1b3c2fea05784$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $hsmeR = parcelRequire("hsmeR");

var $6s1PB = parcelRequire("6s1PB");
const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $b0d1b3c2fea05784$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $4R6GH.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$export$5a09250ffddd7fd1;
const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
const $b0d1b3c2fea05784$var$buttonWrapperSubtleStyles = null;

});
parcelRegister("6BNJk", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $20386d7da4313ff0$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $20386d7da4313ff0$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $20386d7da4313ff0$export$23aa6670f346c214);

var $gwIPs = parcelRequire("gwIPs");
const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
const $20386d7da4313ff0$export$23aa6670f346c214 = (0, $gwIPs.gridSize) * 46;

});

parcelRegister("kspz4", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $aee6103177ce0723$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $aee6103177ce0723$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $jgGDm = parcelRequire("jgGDm");
const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, $3sQ5x.createHook)((0, $jgGDm.default));
const $aee6103177ce0723$export$c61f56f4797e22db = (0, $3sQ5x.createHook)((0, $jgGDm.default), {
    selector: null
});
const $aee6103177ce0723$export$513717a84f55db1a = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelSubscriber'
});
const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("jgGDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $465615692863cce9$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $iXqE5 = parcelRequire("iXqE5");

var $958ua = parcelRequire("958ua");
let $465615692863cce9$var$iphStorage;
const $465615692863cce9$var$createStorage = ()=>{
    if ($465615692863cce9$var$iphStorage) return $465615692863cce9$var$iphStorage;
    $465615692863cce9$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
    return $465615692863cce9$var$iphStorage;
};
const $465615692863cce9$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $465615692863cce9$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $465615692863cce9$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'help-panel',
    initialState: $465615692863cce9$var$initialState,
    actions: $958ua
});

});
parcelRegister("958ua", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $177ac56c5a5bf49e$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $177ac56c5a5bf49e$export$cdabe01d01a8da1e);

var $eNf8a = parcelRequire("eNf8a");
const $177ac56c5a5bf49e$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $177ac56c5a5bf49e$var$iphStorage.set('history', []);
    };
const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



parcelRegister("hsmeR", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $39a48ee662f10943$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $39a48ee662f10943$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $39a48ee662f10943$export$ebe5e907fb0bb63a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $byk51 = parcelRequire("byk51");

var $5e5zm = parcelRequire("5e5zm");
const $39a48ee662f10943$var$useActiveRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $byk51.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
    return rightSidebar;
};
const $39a48ee662f10943$var$useRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
    return rightSidebarState;
};
const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $5e5zm.useLayoutStoreActions)();
    return (0, $5uXOq.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});





parcelRegister("6aFdn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a352393f0769184$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7a352393f0769184$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "custom-nav-bar-colors-flag.title",
        "defaultMessage": "Your top navigation menu has custom colors"
    },
    description: {
        "id": "custom-nav-bar-colors-flag.description",
        "defaultMessage": "If the color of your navigation menu doesn't look right in this theme, notify your Jira admin."
    },
    learnMoreAction: {
        "id": "custom-nav-bar-colors-flag.learn-more-action",
        "defaultMessage": "Learn more"
    },
    dismissAction: {
        "id": "custom-nav-bar-colors-flag.dismiss-action",
        "defaultMessage": "Dismiss"
    }
});

});



parcelRegister("2Ql51", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $14feb59df5995657$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $14feb59df5995657$export$3416635c8aeb5bab);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $Y0b1l = parcelRequire("Y0b1l");

const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("dK4Sf"));
const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, $2M1hQ.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $14feb59df5995657$var$getDataLoader,
    maxAge: 300000
});
const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $2YP9W.useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
            actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $Y0b1l.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("Y0b1l", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $fb319b2ef1da4e47$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $fb319b2ef1da4e47$export$2f7a12048d96237);

var $b9op4 = parcelRequire("b9op4");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $aHuqL.userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $aHuqL.userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $b9op4.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $b9op4.ThemeOptions).includes(theme) ? theme : undefined;
};

});

parcelRegister("dK4Sf", function(module, exports) {

let $a0135a222dc45898$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a0135a222dc45898$var$load("ffQaD"),
    $a0135a222dc45898$var$load("kvRbA"),
    $a0135a222dc45898$var$load("8iXY3")
]).then(()=>parcelRequire('jyeNt'));

});


parcelRegister("QbdOh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fcd42d35db30fa36$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fcd42d35db30fa36$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    commandLightTheme: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-light-theme",
        "defaultMessage": "Switch to light theme"
    },
    commandDarkTheme: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-dark-theme",
        "defaultMessage": "Switch to dark theme"
    },
    commandAutoTheme: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-auto-theme",
        "defaultMessage": "Match system theme"
    },
    themeKeywords: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-no-translate",
        "defaultMessage": "switch to dark theme switch to light theme dark mode light mode change appearance change colors night mode day mode theme dark switch theme light switch theme switch switch theme appearance change colors change"
    },
    themeKeywordsMisspelt: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-misspelt-no-translate",
        "defaultMessage": "lite theme darkmode lightmode nightmode daymode change colours change"
    },
    autoThemeKeywords: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-no-translate",
        "defaultMessage": "match system theme sync to system settings dark mode light mode change appearance change colors night mode day mode system theme match match theme system sync theme to system system theme sync theme dark switch theme light switch theme switch appearance change colors change"
    },
    autoThemeKeywordsMisspelt: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-misspelt-no-translate",
        "defaultMessage": "match sistem theme sinc system theme matxh system theme match sytem theme darkmode lightmode nightmode daymode change colours change"
    }
});

});





//# sourceMappingURL=async-command-palette-integration.d4d5a19a.js.map
